(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/core-libs/webtelemetry/assets/javascripts/webtelemetry.js') >= 0) return;  svs.modules.push('/components/core-libs/webtelemetry/assets/javascripts/webtelemetry.js'); "use strict";

(function webpackUniversalModuleDefinition(root, factory) {
  if (typeof exports === "object" && typeof module === "object") module.exports = factory();else if (typeof define === "function" && define.amd) define([], factory);else if (typeof exports === "object") exports["webtelemetry"] = factory();else root["webtelemetry"] = factory();
})(window, function () {
  return (() => {
    "use strict";

    var __webpack_modules__ = {
      774: (__unused_webpack_module, __webpack_exports__2, __webpack_require__2) => {
        __webpack_require__2.d(__webpack_exports__2, {
          "G": () => DiagAPI
        });
        var global_utils = __webpack_require__2(819);
        ;
        var DiagComponentLogger = function () {
          function DiagComponentLogger2(props) {
            this._namespace = props.namespace || "DiagComponentLogger";
          }
          DiagComponentLogger2.prototype.debug = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
              args[_i] = arguments[_i];
            }
            return logProxy("debug", this._namespace, args);
          };
          DiagComponentLogger2.prototype.error = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
              args[_i] = arguments[_i];
            }
            return logProxy("error", this._namespace, args);
          };
          DiagComponentLogger2.prototype.info = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
              args[_i] = arguments[_i];
            }
            return logProxy("info", this._namespace, args);
          };
          DiagComponentLogger2.prototype.warn = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
              args[_i] = arguments[_i];
            }
            return logProxy("warn", this._namespace, args);
          };
          DiagComponentLogger2.prototype.verbose = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
              args[_i] = arguments[_i];
            }
            return logProxy("verbose", this._namespace, args);
          };
          return DiagComponentLogger2;
        }();
        function logProxy(funcName, namespace, args) {
          var logger = (0, global_utils.Rd)("diag");
          if (!logger) {
            return;
          }
          args.unshift(namespace);
          return logger[funcName].apply(logger, args);
        }
        var types = __webpack_require__2(740);
        ;
        function createLogLevelDiagLogger(maxLevel, logger) {
          if (maxLevel < types.n.NONE) {
            maxLevel = types.n.NONE;
          } else if (maxLevel > types.n.ALL) {
            maxLevel = types.n.ALL;
          }
          logger = logger || {};
          function _filterFunc(funcName, theLevel) {
            var theFunc = logger[funcName];
            if (typeof theFunc === "function" && maxLevel >= theLevel) {
              return theFunc.bind(logger);
            }
            return function () {};
          }
          return {
            error: _filterFunc("error", types.n.ERROR),
            warn: _filterFunc("warn", types.n.WARN),
            info: _filterFunc("info", types.n.INFO),
            debug: _filterFunc("debug", types.n.DEBUG),
            verbose: _filterFunc("verbose", types.n.VERBOSE)
          };
        }
        ;
        var API_NAME = "diag";
        var DiagAPI = function () {
          function DiagAPI2() {
            function _logProxy(funcName) {
              return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                  args[_i] = arguments[_i];
                }
                var logger = (0, global_utils.Rd)("diag");
                if (!logger) return;
                return logger[funcName].apply(logger, args);
              };
            }
            var self2 = this;
            self2.setLogger = function (logger, logLevel) {
              var _a, _b;
              if (logLevel === void 0) {
                logLevel = types.n.INFO;
              }
              if (logger === self2) {
                var err = new Error("Cannot use diag as the logger for itself. Please use a DiagLogger implementation like ConsoleDiagLogger or a custom implementation");
                self2.error((_a = err.stack) !== null && _a !== void 0 ? _a : err.message);
                return false;
              }
              var oldLogger = (0, global_utils.Rd)("diag");
              var newLogger = createLogLevelDiagLogger(logLevel, logger);
              if (oldLogger) {
                var stack = (_b = new Error().stack) !== null && _b !== void 0 ? _b : "<failed to generate stacktrace>";
                oldLogger.warn("Current logger will be overwritten from " + stack);
                newLogger.warn("Current logger will overwrite one already registered from " + stack);
              }
              return (0, global_utils.TG)("diag", newLogger, self2, true);
            };
            self2.disable = function () {
              (0, global_utils.J_)(API_NAME, self2);
            };
            self2.createComponentLogger = function (options) {
              return new DiagComponentLogger(options);
            };
            self2.verbose = _logProxy("verbose");
            self2.debug = _logProxy("debug");
            self2.info = _logProxy("info");
            self2.warn = _logProxy("warn");
            self2.error = _logProxy("error");
          }
          DiagAPI2.instance = function () {
            if (!this._instance) {
              this._instance = new DiagAPI2();
            }
            return this._instance;
          };
          return DiagAPI2;
        }();
      },
      599: (__unused_webpack_module, __webpack_exports__2, __webpack_require__2) => {
        __webpack_require__2.d(__webpack_exports__2, {
          "u": () => baggageEntryMetadataFromString,
          "H": () => createBaggage
        });
        var diag = __webpack_require__2(774);
        ;
        var BaggageImpl = function () {
          function BaggageImpl2(entries) {
            this._entries = entries ? new Map(entries) : new Map();
          }
          BaggageImpl2.prototype.getEntry = function (key) {
            var entry = this._entries.get(key);
            if (!entry) {
              return void 0;
            }
            return Object.assign({}, entry);
          };
          BaggageImpl2.prototype.getAllEntries = function () {
            return Array.from(this._entries.entries()).map(function (_a) {
              var k = _a[0],
                v = _a[1];
              return [k, v];
            });
          };
          BaggageImpl2.prototype.setEntry = function (key, entry) {
            var newBaggage = new BaggageImpl2(this._entries);
            newBaggage._entries.set(key, entry);
            return newBaggage;
          };
          BaggageImpl2.prototype.removeEntry = function (key) {
            var newBaggage = new BaggageImpl2(this._entries);
            newBaggage._entries.delete(key);
            return newBaggage;
          };
          BaggageImpl2.prototype.removeEntries = function () {
            var keys = [];
            for (var _i = 0; _i < arguments.length; _i++) {
              keys[_i] = arguments[_i];
            }
            var newBaggage = new BaggageImpl2(this._entries);
            for (var _a = 0, keys_1 = keys; _a < keys_1.length; _a++) {
              var key = keys_1[_a];
              newBaggage._entries.delete(key);
            }
            return newBaggage;
          };
          BaggageImpl2.prototype.clear = function () {
            return new BaggageImpl2();
          };
          return BaggageImpl2;
        }();
        ;
        var baggageEntryMetadataSymbol = Symbol("BaggageEntryMetadata");
        ;
        var utils_diag = diag.G.instance();
        function createBaggage(entries) {
          if (entries === void 0) {
            entries = {};
          }
          return new BaggageImpl(new Map(Object.entries(entries)));
        }
        function baggageEntryMetadataFromString(str) {
          if (typeof str !== "string") {
            utils_diag.error("Cannot create baggage metadata from unknown type: " + typeof str);
            str = "";
          }
          return {
            __TYPE__: baggageEntryMetadataSymbol,
            toString: function () {
              return str;
            }
          };
        }
      },
      834: (__unused_webpack_module, __webpack_exports__2, __webpack_require__2) => {
        __webpack_require__2.d(__webpack_exports__2, {
          "Y": () => createContextKey,
          "I": () => ROOT_CONTEXT
        });
        function createContextKey(description) {
          return Symbol.for(description);
        }
        var BaseContext = function () {
          function BaseContext2(parentContext) {
            var self2 = this;
            self2._currentContext = parentContext ? new Map(parentContext) : new Map();
            self2.getValue = function (key) {
              return self2._currentContext.get(key);
            };
            self2.setValue = function (key, value) {
              var context = new BaseContext2(self2._currentContext);
              context._currentContext.set(key, value);
              return context;
            };
            self2.deleteValue = function (key) {
              var context = new BaseContext2(self2._currentContext);
              context._currentContext.delete(key);
              return context;
            };
          }
          return BaseContext2;
        }();
        var ROOT_CONTEXT = new BaseContext();
      },
      740: (__unused_webpack_module, __webpack_exports__2, __webpack_require__2) => {
        __webpack_require__2.d(__webpack_exports__2, {
          "n": () => DiagLogLevel
        });
        var DiagLogLevel;
        (function (DiagLogLevel2) {
          DiagLogLevel2[DiagLogLevel2["NONE"] = 0] = "NONE";
          DiagLogLevel2[DiagLogLevel2["ERROR"] = 30] = "ERROR";
          DiagLogLevel2[DiagLogLevel2["WARN"] = 50] = "WARN";
          DiagLogLevel2[DiagLogLevel2["INFO"] = 60] = "INFO";
          DiagLogLevel2[DiagLogLevel2["DEBUG"] = 70] = "DEBUG";
          DiagLogLevel2[DiagLogLevel2["VERBOSE"] = 80] = "VERBOSE";
          DiagLogLevel2[DiagLogLevel2["ALL"] = 9999] = "ALL";
        })(DiagLogLevel || (DiagLogLevel = {}));
      },
      620: (__unused_webpack_module, __webpack_exports__2, __webpack_require__2) => {
        __webpack_require__2.r(__webpack_exports__2);
        __webpack_require__2.d(__webpack_exports__2, {
          "DiagConsoleLogger": () => DiagConsoleLogger,
          "DiagLogLevel": () => types.n,
          "INVALID_SPANID": () => invalid_span_constants.fQ,
          "INVALID_SPAN_CONTEXT": () => invalid_span_constants.Rr,
          "INVALID_TRACEID": () => invalid_span_constants.AE,
          "ProxyTracer": () => ProxyTracer,
          "ProxyTracerProvider": () => ProxyTracerProvider,
          "ROOT_CONTEXT": () => context.I,
          "SamplingDecision": () => SamplingResult.U,
          "SpanKind": () => span_kind.M,
          "SpanStatusCode": () => trace_status.Q,
          "TraceFlags": () => trace_flags.r,
          "baggageEntryMetadataFromString": () => utils.u,
          "context": () => esm_context,
          "createContextKey": () => context.Y,
          "createTraceState": () => createTraceState,
          "default": () => esm,
          "defaultTextMapGetter": () => defaultTextMapGetter,
          "defaultTextMapSetter": () => defaultTextMapSetter,
          "diag": () => esm_diag,
          "isSpanContextValid": () => spancontext_utils.BM,
          "isValidSpanId": () => spancontext_utils.Lc,
          "isValidTraceId": () => spancontext_utils.jN,
          "propagation": () => propagation,
          "trace": () => trace
        });
        var utils = __webpack_require__2(599);
        ;
        var consoleMap = [{
          n: "error",
          c: "error"
        }, {
          n: "warn",
          c: "warn"
        }, {
          n: "info",
          c: "info"
        }, {
          n: "debug",
          c: "debug"
        }, {
          n: "verbose",
          c: "trace"
        }];
        var DiagConsoleLogger = function () {
          function DiagConsoleLogger2() {
            function _consoleFunc(funcName) {
              return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                  args[_i] = arguments[_i];
                }
                if (console) {
                  var theFunc = console[funcName];
                  if (typeof theFunc !== "function") {
                    theFunc = console.log;
                  }
                  if (typeof theFunc === "function") {
                    return theFunc.apply(console, args);
                  }
                }
              };
            }
            for (var i = 0; i < consoleMap.length; i++) {
              this[consoleMap[i].n] = _consoleFunc(consoleMap[i].c);
            }
          }
          return DiagConsoleLogger2;
        }();
        var types = __webpack_require__2(740);
        ;
        ;
        var defaultTextMapGetter = {
          get: function (carrier, key) {
            if (carrier == null) {
              return void 0;
            }
            return carrier[key];
          },
          keys: function (carrier) {
            if (carrier == null) {
              return [];
            }
            return Object.keys(carrier);
          }
        };
        var defaultTextMapSetter = {
          set: function (carrier, key, value) {
            if (carrier == null) {
              return;
            }
            carrier[key] = value;
          }
        };
        var context = __webpack_require__2(834);
        ;
        var __spreadArray = function (to, from) {
          for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) to[j] = from[i];
          return to;
        };
        var NoopContextManager = function () {
          function NoopContextManager2() {}
          NoopContextManager2.prototype.active = function () {
            return context.I;
          };
          NoopContextManager2.prototype.with = function (_context, fn, thisArg) {
            var args = [];
            for (var _i = 3; _i < arguments.length; _i++) {
              args[_i - 3] = arguments[_i];
            }
            return fn.call.apply(fn, __spreadArray([thisArg], args));
          };
          NoopContextManager2.prototype.bind = function (_context, target) {
            return target;
          };
          NoopContextManager2.prototype.enable = function () {
            return this;
          };
          NoopContextManager2.prototype.disable = function () {
            return this;
          };
          return NoopContextManager2;
        }();
        var global_utils = __webpack_require__2(819);
        var diag = __webpack_require__2(774);
        ;
        var context_spreadArray = function (to, from) {
          for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) to[j] = from[i];
          return to;
        };
        var API_NAME = "context";
        var NOOP_CONTEXT_MANAGER = new NoopContextManager();
        var ContextAPI = function () {
          function ContextAPI2() {}
          ContextAPI2.getInstance = function () {
            if (!this._instance) {
              this._instance = new ContextAPI2();
            }
            return this._instance;
          };
          ContextAPI2.prototype.setGlobalContextManager = function (contextManager) {
            return (0, global_utils.TG)(API_NAME, contextManager, diag.G.instance());
          };
          ContextAPI2.prototype.active = function () {
            return this._getContextManager().active();
          };
          ContextAPI2.prototype.with = function (context2, fn, thisArg) {
            var _a;
            var args = [];
            for (var _i = 3; _i < arguments.length; _i++) {
              args[_i - 3] = arguments[_i];
            }
            return (_a = this._getContextManager()).with.apply(_a, context_spreadArray([context2, fn, thisArg], args));
          };
          ContextAPI2.prototype.bind = function (context2, target) {
            return this._getContextManager().bind(context2, target);
          };
          ContextAPI2.prototype._getContextManager = function () {
            return (0, global_utils.Rd)(API_NAME) || NOOP_CONTEXT_MANAGER;
          };
          ContextAPI2.prototype.disable = function () {
            this._getContextManager().disable();
            (0, global_utils.J_)(API_NAME, diag.G.instance());
          };
          return ContextAPI2;
        }();
        var NonRecordingSpan = __webpack_require__2(817);
        ;
        var SPAN_KEY = (0, context.Y)("OpenTelemetry Context Key SPAN");
        function getSpan(context2) {
          return context2.getValue(SPAN_KEY) || void 0;
        }
        function getActiveSpan() {
          return getSpan(ContextAPI.getInstance().active());
        }
        function setSpan(context2, span) {
          return context2.setValue(SPAN_KEY, span);
        }
        function deleteSpan(context2) {
          return context2.deleteValue(SPAN_KEY);
        }
        function setSpanContext(context2, spanContext) {
          return setSpan(context2, new NonRecordingSpan.s(spanContext));
        }
        function getSpanContext(context2) {
          var _a;
          return (_a = getSpan(context2)) === null || _a === void 0 ? void 0 : _a.spanContext();
        }
        var spancontext_utils = __webpack_require__2(228);
        ;
        var NoopTracer_context = ContextAPI.getInstance();
        var NoopTracer = function () {
          function NoopTracer2() {}
          NoopTracer2.prototype.startSpan = function (name, options, context2) {
            var root = Boolean(options === null || options === void 0 ? void 0 : options.root);
            if (root) {
              return new NonRecordingSpan.s();
            }
            var parentFromContext = context2 && getSpanContext(context2);
            if (isSpanContext(parentFromContext) && (0, spancontext_utils.BM)(parentFromContext)) {
              return new NonRecordingSpan.s(parentFromContext);
            } else {
              return new NonRecordingSpan.s();
            }
          };
          NoopTracer2.prototype.startActiveSpan = function (name, arg2, arg3, arg4) {
            var opts;
            var ctx;
            var fn;
            if (arguments.length < 2) {
              return;
            } else if (arguments.length === 2) {
              fn = arg2;
            } else if (arguments.length === 3) {
              opts = arg2;
              fn = arg3;
            } else {
              opts = arg2;
              ctx = arg3;
              fn = arg4;
            }
            var parentContext = ctx !== null && ctx !== void 0 ? ctx : NoopTracer_context.active();
            var span = this.startSpan(name, opts, parentContext);
            var contextWithSpanSet = setSpan(parentContext, span);
            return NoopTracer_context.with(contextWithSpanSet, fn, void 0, span);
          };
          return NoopTracer2;
        }();
        function isSpanContext(spanContext) {
          return typeof spanContext === "object" && typeof spanContext["spanId"] === "string" && typeof spanContext["traceId"] === "string" && typeof spanContext["traceFlags"] === "number";
        }
        ;
        var NOOP_TRACER = new NoopTracer();
        var ProxyTracer = function () {
          function ProxyTracer2(_provider, name, version, options) {
            this._provider = _provider;
            this.name = name;
            this.version = version;
            this.options = options;
          }
          ProxyTracer2.prototype.startSpan = function (name, options, context2) {
            return this._getTracer().startSpan(name, options, context2);
          };
          ProxyTracer2.prototype.startActiveSpan = function (_name, _options, _context, _fn) {
            var tracer = this._getTracer();
            return Reflect.apply(tracer.startActiveSpan, tracer, arguments);
          };
          ProxyTracer2.prototype._getTracer = function () {
            if (this._delegate) {
              return this._delegate;
            }
            var tracer = this._provider.getDelegateTracer(this.name, this.version, this.options);
            if (!tracer) {
              return NOOP_TRACER;
            }
            this._delegate = tracer;
            return this._delegate;
          };
          return ProxyTracer2;
        }();
        ;
        var NoopTracerProvider = function () {
          function NoopTracerProvider2() {}
          NoopTracerProvider2.prototype.getTracer = function (_name, _version, _options) {
            return new NoopTracer();
          };
          return NoopTracerProvider2;
        }();
        ;
        var NOOP_TRACER_PROVIDER = new NoopTracerProvider();
        var ProxyTracerProvider = function () {
          function ProxyTracerProvider2() {}
          ProxyTracerProvider2.prototype.getTracer = function (name, version, options) {
            var _a;
            return (_a = this.getDelegateTracer(name, version, options)) !== null && _a !== void 0 ? _a : new ProxyTracer(this, name, version, options);
          };
          ProxyTracerProvider2.prototype.getDelegate = function () {
            var _a;
            return (_a = this._delegate) !== null && _a !== void 0 ? _a : NOOP_TRACER_PROVIDER;
          };
          ProxyTracerProvider2.prototype.setDelegate = function (delegate) {
            this._delegate = delegate;
          };
          ProxyTracerProvider2.prototype.getDelegateTracer = function (name, version, options) {
            var _a;
            return (_a = this._delegate) === null || _a === void 0 ? void 0 : _a.getTracer(name, version, options);
          };
          return ProxyTracerProvider2;
        }();
        var SamplingResult = __webpack_require__2(227);
        var span_kind = __webpack_require__2(87);
        var trace_status = __webpack_require__2(820);
        var trace_flags = __webpack_require__2(726);
        ;
        var VALID_KEY_CHAR_RANGE = "[_0-9a-z-*/]";
        var VALID_KEY = "[a-z]" + VALID_KEY_CHAR_RANGE + "{0,255}";
        var VALID_VENDOR_KEY = "[a-z0-9]" + VALID_KEY_CHAR_RANGE + "{0,240}@[a-z]" + VALID_KEY_CHAR_RANGE + "{0,13}";
        var VALID_KEY_REGEX = new RegExp("^(?:" + VALID_KEY + "|" + VALID_VENDOR_KEY + ")$");
        var VALID_VALUE_BASE_REGEX = /^[ -~]{0,255}[!-~]$/;
        var INVALID_VALUE_COMMA_EQUAL_REGEX = /,|=/;
        function validateKey(key) {
          return VALID_KEY_REGEX.test(key);
        }
        function validateValue(value) {
          return VALID_VALUE_BASE_REGEX.test(value) && !INVALID_VALUE_COMMA_EQUAL_REGEX.test(value);
        }
        ;
        var MAX_TRACE_STATE_ITEMS = 32;
        var MAX_TRACE_STATE_LEN = 512;
        var LIST_MEMBERS_SEPARATOR = ",";
        var LIST_MEMBER_KEY_VALUE_SPLITTER = "=";
        var TraceStateImpl = function () {
          function TraceStateImpl2(rawTraceState) {
            this._internalState = new Map();
            if (rawTraceState) this._parse(rawTraceState);
          }
          TraceStateImpl2.prototype.set = function (key, value) {
            var traceState = this._clone();
            if (traceState._internalState.has(key)) {
              traceState._internalState.delete(key);
            }
            traceState._internalState.set(key, value);
            return traceState;
          };
          TraceStateImpl2.prototype.unset = function (key) {
            var traceState = this._clone();
            traceState._internalState.delete(key);
            return traceState;
          };
          TraceStateImpl2.prototype.get = function (key) {
            return this._internalState.get(key);
          };
          TraceStateImpl2.prototype.serialize = function () {
            var _this = this;
            return this._keys().reduce(function (agg, key) {
              agg.push(key + LIST_MEMBER_KEY_VALUE_SPLITTER + _this.get(key));
              return agg;
            }, []).join(LIST_MEMBERS_SEPARATOR);
          };
          TraceStateImpl2.prototype._parse = function (rawTraceState) {
            if (rawTraceState.length > MAX_TRACE_STATE_LEN) return;
            this._internalState = rawTraceState.split(LIST_MEMBERS_SEPARATOR).reverse().reduce(function (agg, part) {
              var listMember = part.trim();
              var i = listMember.indexOf(LIST_MEMBER_KEY_VALUE_SPLITTER);
              if (i !== -1) {
                var key = listMember.slice(0, i);
                var value = listMember.slice(i + 1, part.length);
                if (validateKey(key) && validateValue(value)) {
                  agg.set(key, value);
                } else {}
              }
              return agg;
            }, new Map());
            if (this._internalState.size > MAX_TRACE_STATE_ITEMS) {
              this._internalState = new Map(Array.from(this._internalState.entries()).reverse().slice(0, MAX_TRACE_STATE_ITEMS));
            }
          };
          TraceStateImpl2.prototype._keys = function () {
            return Array.from(this._internalState.keys()).reverse();
          };
          TraceStateImpl2.prototype._clone = function () {
            var traceState = new TraceStateImpl2();
            traceState._internalState = new Map(this._internalState);
            return traceState;
          };
          return TraceStateImpl2;
        }();
        ;
        function createTraceState(rawTraceState) {
          return new TraceStateImpl(rawTraceState);
        }
        var invalid_span_constants = __webpack_require__2(7);
        ;
        var trace_API_NAME = "trace";
        var TraceAPI = function () {
          function TraceAPI2() {
            this._proxyTracerProvider = new ProxyTracerProvider();
            this.wrapSpanContext = spancontext_utils.kw;
            this.isSpanContextValid = spancontext_utils.BM;
            this.deleteSpan = deleteSpan;
            this.getSpan = getSpan;
            this.getActiveSpan = getActiveSpan;
            this.getSpanContext = getSpanContext;
            this.setSpan = setSpan;
            this.setSpanContext = setSpanContext;
          }
          TraceAPI2.getInstance = function () {
            if (!this._instance) {
              this._instance = new TraceAPI2();
            }
            return this._instance;
          };
          TraceAPI2.prototype.setGlobalTracerProvider = function (provider) {
            var success = (0, global_utils.TG)(trace_API_NAME, this._proxyTracerProvider, diag.G.instance());
            if (success) {
              this._proxyTracerProvider.setDelegate(provider);
            }
            return success;
          };
          TraceAPI2.prototype.getTracerProvider = function () {
            return (0, global_utils.Rd)(trace_API_NAME) || this._proxyTracerProvider;
          };
          TraceAPI2.prototype.getTracer = function (name, version) {
            return this.getTracerProvider().getTracer(name, version);
          };
          TraceAPI2.prototype.disable = function () {
            (0, global_utils.J_)(trace_API_NAME, diag.G.instance());
            this._proxyTracerProvider = new ProxyTracerProvider();
          };
          return TraceAPI2;
        }();
        ;
        var NoopTextMapPropagator = function () {
          function NoopTextMapPropagator2() {}
          NoopTextMapPropagator2.prototype.inject = function (_context, _carrier) {};
          NoopTextMapPropagator2.prototype.extract = function (context2, _carrier) {
            return context2;
          };
          NoopTextMapPropagator2.prototype.fields = function () {
            return [];
          };
          return NoopTextMapPropagator2;
        }();
        ;
        var BAGGAGE_KEY = (0, context.Y)("OpenTelemetry Baggage Key");
        function getBaggage(context2) {
          return context2.getValue(BAGGAGE_KEY) || void 0;
        }
        function setBaggage(context2, baggage) {
          return context2.setValue(BAGGAGE_KEY, baggage);
        }
        function deleteBaggage(context2) {
          return context2.deleteValue(BAGGAGE_KEY);
        }
        ;
        var propagation_API_NAME = "propagation";
        var NOOP_TEXT_MAP_PROPAGATOR = new NoopTextMapPropagator();
        var PropagationAPI = function () {
          function PropagationAPI2() {
            this.createBaggage = utils.H;
            this.getBaggage = getBaggage;
            this.setBaggage = setBaggage;
            this.deleteBaggage = deleteBaggage;
          }
          PropagationAPI2.getInstance = function () {
            if (!this._instance) {
              this._instance = new PropagationAPI2();
            }
            return this._instance;
          };
          PropagationAPI2.prototype.setGlobalPropagator = function (propagator) {
            return (0, global_utils.TG)(propagation_API_NAME, propagator, diag.G.instance());
          };
          PropagationAPI2.prototype.inject = function (context2, carrier, setter) {
            if (setter === void 0) {
              setter = defaultTextMapSetter;
            }
            return this._getGlobalPropagator().inject(context2, carrier, setter);
          };
          PropagationAPI2.prototype.extract = function (context2, carrier, getter) {
            if (getter === void 0) {
              getter = defaultTextMapGetter;
            }
            return this._getGlobalPropagator().extract(context2, carrier, getter);
          };
          PropagationAPI2.prototype.fields = function () {
            return this._getGlobalPropagator().fields();
          };
          PropagationAPI2.prototype.disable = function () {
            (0, global_utils.J_)(propagation_API_NAME, diag.G.instance());
          };
          PropagationAPI2.prototype._getGlobalPropagator = function () {
            return (0, global_utils.Rd)(propagation_API_NAME) || NOOP_TEXT_MAP_PROPAGATOR;
          };
          return PropagationAPI2;
        }();
        ;
        var esm_context = ContextAPI.getInstance();
        var trace = TraceAPI.getInstance();
        var propagation = PropagationAPI.getInstance();
        var esm_diag = diag.G.instance();
        const esm = {
          trace,
          context: esm_context,
          propagation,
          diag: esm_diag
        };
      },
      819: (__unused_webpack_module, __webpack_exports__2, __webpack_require__2) => {
        __webpack_require__2.d(__webpack_exports__2, {
          "Rd": () => getGlobal,
          "TG": () => registerGlobal,
          "J_": () => unregisterGlobal
        });
        ;
        var _globalThis = typeof globalThis === "object" ? globalThis : typeof self === "object" ? self : typeof window === "object" ? window : typeof __webpack_require__2.g === "object" ? __webpack_require__2.g : {};
        ;
        var VERSION = "1.2.0";
        ;
        var re = /^(\d+)\.(\d+)\.(\d+)(-(.+))?$/;
        function _makeCompatibilityCheck(ownVersion) {
          var acceptedVersions = new Set([ownVersion]);
          var rejectedVersions = new Set();
          var myVersionMatch = ownVersion.match(re);
          if (!myVersionMatch) {
            return function () {
              return false;
            };
          }
          var ownVersionParsed = {
            major: +myVersionMatch[1],
            minor: +myVersionMatch[2],
            patch: +myVersionMatch[3],
            prerelease: myVersionMatch[4]
          };
          if (ownVersionParsed.prerelease != null) {
            return function isExactmatch(globalVersion) {
              return globalVersion === ownVersion;
            };
          }
          function _reject(v) {
            rejectedVersions.add(v);
            return false;
          }
          function _accept(v) {
            acceptedVersions.add(v);
            return true;
          }
          return function isCompatible2(globalVersion) {
            if (acceptedVersions.has(globalVersion)) {
              return true;
            }
            if (rejectedVersions.has(globalVersion)) {
              return false;
            }
            var globalVersionMatch = globalVersion.match(re);
            if (!globalVersionMatch) {
              return _reject(globalVersion);
            }
            var globalVersionParsed = {
              major: +globalVersionMatch[1],
              minor: +globalVersionMatch[2],
              patch: +globalVersionMatch[3],
              prerelease: globalVersionMatch[4]
            };
            if (globalVersionParsed.prerelease != null) {
              return _reject(globalVersion);
            }
            if (ownVersionParsed.major !== globalVersionParsed.major) {
              return _reject(globalVersion);
            }
            if (ownVersionParsed.major === 0) {
              if (ownVersionParsed.minor === globalVersionParsed.minor && ownVersionParsed.patch <= globalVersionParsed.patch) {
                return _accept(globalVersion);
              }
              return _reject(globalVersion);
            }
            if (ownVersionParsed.minor <= globalVersionParsed.minor) {
              return _accept(globalVersion);
            }
            return _reject(globalVersion);
          };
        }
        var isCompatible = _makeCompatibilityCheck(VERSION);
        ;
        var major = VERSION.split(".")[0];
        var GLOBAL_OPENTELEMETRY_API_KEY = Symbol.for("opentelemetry.js.api." + major);
        var _global = _globalThis;
        function registerGlobal(type, instance, diag, allowOverride) {
          var _a;
          if (allowOverride === void 0) {
            allowOverride = false;
          }
          var api = _global[GLOBAL_OPENTELEMETRY_API_KEY] = (_a = _global[GLOBAL_OPENTELEMETRY_API_KEY]) !== null && _a !== void 0 ? _a : {
            version: VERSION
          };
          if (!allowOverride && api[type]) {
            var err = new Error("@opentelemetry/api: Attempted duplicate registration of API: " + type);
            diag.error(err.stack || err.message);
            return false;
          }
          if (api.version !== VERSION) {
            var err = new Error("@opentelemetry/api: All API registration versions must match");
            diag.error(err.stack || err.message);
            return false;
          }
          api[type] = instance;
          diag.debug("@opentelemetry/api: Registered a global for " + type + " v" + VERSION + ".");
          return true;
        }
        function getGlobal(type) {
          var _a, _b;
          var globalVersion = (_a = _global[GLOBAL_OPENTELEMETRY_API_KEY]) === null || _a === void 0 ? void 0 : _a.version;
          if (!globalVersion || !isCompatible(globalVersion)) {
            return;
          }
          return (_b = _global[GLOBAL_OPENTELEMETRY_API_KEY]) === null || _b === void 0 ? void 0 : _b[type];
        }
        function unregisterGlobal(type, diag) {
          diag.debug("@opentelemetry/api: Unregistering a global for " + type + " v" + VERSION + ".");
          var api = _global[GLOBAL_OPENTELEMETRY_API_KEY];
          if (api) {
            delete api[type];
          }
        }
      },
      817: (__unused_webpack_module, __webpack_exports__2, __webpack_require__2) => {
        __webpack_require__2.d(__webpack_exports__2, {
          "s": () => NonRecordingSpan
        });
        var _invalid_span_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__2(7);
        var NonRecordingSpan = function () {
          function NonRecordingSpan2(_spanContext) {
            if (_spanContext === void 0) {
              _spanContext = _invalid_span_constants__WEBPACK_IMPORTED_MODULE_0__.Rr;
            }
            this._spanContext = _spanContext;
          }
          NonRecordingSpan2.prototype.spanContext = function () {
            return this._spanContext;
          };
          NonRecordingSpan2.prototype.setAttribute = function (_key, _value) {
            return this;
          };
          NonRecordingSpan2.prototype.setAttributes = function (_attributes) {
            return this;
          };
          NonRecordingSpan2.prototype.addEvent = function (_name, _attributes) {
            return this;
          };
          NonRecordingSpan2.prototype.setStatus = function (_status) {
            return this;
          };
          NonRecordingSpan2.prototype.updateName = function (_name) {
            return this;
          };
          NonRecordingSpan2.prototype.end = function (_endTime) {};
          NonRecordingSpan2.prototype.isRecording = function () {
            return false;
          };
          NonRecordingSpan2.prototype.recordException = function (_exception, _time) {};
          return NonRecordingSpan2;
        }();
      },
      227: (__unused_webpack_module, __webpack_exports__2, __webpack_require__2) => {
        __webpack_require__2.d(__webpack_exports__2, {
          "U": () => SamplingDecision
        });
        var SamplingDecision;
        (function (SamplingDecision2) {
          SamplingDecision2[SamplingDecision2["NOT_RECORD"] = 0] = "NOT_RECORD";
          SamplingDecision2[SamplingDecision2["RECORD"] = 1] = "RECORD";
          SamplingDecision2[SamplingDecision2["RECORD_AND_SAMPLED"] = 2] = "RECORD_AND_SAMPLED";
        })(SamplingDecision || (SamplingDecision = {}));
      },
      7: (__unused_webpack_module, __webpack_exports__2, __webpack_require__2) => {
        __webpack_require__2.d(__webpack_exports__2, {
          "fQ": () => INVALID_SPANID,
          "AE": () => INVALID_TRACEID,
          "Rr": () => INVALID_SPAN_CONTEXT
        });
        var _trace_flags__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__2(726);
        var INVALID_SPANID = "0000000000000000";
        var INVALID_TRACEID = "00000000000000000000000000000000";
        var INVALID_SPAN_CONTEXT = {
          traceId: INVALID_TRACEID,
          spanId: INVALID_SPANID,
          traceFlags: _trace_flags__WEBPACK_IMPORTED_MODULE_0__.r.NONE
        };
      },
      87: (__unused_webpack_module, __webpack_exports__2, __webpack_require__2) => {
        __webpack_require__2.d(__webpack_exports__2, {
          "M": () => SpanKind
        });
        var SpanKind;
        (function (SpanKind2) {
          SpanKind2[SpanKind2["INTERNAL"] = 0] = "INTERNAL";
          SpanKind2[SpanKind2["SERVER"] = 1] = "SERVER";
          SpanKind2[SpanKind2["CLIENT"] = 2] = "CLIENT";
          SpanKind2[SpanKind2["PRODUCER"] = 3] = "PRODUCER";
          SpanKind2[SpanKind2["CONSUMER"] = 4] = "CONSUMER";
        })(SpanKind || (SpanKind = {}));
      },
      228: (__unused_webpack_module, __webpack_exports__2, __webpack_require__2) => {
        __webpack_require__2.d(__webpack_exports__2, {
          "jN": () => isValidTraceId,
          "Lc": () => isValidSpanId,
          "BM": () => isSpanContextValid,
          "kw": () => wrapSpanContext
        });
        var _invalid_span_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__2(7);
        var _NonRecordingSpan__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__2(817);
        var VALID_TRACEID_REGEX = /^([0-9a-f]{32})$/i;
        var VALID_SPANID_REGEX = /^[0-9a-f]{16}$/i;
        function isValidTraceId(traceId) {
          return VALID_TRACEID_REGEX.test(traceId) && traceId !== _invalid_span_constants__WEBPACK_IMPORTED_MODULE_0__.AE;
        }
        function isValidSpanId(spanId) {
          return VALID_SPANID_REGEX.test(spanId) && spanId !== _invalid_span_constants__WEBPACK_IMPORTED_MODULE_0__.fQ;
        }
        function isSpanContextValid(spanContext) {
          return isValidTraceId(spanContext.traceId) && isValidSpanId(spanContext.spanId);
        }
        function wrapSpanContext(spanContext) {
          return new _NonRecordingSpan__WEBPACK_IMPORTED_MODULE_1__.s(spanContext);
        }
      },
      820: (__unused_webpack_module, __webpack_exports__2, __webpack_require__2) => {
        __webpack_require__2.d(__webpack_exports__2, {
          "Q": () => SpanStatusCode
        });
        var SpanStatusCode;
        (function (SpanStatusCode2) {
          SpanStatusCode2[SpanStatusCode2["UNSET"] = 0] = "UNSET";
          SpanStatusCode2[SpanStatusCode2["OK"] = 1] = "OK";
          SpanStatusCode2[SpanStatusCode2["ERROR"] = 2] = "ERROR";
        })(SpanStatusCode || (SpanStatusCode = {}));
      },
      726: (__unused_webpack_module, __webpack_exports__2, __webpack_require__2) => {
        __webpack_require__2.d(__webpack_exports__2, {
          "r": () => TraceFlags
        });
        var TraceFlags;
        (function (TraceFlags2) {
          TraceFlags2[TraceFlags2["NONE"] = 0] = "NONE";
          TraceFlags2[TraceFlags2["SAMPLED"] = 1] = "SAMPLED";
        })(TraceFlags || (TraceFlags = {}));
      },
      420: (__unused_webpack_module, __webpack_exports__2, __webpack_require__2) => {
        __webpack_require__2.d(__webpack_exports__2, {
          "I": () => ExportResultCode
        });
        var ExportResultCode;
        (function (ExportResultCode2) {
          ExportResultCode2[ExportResultCode2["SUCCESS"] = 0] = "SUCCESS";
          ExportResultCode2[ExportResultCode2["FAILED"] = 1] = "FAILED";
        })(ExportResultCode || (ExportResultCode = {}));
      },
      250: (__unused_webpack_module, __webpack_exports__2, __webpack_require__2) => {
        __webpack_require__2.d(__webpack_exports__2, {
          "Vo": () => BAGGAGE_KEY_PAIR_SEPARATOR,
          "bO": () => BAGGAGE_PROPERTIES_SEPARATOR,
          "bU": () => BAGGAGE_ITEMS_SEPARATOR,
          "WM": () => BAGGAGE_HEADER,
          "Cx": () => BAGGAGE_MAX_NAME_VALUE_PAIRS,
          "ef": () => BAGGAGE_MAX_PER_NAME_VALUE_PAIRS,
          "H3": () => BAGGAGE_MAX_TOTAL_LENGTH
        });
        var BAGGAGE_KEY_PAIR_SEPARATOR = "=";
        var BAGGAGE_PROPERTIES_SEPARATOR = ";";
        var BAGGAGE_ITEMS_SEPARATOR = ",";
        var BAGGAGE_HEADER = "baggage";
        var BAGGAGE_MAX_NAME_VALUE_PAIRS = 180;
        var BAGGAGE_MAX_PER_NAME_VALUE_PAIRS = 4096;
        var BAGGAGE_MAX_TOTAL_LENGTH = 8192;
      },
      926: (__unused_webpack_module, __webpack_exports__2, __webpack_require__2) => {
        __webpack_require__2.d(__webpack_exports__2, {
          "a": () => W3CBaggagePropagator
        });
        var _opentelemetry_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__2(620);
        var _trace_suppress_tracing__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__2(397);
        var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__2(250);
        var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__2(315);
        var W3CBaggagePropagator = function () {
          function W3CBaggagePropagator2() {}
          W3CBaggagePropagator2.prototype.inject = function (context, carrier, setter) {
            var baggage = _opentelemetry_api__WEBPACK_IMPORTED_MODULE_0__.propagation.getBaggage(context);
            if (!baggage || (0, _trace_suppress_tracing__WEBPACK_IMPORTED_MODULE_1__.Ll)(context)) return;
            var keyPairs = (0, _utils__WEBPACK_IMPORTED_MODULE_2__.getKeyPairs)(baggage).filter(function (pair) {
              return pair.length <= _constants__WEBPACK_IMPORTED_MODULE_3__.ef;
            }).slice(0, _constants__WEBPACK_IMPORTED_MODULE_3__.Cx);
            var headerValue = (0, _utils__WEBPACK_IMPORTED_MODULE_2__.serializeKeyPairs)(keyPairs);
            if (headerValue.length > 0) {
              setter.set(carrier, _constants__WEBPACK_IMPORTED_MODULE_3__.WM, headerValue);
            }
          };
          W3CBaggagePropagator2.prototype.extract = function (context, carrier, getter) {
            var headerValue = getter.get(carrier, _constants__WEBPACK_IMPORTED_MODULE_3__.WM);
            var baggageString = Array.isArray(headerValue) ? headerValue.join(_constants__WEBPACK_IMPORTED_MODULE_3__.bU) : headerValue;
            if (!baggageString) return context;
            var baggage = {};
            if (baggageString.length === 0) {
              return context;
            }
            var pairs = baggageString.split(_constants__WEBPACK_IMPORTED_MODULE_3__.bU);
            pairs.forEach(function (entry) {
              var keyPair = (0, _utils__WEBPACK_IMPORTED_MODULE_2__.parsePairKeyValue)(entry);
              if (keyPair) {
                var baggageEntry = {
                  value: keyPair.value
                };
                if (keyPair.metadata) {
                  baggageEntry.metadata = keyPair.metadata;
                }
                baggage[keyPair.key] = baggageEntry;
              }
            });
            if (Object.entries(baggage).length === 0) {
              return context;
            }
            return _opentelemetry_api__WEBPACK_IMPORTED_MODULE_0__.propagation.setBaggage(context, _opentelemetry_api__WEBPACK_IMPORTED_MODULE_0__.propagation.createBaggage(baggage));
          };
          W3CBaggagePropagator2.prototype.fields = function () {
            return [_constants__WEBPACK_IMPORTED_MODULE_3__.WM];
          };
          return W3CBaggagePropagator2;
        }();
      },
      315: (__unused_webpack_module, __webpack_exports__2, __webpack_require__2) => {
        __webpack_require__2.r(__webpack_exports__2);
        __webpack_require__2.d(__webpack_exports__2, {
          "serializeKeyPairs": () => serializeKeyPairs,
          "getKeyPairs": () => getKeyPairs,
          "parsePairKeyValue": () => parsePairKeyValue,
          "parseKeyPairsIntoRecord": () => parseKeyPairsIntoRecord
        });
        var _opentelemetry_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__2(599);
        var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__2(250);
        var __read = function (o, n) {
          var m = typeof Symbol === "function" && o[Symbol.iterator];
          if (!m) return o;
          var i = m.call(o),
            r,
            ar = [],
            e;
          try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
          } catch (error) {
            e = {
              error
            };
          } finally {
            try {
              if (r && !r.done && (m = i["return"])) m.call(i);
            } finally {
              if (e) throw e.error;
            }
          }
          return ar;
        };
        function serializeKeyPairs(keyPairs) {
          return keyPairs.reduce(function (hValue, current) {
            var value = "" + hValue + (hValue !== "" ? _constants__WEBPACK_IMPORTED_MODULE_0__.bU : "") + current;
            return value.length > _constants__WEBPACK_IMPORTED_MODULE_0__.H3 ? hValue : value;
          }, "");
        }
        function getKeyPairs(baggage) {
          return baggage.getAllEntries().map(function (_a) {
            var _b = __read(_a, 2),
              key = _b[0],
              value = _b[1];
            var entry = encodeURIComponent(key) + "=" + encodeURIComponent(value.value);
            if (value.metadata !== void 0) {
              entry += _constants__WEBPACK_IMPORTED_MODULE_0__.bO + value.metadata.toString();
            }
            return entry;
          });
        }
        function parsePairKeyValue(entry) {
          var valueProps = entry.split(_constants__WEBPACK_IMPORTED_MODULE_0__.bO);
          if (valueProps.length <= 0) return;
          var keyPairPart = valueProps.shift();
          if (!keyPairPart) return;
          var keyPair = keyPairPart.split(_constants__WEBPACK_IMPORTED_MODULE_0__.Vo);
          if (keyPair.length !== 2) return;
          var key = decodeURIComponent(keyPair[0].trim());
          var value = decodeURIComponent(keyPair[1].trim());
          var metadata;
          if (valueProps.length > 0) {
            metadata = (0, _opentelemetry_api__WEBPACK_IMPORTED_MODULE_1__.u)(valueProps.join(_constants__WEBPACK_IMPORTED_MODULE_0__.bO));
          }
          return {
            key,
            value,
            metadata
          };
        }
        function parseKeyPairsIntoRecord(value) {
          if (typeof value !== "string" || value.length === 0) return {};
          return value.split(_constants__WEBPACK_IMPORTED_MODULE_0__.bU).map(function (entry) {
            return parsePairKeyValue(entry);
          }).filter(function (keyPair) {
            return keyPair !== void 0 && keyPair.value.length > 0;
          }).reduce(function (headers, keyPair) {
            headers[keyPair.key] = keyPair.value;
            return headers;
          }, {});
        }
      },
      706: (__unused_webpack_module, __webpack_exports__2, __webpack_require__2) => {
        __webpack_require__2.d(__webpack_exports__2, {
          "v": () => AnchoredClock
        });
        var AnchoredClock = function () {
          function AnchoredClock2(systemClock, monotonicClock) {
            this._monotonicClock = monotonicClock;
            this._epochMillis = systemClock.now();
            this._performanceMillis = monotonicClock.now();
          }
          AnchoredClock2.prototype.now = function () {
            var delta = this._monotonicClock.now() - this._performanceMillis;
            return this._epochMillis + delta;
          };
          return AnchoredClock2;
        }();
      },
      551: (__unused_webpack_module, __webpack_exports__2, __webpack_require__2) => {
        __webpack_require__2.d(__webpack_exports__2, {
          "FT": () => sanitizeAttributes,
          "sy": () => isAttributeKey,
          "Do": () => isAttributeValue
        });
        var _opentelemetry_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__2(620);
        var __values = function (o) {
          var s = typeof Symbol === "function" && Symbol.iterator,
            m = s && o[s],
            i = 0;
          if (m) return m.call(o);
          if (o && typeof o.length === "number") return {
            next: function () {
              if (o && i >= o.length) o = void 0;
              return {
                value: o && o[i++],
                done: !o
              };
            }
          };
          throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
        };
        var __read = function (o, n) {
          var m = typeof Symbol === "function" && o[Symbol.iterator];
          if (!m) return o;
          var i = m.call(o),
            r,
            ar = [],
            e;
          try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
          } catch (error) {
            e = {
              error
            };
          } finally {
            try {
              if (r && !r.done && (m = i["return"])) m.call(i);
            } finally {
              if (e) throw e.error;
            }
          }
          return ar;
        };
        function sanitizeAttributes(attributes) {
          var e_1, _a;
          var out = {};
          if (typeof attributes !== "object" || attributes == null) {
            return out;
          }
          try {
            for (var _b = __values(Object.entries(attributes)), _c = _b.next(); !_c.done; _c = _b.next()) {
              var _d = __read(_c.value, 2),
                key = _d[0],
                val = _d[1];
              if (!isAttributeKey(key)) {
                _opentelemetry_api__WEBPACK_IMPORTED_MODULE_0__.diag.warn("Invalid attribute key: " + key);
                continue;
              }
              if (!isAttributeValue(val)) {
                _opentelemetry_api__WEBPACK_IMPORTED_MODULE_0__.diag.warn("Invalid attribute value set for key: " + key);
                continue;
              }
              if (Array.isArray(val)) {
                out[key] = val.slice();
              } else {
                out[key] = val;
              }
            }
          } catch (e_1_1) {
            e_1 = {
              error: e_1_1
            };
          } finally {
            try {
              if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally {
              if (e_1) throw e_1.error;
            }
          }
          return out;
        }
        function isAttributeKey(key) {
          return typeof key === "string" && key.length > 0;
        }
        function isAttributeValue(val) {
          if (val == null) {
            return true;
          }
          if (Array.isArray(val)) {
            return isHomogeneousAttributeValueArray(val);
          }
          return isValidPrimitiveAttributeValue(val);
        }
        function isHomogeneousAttributeValueArray(arr) {
          var e_2, _a;
          var type;
          try {
            for (var arr_1 = __values(arr), arr_1_1 = arr_1.next(); !arr_1_1.done; arr_1_1 = arr_1.next()) {
              var element = arr_1_1.value;
              if (element == null) continue;
              if (!type) {
                if (isValidPrimitiveAttributeValue(element)) {
                  type = typeof element;
                  continue;
                }
                return false;
              }
              if (typeof element === type) {
                continue;
              }
              return false;
            }
          } catch (e_2_1) {
            e_2 = {
              error: e_2_1
            };
          } finally {
            try {
              if (arr_1_1 && !arr_1_1.done && (_a = arr_1.return)) _a.call(arr_1);
            } finally {
              if (e_2) throw e_2.error;
            }
          }
          return true;
        }
        function isValidPrimitiveAttributeValue(val) {
          switch (typeof val) {
            case "number":
            case "boolean":
            case "string":
              return true;
          }
          return false;
        }
      },
      220: (__unused_webpack_module, __webpack_exports__2, __webpack_require__2) => {
        __webpack_require__2.d(__webpack_exports__2, {
          "c": () => setGlobalErrorHandler,
          "L": () => globalErrorHandler
        });
        var _logging_error_handler__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__2(470);
        var delegateHandler = (0, _logging_error_handler__WEBPACK_IMPORTED_MODULE_0__.x)();
        function setGlobalErrorHandler(handler) {
          delegateHandler = handler;
        }
        function globalErrorHandler(ex) {
          try {
            delegateHandler(ex);
          } catch (_a) {}
        }
      },
      470: (__unused_webpack_module, __webpack_exports__2, __webpack_require__2) => {
        __webpack_require__2.d(__webpack_exports__2, {
          "x": () => loggingErrorHandler
        });
        var _opentelemetry_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__2(620);
        function loggingErrorHandler() {
          return function (ex) {
            _opentelemetry_api__WEBPACK_IMPORTED_MODULE_0__.diag.error(stringifyException(ex));
          };
        }
        function stringifyException(ex) {
          if (typeof ex === "string") {
            return ex;
          } else {
            return JSON.stringify(flattenException(ex));
          }
        }
        function flattenException(ex) {
          var result = {};
          var current = ex;
          while (current !== null) {
            Object.getOwnPropertyNames(current).forEach(function (propertyName) {
              if (result[propertyName]) return;
              var value = current[propertyName];
              if (value) {
                result[propertyName] = String(value);
              }
            });
            current = Object.getPrototypeOf(current);
          }
          return result;
        }
      },
      664: (__unused_webpack_module, __webpack_exports__2, __webpack_require__2) => {
        __webpack_require__2.d(__webpack_exports__2, {
          "Jt": () => hrTime,
          "aE": () => timeInputToHrTime,
          "J3": () => hrTimeDuration,
          "Us": () => hrTimeToTimeStamp,
          "PW": () => hrTimeToNanoseconds,
          "KO": () => hrTimeToMilliseconds,
          "ji": () => hrTimeToMicroseconds,
          "Dt": () => isTimeInputHrTime,
          "X_": () => isTimeInput
        });
        var _platform__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__2(383);
        var NANOSECOND_DIGITS = 9;
        var SECOND_TO_NANOSECONDS = Math.pow(10, NANOSECOND_DIGITS);
        function numberToHrtime(epochMillis) {
          var epochSeconds = epochMillis / 1e3;
          var seconds = Math.trunc(epochSeconds);
          var nanos = Number((epochSeconds - seconds).toFixed(NANOSECOND_DIGITS)) * SECOND_TO_NANOSECONDS;
          return [seconds, nanos];
        }
        function getTimeOrigin() {
          var timeOrigin = _platform__WEBPACK_IMPORTED_MODULE_0__.t.timeOrigin;
          if (typeof timeOrigin !== "number") {
            var perf = _platform__WEBPACK_IMPORTED_MODULE_0__.t;
            timeOrigin = perf.timing && perf.timing.fetchStart;
          }
          return timeOrigin;
        }
        function hrTime(performanceNow) {
          var timeOrigin = numberToHrtime(getTimeOrigin());
          var now = numberToHrtime(typeof performanceNow === "number" ? performanceNow : _platform__WEBPACK_IMPORTED_MODULE_0__.t.now());
          var seconds = timeOrigin[0] + now[0];
          var nanos = timeOrigin[1] + now[1];
          if (nanos > SECOND_TO_NANOSECONDS) {
            nanos -= SECOND_TO_NANOSECONDS;
            seconds += 1;
          }
          return [seconds, nanos];
        }
        function timeInputToHrTime(time) {
          if (isTimeInputHrTime(time)) {
            return time;
          } else if (typeof time === "number") {
            if (time < getTimeOrigin()) {
              return hrTime(time);
            } else {
              return numberToHrtime(time);
            }
          } else if (time instanceof Date) {
            return numberToHrtime(time.getTime());
          } else {
            throw TypeError("Invalid input type");
          }
        }
        function hrTimeDuration(startTime, endTime) {
          var seconds = endTime[0] - startTime[0];
          var nanos = endTime[1] - startTime[1];
          if (nanos < 0) {
            seconds -= 1;
            nanos += SECOND_TO_NANOSECONDS;
          }
          return [seconds, nanos];
        }
        function hrTimeToTimeStamp(time) {
          var precision = NANOSECOND_DIGITS;
          var tmp = "" + "0".repeat(precision) + time[1] + "Z";
          var nanoString = tmp.substr(tmp.length - precision - 1);
          var date = new Date(time[0] * 1e3).toISOString();
          return date.replace("000Z", nanoString);
        }
        function hrTimeToNanoseconds(time) {
          return time[0] * SECOND_TO_NANOSECONDS + time[1];
        }
        function hrTimeToMilliseconds(time) {
          return Math.round(time[0] * 1e3 + time[1] / 1e6);
        }
        function hrTimeToMicroseconds(time) {
          return Math.round(time[0] * 1e6 + time[1] / 1e3);
        }
        function isTimeInputHrTime(value) {
          return Array.isArray(value) && value.length === 2 && typeof value[0] === "number" && typeof value[1] === "number";
        }
        function isTimeInput(value) {
          return isTimeInputHrTime(value) || typeof value === "number" || value instanceof Date;
        }
      },
      455: (__unused_webpack_module, __webpack_exports__2, __webpack_require__2) => {
        __webpack_require__2.r(__webpack_exports__2);
        __webpack_require__2.d(__webpack_exports__2, {
          "AlwaysOffSampler": () => AlwaysOffSampler,
          "AlwaysOnSampler": () => AlwaysOnSampler,
          "AnchoredClock": () => anchored_clock.v,
          "BindOnceFuture": () => callback.q,
          "CompositePropagator": () => composite.Y,
          "DEFAULT_ATTRIBUTE_COUNT_LIMIT": () => utils_environment.qG,
          "DEFAULT_ATTRIBUTE_VALUE_LENGTH_LIMIT": () => utils_environment.KR,
          "DEFAULT_ENVIRONMENT": () => utils_environment.J9,
          "ExportResultCode": () => ExportResult.I,
          "ParentBasedSampler": () => ParentBasedSampler,
          "RPCType": () => RPCType,
          "RandomIdGenerator": () => RandomIdGenerator,
          "SDK_INFO": () => sdk_info.m,
          "TRACE_PARENT_HEADER": () => W3CTraceContextPropagator.FX,
          "TRACE_STATE_HEADER": () => W3CTraceContextPropagator.C3,
          "TraceIdRatioBasedSampler": () => TraceIdRatioBasedSampler,
          "TraceState": () => TraceState.n,
          "TracesSamplerValues": () => sampling.J,
          "VERSION": () => version.q,
          "W3CBaggagePropagator": () => W3CBaggagePropagator.a,
          "W3CTraceContextPropagator": () => W3CTraceContextPropagator.jf,
          "_globalThis": () => globalThis2.E,
          "baggageUtils": () => utils,
          "deleteRPCMetadata": () => deleteRPCMetadata,
          "getEnv": () => environment.d,
          "getEnvWithoutDefaults": () => utils_environment.vU,
          "getRPCMetadata": () => getRPCMetadata,
          "globalErrorHandler": () => global_error_handler.L,
          "hexToBase64": () => hex_to_base64.W,
          "hrTime": () => time.Jt,
          "hrTimeDuration": () => time.J3,
          "hrTimeToMicroseconds": () => time.ji,
          "hrTimeToMilliseconds": () => time.KO,
          "hrTimeToNanoseconds": () => time.PW,
          "hrTimeToTimeStamp": () => time.Us,
          "isAttributeKey": () => attributes.sy,
          "isAttributeValue": () => attributes.Do,
          "isTimeInput": () => time.X_,
          "isTimeInputHrTime": () => time.Dt,
          "isTracingSuppressed": () => suppress_tracing.Ll,
          "isUrlIgnored": () => isUrlIgnored,
          "isWrapped": () => isWrapped,
          "loggingErrorHandler": () => logging_error_handler.x,
          "merge": () => merge.T,
          "otperformance": () => performance2.t,
          "parseEnvironment": () => utils_environment.Ds,
          "parseTraceParent": () => W3CTraceContextPropagator.j_,
          "sanitizeAttributes": () => attributes.FT,
          "setGlobalErrorHandler": () => global_error_handler.c,
          "setRPCMetadata": () => setRPCMetadata,
          "suppressTracing": () => suppress_tracing.hE,
          "timeInputToHrTime": () => time.aE,
          "unrefTimer": () => timer_util.g,
          "unsuppressTracing": () => suppress_tracing.yy,
          "urlMatches": () => urlMatches
        });
        var W3CBaggagePropagator = __webpack_require__2(926);
        var anchored_clock = __webpack_require__2(706);
        var attributes = __webpack_require__2(551);
        var global_error_handler = __webpack_require__2(220);
        var logging_error_handler = __webpack_require__2(470);
        var time = __webpack_require__2(664);
        var ExportResult = __webpack_require__2(420);
        var version = __webpack_require__2(923);
        var utils = __webpack_require__2(315);
        var environment = __webpack_require__2(580);
        var globalThis2 = __webpack_require__2(298);
        var hex_to_base64 = __webpack_require__2(16);
        ;
        var SPAN_ID_BYTES = 8;
        var TRACE_ID_BYTES = 16;
        var RandomIdGenerator = function () {
          function RandomIdGenerator2() {
            this.generateTraceId = getIdGenerator(TRACE_ID_BYTES);
            this.generateSpanId = getIdGenerator(SPAN_ID_BYTES);
          }
          return RandomIdGenerator2;
        }();
        var SHARED_CHAR_CODES_ARRAY = Array(32);
        function getIdGenerator(bytes) {
          return function generateId() {
            for (var i = 0; i < bytes * 2; i++) {
              SHARED_CHAR_CODES_ARRAY[i] = Math.floor(Math.random() * 16) + 48;
              if (SHARED_CHAR_CODES_ARRAY[i] >= 58) {
                SHARED_CHAR_CODES_ARRAY[i] += 39;
              }
            }
            return String.fromCharCode.apply(null, SHARED_CHAR_CODES_ARRAY.slice(0, bytes * 2));
          };
        }
        var performance2 = __webpack_require__2(383);
        var sdk_info = __webpack_require__2(511);
        var timer_util = __webpack_require__2(869);
        ;
        var composite = __webpack_require__2(135);
        var W3CTraceContextPropagator = __webpack_require__2(588);
        var context = __webpack_require__2(834);
        ;
        var RPC_METADATA_KEY = (0, context.Y)("OpenTelemetry SDK Context Key RPC_METADATA");
        var RPCType;
        (function (RPCType2) {
          RPCType2["HTTP"] = "http";
        })(RPCType || (RPCType = {}));
        function setRPCMetadata(context2, meta) {
          return context2.setValue(RPC_METADATA_KEY, meta);
        }
        function deleteRPCMetadata(context2) {
          return context2.deleteValue(RPC_METADATA_KEY);
        }
        function getRPCMetadata(context2) {
          return context2.getValue(RPC_METADATA_KEY);
        }
        var SamplingResult = __webpack_require__2(227);
        ;
        var AlwaysOffSampler = function () {
          function AlwaysOffSampler2() {}
          AlwaysOffSampler2.prototype.shouldSample = function () {
            return {
              decision: SamplingResult.U.NOT_RECORD
            };
          };
          AlwaysOffSampler2.prototype.toString = function () {
            return "AlwaysOffSampler";
          };
          return AlwaysOffSampler2;
        }();
        ;
        var AlwaysOnSampler = function () {
          function AlwaysOnSampler2() {}
          AlwaysOnSampler2.prototype.shouldSample = function () {
            return {
              decision: SamplingResult.U.RECORD_AND_SAMPLED
            };
          };
          AlwaysOnSampler2.prototype.toString = function () {
            return "AlwaysOnSampler";
          };
          return AlwaysOnSampler2;
        }();
        var esm = __webpack_require__2(620);
        var spancontext_utils = __webpack_require__2(228);
        var trace_flags = __webpack_require__2(726);
        ;
        var ParentBasedSampler = function () {
          function ParentBasedSampler2(config) {
            var _a, _b, _c, _d;
            this._root = config.root;
            if (!this._root) {
              (0, global_error_handler.L)(new Error("ParentBasedSampler must have a root sampler configured"));
              this._root = new AlwaysOnSampler();
            }
            this._remoteParentSampled = (_a = config.remoteParentSampled) !== null && _a !== void 0 ? _a : new AlwaysOnSampler();
            this._remoteParentNotSampled = (_b = config.remoteParentNotSampled) !== null && _b !== void 0 ? _b : new AlwaysOffSampler();
            this._localParentSampled = (_c = config.localParentSampled) !== null && _c !== void 0 ? _c : new AlwaysOnSampler();
            this._localParentNotSampled = (_d = config.localParentNotSampled) !== null && _d !== void 0 ? _d : new AlwaysOffSampler();
          }
          ParentBasedSampler2.prototype.shouldSample = function (context2, traceId, spanName, spanKind, attributes2, links) {
            var parentContext = esm.trace.getSpanContext(context2);
            if (!parentContext || !(0, spancontext_utils.BM)(parentContext)) {
              return this._root.shouldSample(context2, traceId, spanName, spanKind, attributes2, links);
            }
            if (parentContext.isRemote) {
              if (parentContext.traceFlags & trace_flags.r.SAMPLED) {
                return this._remoteParentSampled.shouldSample(context2, traceId, spanName, spanKind, attributes2, links);
              }
              return this._remoteParentNotSampled.shouldSample(context2, traceId, spanName, spanKind, attributes2, links);
            }
            if (parentContext.traceFlags & trace_flags.r.SAMPLED) {
              return this._localParentSampled.shouldSample(context2, traceId, spanName, spanKind, attributes2, links);
            }
            return this._localParentNotSampled.shouldSample(context2, traceId, spanName, spanKind, attributes2, links);
          };
          ParentBasedSampler2.prototype.toString = function () {
            return "ParentBased{root=" + this._root.toString() + ", remoteParentSampled=" + this._remoteParentSampled.toString() + ", remoteParentNotSampled=" + this._remoteParentNotSampled.toString() + ", localParentSampled=" + this._localParentSampled.toString() + ", localParentNotSampled=" + this._localParentNotSampled.toString() + "}";
          };
          return ParentBasedSampler2;
        }();
        ;
        var TraceIdRatioBasedSampler = function () {
          function TraceIdRatioBasedSampler2(_ratio) {
            if (_ratio === void 0) {
              _ratio = 0;
            }
            this._ratio = _ratio;
            this._ratio = this._normalize(_ratio);
            this._upperBound = Math.floor(this._ratio * 4294967295);
          }
          TraceIdRatioBasedSampler2.prototype.shouldSample = function (context2, traceId) {
            return {
              decision: (0, spancontext_utils.jN)(traceId) && this._accumulate(traceId) < this._upperBound ? SamplingResult.U.RECORD_AND_SAMPLED : SamplingResult.U.NOT_RECORD
            };
          };
          TraceIdRatioBasedSampler2.prototype.toString = function () {
            return "TraceIdRatioBased{" + this._ratio + "}";
          };
          TraceIdRatioBasedSampler2.prototype._normalize = function (ratio) {
            if (typeof ratio !== "number" || isNaN(ratio)) return 0;
            return ratio >= 1 ? 1 : ratio <= 0 ? 0 : ratio;
          };
          TraceIdRatioBasedSampler2.prototype._accumulate = function (traceId) {
            var accumulation = 0;
            for (var i = 0; i < traceId.length / 8; i++) {
              var pos = i * 8;
              var part = parseInt(traceId.slice(pos, pos + 8), 16);
              accumulation = (accumulation ^ part) >>> 0;
            }
            return accumulation;
          };
          return TraceIdRatioBasedSampler2;
        }();
        var suppress_tracing = __webpack_require__2(397);
        var TraceState = __webpack_require__2(598);
        var utils_environment = __webpack_require__2(851);
        var merge = __webpack_require__2(9);
        var sampling = __webpack_require__2(290);
        ;
        var __values = function (o) {
          var s = typeof Symbol === "function" && Symbol.iterator,
            m = s && o[s],
            i = 0;
          if (m) return m.call(o);
          if (o && typeof o.length === "number") return {
            next: function () {
              if (o && i >= o.length) o = void 0;
              return {
                value: o && o[i++],
                done: !o
              };
            }
          };
          throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
        };
        function urlMatches(url, urlToMatch) {
          if (typeof urlToMatch === "string") {
            return url === urlToMatch;
          } else {
            return !!url.match(urlToMatch);
          }
        }
        function isUrlIgnored(url, ignoredUrls) {
          var e_1, _a;
          if (!ignoredUrls) {
            return false;
          }
          try {
            for (var ignoredUrls_1 = __values(ignoredUrls), ignoredUrls_1_1 = ignoredUrls_1.next(); !ignoredUrls_1_1.done; ignoredUrls_1_1 = ignoredUrls_1.next()) {
              var ignoreUrl = ignoredUrls_1_1.value;
              if (urlMatches(url, ignoreUrl)) {
                return true;
              }
            }
          } catch (e_1_1) {
            e_1 = {
              error: e_1_1
            };
          } finally {
            try {
              if (ignoredUrls_1_1 && !ignoredUrls_1_1.done && (_a = ignoredUrls_1.return)) _a.call(ignoredUrls_1);
            } finally {
              if (e_1) throw e_1.error;
            }
          }
          return false;
        }
        ;
        function isWrapped(func) {
          return typeof func === "function" && typeof func.__original === "function" && typeof func.__unwrap === "function" && func.__wrapped === true;
        }
        var callback = __webpack_require__2(399);
        ;
      },
      580: (__unused_webpack_module, __webpack_exports__2, __webpack_require__2) => {
        __webpack_require__2.d(__webpack_exports__2, {
          "d": () => getEnv
        });
        var _utils_environment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__2(851);
        var _globalThis__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__2(298);
        function getEnv() {
          var globalEnv = (0, _utils_environment__WEBPACK_IMPORTED_MODULE_0__.Ds)(_globalThis__WEBPACK_IMPORTED_MODULE_1__.E);
          return Object.assign({}, _utils_environment__WEBPACK_IMPORTED_MODULE_0__.J9, globalEnv);
        }
      },
      298: (__unused_webpack_module, __webpack_exports__2, __webpack_require__2) => {
        __webpack_require__2.d(__webpack_exports__2, {
          "E": () => _globalThis
        });
        var _globalThis = typeof globalThis === "object" ? globalThis : typeof self === "object" ? self : typeof window === "object" ? window : typeof __webpack_require__2.g === "object" ? __webpack_require__2.g : {};
      },
      16: (__unused_webpack_module, __webpack_exports__2, __webpack_require__2) => {
        __webpack_require__2.d(__webpack_exports__2, {
          "W": () => hexToBase64
        });
        function hexToBase64(hexStr) {
          var hexStrLen = hexStr.length;
          var hexAsciiCharsStr = "";
          for (var i = 0; i < hexStrLen; i += 2) {
            var hexPair = hexStr.substring(i, i + 2);
            var hexVal = parseInt(hexPair, 16);
            hexAsciiCharsStr += String.fromCharCode(hexVal);
          }
          return btoa(hexAsciiCharsStr);
        }
      },
      383: (__unused_webpack_module, __webpack_exports__2, __webpack_require__2) => {
        __webpack_require__2.d(__webpack_exports__2, {
          "t": () => otperformance
        });
        var otperformance = performance;
      },
      511: (__unused_webpack_module, __webpack_exports__2, __webpack_require__2) => {
        __webpack_require__2.d(__webpack_exports__2, {
          "m": () => SDK_INFO
        });
        var _version__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__2(923);
        var _opentelemetry_semantic_conventions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__2(364);
        var _a;
        var SDK_INFO = (_a = {}, _a[_opentelemetry_semantic_conventions__WEBPACK_IMPORTED_MODULE_0__.R9.TELEMETRY_SDK_NAME] = "opentelemetry", _a[_opentelemetry_semantic_conventions__WEBPACK_IMPORTED_MODULE_0__.R9.PROCESS_RUNTIME_NAME] = "browser", _a[_opentelemetry_semantic_conventions__WEBPACK_IMPORTED_MODULE_0__.R9.TELEMETRY_SDK_LANGUAGE] = _opentelemetry_semantic_conventions__WEBPACK_IMPORTED_MODULE_0__.Te.WEBJS, _a[_opentelemetry_semantic_conventions__WEBPACK_IMPORTED_MODULE_0__.R9.TELEMETRY_SDK_VERSION] = _version__WEBPACK_IMPORTED_MODULE_1__.q, _a);
      },
      869: (__unused_webpack_module, __webpack_exports__2, __webpack_require__2) => {
        __webpack_require__2.d(__webpack_exports__2, {
          "g": () => unrefTimer
        });
        function unrefTimer(_timer) {}
      },
      135: (__unused_webpack_module, __webpack_exports__2, __webpack_require__2) => {
        __webpack_require__2.d(__webpack_exports__2, {
          "Y": () => CompositePropagator
        });
        var _opentelemetry_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__2(620);
        var __values = function (o) {
          var s = typeof Symbol === "function" && Symbol.iterator,
            m = s && o[s],
            i = 0;
          if (m) return m.call(o);
          if (o && typeof o.length === "number") return {
            next: function () {
              if (o && i >= o.length) o = void 0;
              return {
                value: o && o[i++],
                done: !o
              };
            }
          };
          throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
        };
        var CompositePropagator = function () {
          function CompositePropagator2(config) {
            if (config === void 0) {
              config = {};
            }
            var _a;
            this._propagators = (_a = config.propagators) !== null && _a !== void 0 ? _a : [];
            this._fields = Array.from(new Set(this._propagators.map(function (p) {
              return typeof p.fields === "function" ? p.fields() : [];
            }).reduce(function (x, y) {
              return x.concat(y);
            }, [])));
          }
          CompositePropagator2.prototype.inject = function (context, carrier, setter) {
            var e_1, _a;
            try {
              for (var _b = __values(this._propagators), _c = _b.next(); !_c.done; _c = _b.next()) {
                var propagator = _c.value;
                try {
                  propagator.inject(context, carrier, setter);
                } catch (err) {
                  _opentelemetry_api__WEBPACK_IMPORTED_MODULE_0__.diag.warn("Failed to inject with " + propagator.constructor.name + ". Err: " + err.message);
                }
              }
            } catch (e_1_1) {
              e_1 = {
                error: e_1_1
              };
            } finally {
              try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
              } finally {
                if (e_1) throw e_1.error;
              }
            }
          };
          CompositePropagator2.prototype.extract = function (context, carrier, getter) {
            return this._propagators.reduce(function (ctx, propagator) {
              try {
                return propagator.extract(ctx, carrier, getter);
              } catch (err) {
                _opentelemetry_api__WEBPACK_IMPORTED_MODULE_0__.diag.warn("Failed to inject with " + propagator.constructor.name + ". Err: " + err.message);
              }
              return ctx;
            }, context);
          };
          CompositePropagator2.prototype.fields = function () {
            return this._fields.slice();
          };
          return CompositePropagator2;
        }();
      },
      598: (__unused_webpack_module, __webpack_exports__2, __webpack_require__2) => {
        __webpack_require__2.d(__webpack_exports__2, {
          "n": () => TraceState
        });
        ;
        var VALID_KEY_CHAR_RANGE = "[_0-9a-z-*/]";
        var VALID_KEY = "[a-z]" + VALID_KEY_CHAR_RANGE + "{0,255}";
        var VALID_VENDOR_KEY = "[a-z0-9]" + VALID_KEY_CHAR_RANGE + "{0,240}@[a-z]" + VALID_KEY_CHAR_RANGE + "{0,13}";
        var VALID_KEY_REGEX = new RegExp("^(?:" + VALID_KEY + "|" + VALID_VENDOR_KEY + ")$");
        var VALID_VALUE_BASE_REGEX = /^[ -~]{0,255}[!-~]$/;
        var INVALID_VALUE_COMMA_EQUAL_REGEX = /,|=/;
        function validateKey(key) {
          return VALID_KEY_REGEX.test(key);
        }
        function validateValue(value) {
          return VALID_VALUE_BASE_REGEX.test(value) && !INVALID_VALUE_COMMA_EQUAL_REGEX.test(value);
        }
        ;
        var MAX_TRACE_STATE_ITEMS = 32;
        var MAX_TRACE_STATE_LEN = 512;
        var LIST_MEMBERS_SEPARATOR = ",";
        var LIST_MEMBER_KEY_VALUE_SPLITTER = "=";
        var TraceState = function () {
          function TraceState2(rawTraceState) {
            this._internalState = new Map();
            if (rawTraceState) this._parse(rawTraceState);
          }
          TraceState2.prototype.set = function (key, value) {
            var traceState = this._clone();
            if (traceState._internalState.has(key)) {
              traceState._internalState.delete(key);
            }
            traceState._internalState.set(key, value);
            return traceState;
          };
          TraceState2.prototype.unset = function (key) {
            var traceState = this._clone();
            traceState._internalState.delete(key);
            return traceState;
          };
          TraceState2.prototype.get = function (key) {
            return this._internalState.get(key);
          };
          TraceState2.prototype.serialize = function () {
            var _this = this;
            return this._keys().reduce(function (agg, key) {
              agg.push(key + LIST_MEMBER_KEY_VALUE_SPLITTER + _this.get(key));
              return agg;
            }, []).join(LIST_MEMBERS_SEPARATOR);
          };
          TraceState2.prototype._parse = function (rawTraceState) {
            if (rawTraceState.length > MAX_TRACE_STATE_LEN) return;
            this._internalState = rawTraceState.split(LIST_MEMBERS_SEPARATOR).reverse().reduce(function (agg, part) {
              var listMember = part.trim();
              var i = listMember.indexOf(LIST_MEMBER_KEY_VALUE_SPLITTER);
              if (i !== -1) {
                var key = listMember.slice(0, i);
                var value = listMember.slice(i + 1, part.length);
                if (validateKey(key) && validateValue(value)) {
                  agg.set(key, value);
                } else {}
              }
              return agg;
            }, new Map());
            if (this._internalState.size > MAX_TRACE_STATE_ITEMS) {
              this._internalState = new Map(Array.from(this._internalState.entries()).reverse().slice(0, MAX_TRACE_STATE_ITEMS));
            }
          };
          TraceState2.prototype._keys = function () {
            return Array.from(this._internalState.keys()).reverse();
          };
          TraceState2.prototype._clone = function () {
            var traceState = new TraceState2();
            traceState._internalState = new Map(this._internalState);
            return traceState;
          };
          return TraceState2;
        }();
      },
      588: (__unused_webpack_module, __webpack_exports__2, __webpack_require__2) => {
        __webpack_require__2.d(__webpack_exports__2, {
          "FX": () => TRACE_PARENT_HEADER,
          "C3": () => TRACE_STATE_HEADER,
          "j_": () => parseTraceParent,
          "jf": () => W3CTraceContextPropagator
        });
        var _opentelemetry_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__2(620);
        var _opentelemetry_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__2(228);
        var _opentelemetry_api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__2(726);
        var _suppress_tracing__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__2(397);
        var _TraceState__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__2(598);
        var TRACE_PARENT_HEADER = "traceparent";
        var TRACE_STATE_HEADER = "tracestate";
        var VERSION = "00";
        var VERSION_PART = "(?!ff)[\\da-f]{2}";
        var TRACE_ID_PART = "(?![0]{32})[\\da-f]{32}";
        var PARENT_ID_PART = "(?![0]{16})[\\da-f]{16}";
        var FLAGS_PART = "[\\da-f]{2}";
        var TRACE_PARENT_REGEX = new RegExp("^\\s?(" + VERSION_PART + ")-(" + TRACE_ID_PART + ")-(" + PARENT_ID_PART + ")-(" + FLAGS_PART + ")(-.*)?\\s?$");
        function parseTraceParent(traceParent) {
          var match = TRACE_PARENT_REGEX.exec(traceParent);
          if (!match) return null;
          if (match[1] === "00" && match[5]) return null;
          return {
            traceId: match[2],
            spanId: match[3],
            traceFlags: parseInt(match[4], 16)
          };
        }
        var W3CTraceContextPropagator = function () {
          function W3CTraceContextPropagator2() {}
          W3CTraceContextPropagator2.prototype.inject = function (context, carrier, setter) {
            var spanContext = _opentelemetry_api__WEBPACK_IMPORTED_MODULE_0__.trace.getSpanContext(context);
            if (!spanContext || (0, _suppress_tracing__WEBPACK_IMPORTED_MODULE_1__.Ll)(context) || !(0, _opentelemetry_api__WEBPACK_IMPORTED_MODULE_2__.BM)(spanContext)) return;
            var traceParent = VERSION + "-" + spanContext.traceId + "-" + spanContext.spanId + "-0" + Number(spanContext.traceFlags || _opentelemetry_api__WEBPACK_IMPORTED_MODULE_3__.r.NONE).toString(16);
            setter.set(carrier, TRACE_PARENT_HEADER, traceParent);
            if (spanContext.traceState) {
              setter.set(carrier, TRACE_STATE_HEADER, spanContext.traceState.serialize());
            }
          };
          W3CTraceContextPropagator2.prototype.extract = function (context, carrier, getter) {
            var traceParentHeader = getter.get(carrier, TRACE_PARENT_HEADER);
            if (!traceParentHeader) return context;
            var traceParent = Array.isArray(traceParentHeader) ? traceParentHeader[0] : traceParentHeader;
            if (typeof traceParent !== "string") return context;
            var spanContext = parseTraceParent(traceParent);
            if (!spanContext) return context;
            spanContext.isRemote = true;
            var traceStateHeader = getter.get(carrier, TRACE_STATE_HEADER);
            if (traceStateHeader) {
              var state = Array.isArray(traceStateHeader) ? traceStateHeader.join(",") : traceStateHeader;
              spanContext.traceState = new _TraceState__WEBPACK_IMPORTED_MODULE_4__.n(typeof state === "string" ? state : void 0);
            }
            return _opentelemetry_api__WEBPACK_IMPORTED_MODULE_0__.trace.setSpanContext(context, spanContext);
          };
          W3CTraceContextPropagator2.prototype.fields = function () {
            return [TRACE_PARENT_HEADER, TRACE_STATE_HEADER];
          };
          return W3CTraceContextPropagator2;
        }();
      },
      397: (__unused_webpack_module, __webpack_exports__2, __webpack_require__2) => {
        __webpack_require__2.d(__webpack_exports__2, {
          "hE": () => suppressTracing,
          "yy": () => unsuppressTracing,
          "Ll": () => isTracingSuppressed
        });
        var _opentelemetry_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__2(834);
        var SUPPRESS_TRACING_KEY = (0, _opentelemetry_api__WEBPACK_IMPORTED_MODULE_0__.Y)("OpenTelemetry SDK Context Key SUPPRESS_TRACING");
        function suppressTracing(context) {
          return context.setValue(SUPPRESS_TRACING_KEY, true);
        }
        function unsuppressTracing(context) {
          return context.deleteValue(SUPPRESS_TRACING_KEY);
        }
        function isTracingSuppressed(context) {
          return context.getValue(SUPPRESS_TRACING_KEY) === true;
        }
      },
      399: (__unused_webpack_module, __webpack_exports__2, __webpack_require__2) => {
        __webpack_require__2.d(__webpack_exports__2, {
          "q": () => BindOnceFuture
        });
        ;
        var Deferred = function () {
          function Deferred2() {
            var _this = this;
            this._promise = new Promise(function (resolve, reject) {
              _this._resolve = resolve;
              _this._reject = reject;
            });
          }
          Object.defineProperty(Deferred2.prototype, "promise", {
            get: function () {
              return this._promise;
            },
            enumerable: false,
            configurable: true
          });
          Deferred2.prototype.resolve = function (val) {
            this._resolve(val);
          };
          Deferred2.prototype.reject = function (err) {
            this._reject(err);
          };
          return Deferred2;
        }();
        ;
        var __read = function (o, n) {
          var m = typeof Symbol === "function" && o[Symbol.iterator];
          if (!m) return o;
          var i = m.call(o),
            r,
            ar = [],
            e;
          try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
          } catch (error) {
            e = {
              error
            };
          } finally {
            try {
              if (r && !r.done && (m = i["return"])) m.call(i);
            } finally {
              if (e) throw e.error;
            }
          }
          return ar;
        };
        var __spreadArray = function (to, from, pack) {
          if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
            if (ar || !(i in from)) {
              if (!ar) ar = Array.prototype.slice.call(from, 0, i);
              ar[i] = from[i];
            }
          }
          return to.concat(ar || Array.prototype.slice.call(from));
        };
        var BindOnceFuture = function () {
          function BindOnceFuture2(_callback, _that) {
            this._callback = _callback;
            this._that = _that;
            this._isCalled = false;
            this._deferred = new Deferred();
          }
          Object.defineProperty(BindOnceFuture2.prototype, "isCalled", {
            get: function () {
              return this._isCalled;
            },
            enumerable: false,
            configurable: true
          });
          Object.defineProperty(BindOnceFuture2.prototype, "promise", {
            get: function () {
              return this._deferred.promise;
            },
            enumerable: false,
            configurable: true
          });
          BindOnceFuture2.prototype.call = function () {
            var _a;
            var _this = this;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
              args[_i] = arguments[_i];
            }
            if (!this._isCalled) {
              this._isCalled = true;
              try {
                Promise.resolve((_a = this._callback).call.apply(_a, __spreadArray([this._that], __read(args), false))).then(function (val) {
                  return _this._deferred.resolve(val);
                }, function (err) {
                  return _this._deferred.reject(err);
                });
              } catch (err) {
                this._deferred.reject(err);
              }
            }
            return this._deferred.promise;
          };
          return BindOnceFuture2;
        }();
      },
      851: (__unused_webpack_module, __webpack_exports__2, __webpack_require__2) => {
        __webpack_require__2.d(__webpack_exports__2, {
          "KR": () => DEFAULT_ATTRIBUTE_VALUE_LENGTH_LIMIT,
          "qG": () => DEFAULT_ATTRIBUTE_COUNT_LIMIT,
          "J9": () => DEFAULT_ENVIRONMENT,
          "Ds": () => parseEnvironment,
          "vU": () => getEnvWithoutDefaults
        });
        var _opentelemetry_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__2(740);
        var _sampling__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__2(290);
        var _platform_browser_globalThis__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__2(298);
        var DEFAULT_LIST_SEPARATOR = ",";
        var ENVIRONMENT_NUMBERS_KEYS = ["OTEL_BSP_EXPORT_TIMEOUT", "OTEL_BSP_MAX_EXPORT_BATCH_SIZE", "OTEL_BSP_MAX_QUEUE_SIZE", "OTEL_BSP_SCHEDULE_DELAY", "OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT", "OTEL_ATTRIBUTE_COUNT_LIMIT", "OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT", "OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT", "OTEL_SPAN_EVENT_COUNT_LIMIT", "OTEL_SPAN_LINK_COUNT_LIMIT", "OTEL_EXPORTER_OTLP_TIMEOUT", "OTEL_EXPORTER_OTLP_TRACES_TIMEOUT", "OTEL_EXPORTER_OTLP_METRICS_TIMEOUT", "OTEL_EXPORTER_JAEGER_AGENT_PORT"];
        function isEnvVarANumber(key) {
          return ENVIRONMENT_NUMBERS_KEYS.indexOf(key) > -1;
        }
        var ENVIRONMENT_LISTS_KEYS = ["OTEL_NO_PATCH_MODULES", "OTEL_PROPAGATORS"];
        function isEnvVarAList(key) {
          return ENVIRONMENT_LISTS_KEYS.indexOf(key) > -1;
        }
        var DEFAULT_ATTRIBUTE_VALUE_LENGTH_LIMIT = Infinity;
        var DEFAULT_ATTRIBUTE_COUNT_LIMIT = 128;
        var DEFAULT_ENVIRONMENT = {
          CONTAINER_NAME: "",
          ECS_CONTAINER_METADATA_URI_V4: "",
          ECS_CONTAINER_METADATA_URI: "",
          HOSTNAME: "",
          KUBERNETES_SERVICE_HOST: "",
          NAMESPACE: "",
          OTEL_BSP_EXPORT_TIMEOUT: 3e4,
          OTEL_BSP_MAX_EXPORT_BATCH_SIZE: 512,
          OTEL_BSP_MAX_QUEUE_SIZE: 2048,
          OTEL_BSP_SCHEDULE_DELAY: 5e3,
          OTEL_EXPORTER_JAEGER_AGENT_HOST: "",
          OTEL_EXPORTER_JAEGER_AGENT_PORT: 6832,
          OTEL_EXPORTER_JAEGER_ENDPOINT: "",
          OTEL_EXPORTER_JAEGER_PASSWORD: "",
          OTEL_EXPORTER_JAEGER_USER: "",
          OTEL_EXPORTER_OTLP_ENDPOINT: "",
          OTEL_EXPORTER_OTLP_TRACES_ENDPOINT: "",
          OTEL_EXPORTER_OTLP_METRICS_ENDPOINT: "",
          OTEL_EXPORTER_OTLP_HEADERS: "",
          OTEL_EXPORTER_OTLP_TRACES_HEADERS: "",
          OTEL_EXPORTER_OTLP_METRICS_HEADERS: "",
          OTEL_EXPORTER_OTLP_TIMEOUT: 1e4,
          OTEL_EXPORTER_OTLP_TRACES_TIMEOUT: 1e4,
          OTEL_EXPORTER_OTLP_METRICS_TIMEOUT: 1e4,
          OTEL_EXPORTER_ZIPKIN_ENDPOINT: "http://localhost:9411/api/v2/spans",
          OTEL_LOG_LEVEL: _opentelemetry_api__WEBPACK_IMPORTED_MODULE_0__.n.INFO,
          OTEL_NO_PATCH_MODULES: [],
          OTEL_PROPAGATORS: ["tracecontext", "baggage"],
          OTEL_RESOURCE_ATTRIBUTES: "",
          OTEL_SERVICE_NAME: "",
          OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT: DEFAULT_ATTRIBUTE_VALUE_LENGTH_LIMIT,
          OTEL_ATTRIBUTE_COUNT_LIMIT: DEFAULT_ATTRIBUTE_COUNT_LIMIT,
          OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT: DEFAULT_ATTRIBUTE_VALUE_LENGTH_LIMIT,
          OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT: DEFAULT_ATTRIBUTE_COUNT_LIMIT,
          OTEL_SPAN_EVENT_COUNT_LIMIT: 128,
          OTEL_SPAN_LINK_COUNT_LIMIT: 128,
          OTEL_TRACES_EXPORTER: "none",
          OTEL_TRACES_SAMPLER: _sampling__WEBPACK_IMPORTED_MODULE_1__.J.ParentBasedAlwaysOn,
          OTEL_TRACES_SAMPLER_ARG: "",
          OTEL_EXPORTER_OTLP_INSECURE: "",
          OTEL_EXPORTER_OTLP_TRACES_INSECURE: "",
          OTEL_EXPORTER_OTLP_METRICS_INSECURE: "",
          OTEL_EXPORTER_OTLP_CERTIFICATE: "",
          OTEL_EXPORTER_OTLP_TRACES_CERTIFICATE: "",
          OTEL_EXPORTER_OTLP_METRICS_CERTIFICATE: "",
          OTEL_EXPORTER_OTLP_COMPRESSION: "",
          OTEL_EXPORTER_OTLP_TRACES_COMPRESSION: "",
          OTEL_EXPORTER_OTLP_METRICS_COMPRESSION: "",
          OTEL_EXPORTER_OTLP_CLIENT_KEY: "",
          OTEL_EXPORTER_OTLP_TRACES_CLIENT_KEY: "",
          OTEL_EXPORTER_OTLP_METRICS_CLIENT_KEY: "",
          OTEL_EXPORTER_OTLP_CLIENT_CERTIFICATE: "",
          OTEL_EXPORTER_OTLP_TRACES_CLIENT_CERTIFICATE: "",
          OTEL_EXPORTER_OTLP_METRICS_CLIENT_CERTIFICATE: ""
        };
        function parseNumber(name, environment, values, min, max) {
          if (min === void 0) {
            min = -Infinity;
          }
          if (max === void 0) {
            max = Infinity;
          }
          if (typeof values[name] !== "undefined") {
            var value = Number(values[name]);
            if (!isNaN(value)) {
              if (value < min) {
                environment[name] = min;
              } else if (value > max) {
                environment[name] = max;
              } else {
                environment[name] = value;
              }
            }
          }
        }
        function parseStringList(name, output, input, separator) {
          if (separator === void 0) {
            separator = DEFAULT_LIST_SEPARATOR;
          }
          var givenValue = input[name];
          if (typeof givenValue === "string") {
            output[name] = givenValue.split(separator).map(function (v) {
              return v.trim();
            });
          }
        }
        var logLevelMap = {
          ALL: _opentelemetry_api__WEBPACK_IMPORTED_MODULE_0__.n.ALL,
          VERBOSE: _opentelemetry_api__WEBPACK_IMPORTED_MODULE_0__.n.VERBOSE,
          DEBUG: _opentelemetry_api__WEBPACK_IMPORTED_MODULE_0__.n.DEBUG,
          INFO: _opentelemetry_api__WEBPACK_IMPORTED_MODULE_0__.n.INFO,
          WARN: _opentelemetry_api__WEBPACK_IMPORTED_MODULE_0__.n.WARN,
          ERROR: _opentelemetry_api__WEBPACK_IMPORTED_MODULE_0__.n.ERROR,
          NONE: _opentelemetry_api__WEBPACK_IMPORTED_MODULE_0__.n.NONE
        };
        function setLogLevelFromEnv(key, environment, values) {
          var value = values[key];
          if (typeof value === "string") {
            var theLevel = logLevelMap[value.toUpperCase()];
            if (theLevel != null) {
              environment[key] = theLevel;
            }
          }
        }
        function parseEnvironment(values) {
          var environment = {};
          for (var env in DEFAULT_ENVIRONMENT) {
            var key = env;
            switch (key) {
              case "OTEL_LOG_LEVEL":
                setLogLevelFromEnv(key, environment, values);
                break;
              default:
                if (isEnvVarANumber(key)) {
                  parseNumber(key, environment, values);
                } else if (isEnvVarAList(key)) {
                  parseStringList(key, environment, values);
                } else {
                  var value = values[key];
                  if (typeof value !== "undefined" && value !== null) {
                    environment[key] = String(value);
                  }
                }
            }
          }
          return environment;
        }
        function getEnvWithoutDefaults() {
          return typeof process !== "undefined" ? parseEnvironment(process.env) : parseEnvironment(_platform_browser_globalThis__WEBPACK_IMPORTED_MODULE_2__.E);
        }
      },
      9: (__unused_webpack_module, __webpack_exports__2, __webpack_require__2) => {
        __webpack_require__2.d(__webpack_exports__2, {
          "T": () => merge
        });
        ;
        var objectTag = "[object Object]";
        var nullTag = "[object Null]";
        var undefinedTag = "[object Undefined]";
        var funcProto = Function.prototype;
        var funcToString = funcProto.toString;
        var objectCtorString = funcToString.call(Object);
        var getPrototype = overArg(Object.getPrototypeOf, Object);
        var objectProto = Object.prototype;
        var lodash_merge_hasOwnProperty = objectProto.hasOwnProperty;
        var symToStringTag = Symbol ? Symbol.toStringTag : void 0;
        var nativeObjectToString = objectProto.toString;
        function overArg(func, transform) {
          return function (arg) {
            return func(transform(arg));
          };
        }
        function isPlainObject(value) {
          if (!isObjectLike(value) || baseGetTag(value) !== objectTag) {
            return false;
          }
          var proto = getPrototype(value);
          if (proto === null) {
            return true;
          }
          var Ctor = lodash_merge_hasOwnProperty.call(proto, "constructor") && proto.constructor;
          return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) === objectCtorString;
        }
        function isObjectLike(value) {
          return value != null && typeof value == "object";
        }
        function baseGetTag(value) {
          if (value == null) {
            return value === void 0 ? undefinedTag : nullTag;
          }
          return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
        }
        function getRawTag(value) {
          var isOwn = lodash_merge_hasOwnProperty.call(value, symToStringTag),
            tag = value[symToStringTag];
          var unmasked = false;
          try {
            value[symToStringTag] = void 0;
            unmasked = true;
          } catch (e) {}
          var result = nativeObjectToString.call(value);
          if (unmasked) {
            if (isOwn) {
              value[symToStringTag] = tag;
            } else {
              delete value[symToStringTag];
            }
          }
          return result;
        }
        function objectToString(value) {
          return nativeObjectToString.call(value);
        }
        ;
        var MAX_LEVEL = 20;
        function merge() {
          var args = [];
          for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
          }
          var result = args.shift();
          var objects = new WeakMap();
          while (args.length > 0) {
            result = mergeTwoObjects(result, args.shift(), 0, objects);
          }
          return result;
        }
        function takeValue(value) {
          if (isArray(value)) {
            return value.slice();
          }
          return value;
        }
        function mergeTwoObjects(one, two, level, objects) {
          if (level === void 0) {
            level = 0;
          }
          var result;
          if (level > MAX_LEVEL) {
            return void 0;
          }
          level++;
          if (isPrimitive(one) || isPrimitive(two) || isFunction(two)) {
            result = takeValue(two);
          } else if (isArray(one)) {
            result = one.slice();
            if (isArray(two)) {
              for (var i = 0, j = two.length; i < j; i++) {
                result.push(takeValue(two[i]));
              }
            } else if (isObject(two)) {
              var keys = Object.keys(two);
              for (var i = 0, j = keys.length; i < j; i++) {
                var key = keys[i];
                result[key] = takeValue(two[key]);
              }
            }
          } else if (isObject(one)) {
            if (isObject(two)) {
              if (!shouldMerge(one, two)) {
                return two;
              }
              result = Object.assign({}, one);
              var keys = Object.keys(two);
              for (var i = 0, j = keys.length; i < j; i++) {
                var key = keys[i];
                var twoValue = two[key];
                if (isPrimitive(twoValue)) {
                  if (typeof twoValue === "undefined") {
                    delete result[key];
                  } else {
                    result[key] = twoValue;
                  }
                } else {
                  var obj1 = result[key];
                  var obj2 = twoValue;
                  if (wasObjectReferenced(one, key, objects) || wasObjectReferenced(two, key, objects)) {
                    delete result[key];
                  } else {
                    if (isObject(obj1) && isObject(obj2)) {
                      var arr1 = objects.get(obj1) || [];
                      var arr2 = objects.get(obj2) || [];
                      arr1.push({
                        obj: one,
                        key
                      });
                      arr2.push({
                        obj: two,
                        key
                      });
                      objects.set(obj1, arr1);
                      objects.set(obj2, arr2);
                    }
                    result[key] = mergeTwoObjects(result[key], twoValue, level, objects);
                  }
                }
              }
            } else {
              result = two;
            }
          }
          return result;
        }
        function wasObjectReferenced(obj, key, objects) {
          var arr = objects.get(obj[key]) || [];
          for (var i = 0, j = arr.length; i < j; i++) {
            var info = arr[i];
            if (info.key === key && info.obj === obj) {
              return true;
            }
          }
          return false;
        }
        function isArray(value) {
          return Array.isArray(value);
        }
        function isFunction(value) {
          return typeof value === "function";
        }
        function isObject(value) {
          return !isPrimitive(value) && !isArray(value) && !isFunction(value) && typeof value === "object";
        }
        function isPrimitive(value) {
          return typeof value === "string" || typeof value === "number" || typeof value === "boolean" || typeof value === "undefined" || value instanceof Date || value instanceof RegExp || value === null;
        }
        function shouldMerge(one, two) {
          if (!isPlainObject(one) || !isPlainObject(two)) {
            return false;
          }
          return true;
        }
      },
      290: (__unused_webpack_module, __webpack_exports__2, __webpack_require__2) => {
        __webpack_require__2.d(__webpack_exports__2, {
          "J": () => TracesSamplerValues
        });
        var TracesSamplerValues;
        (function (TracesSamplerValues2) {
          TracesSamplerValues2["AlwaysOff"] = "always_off";
          TracesSamplerValues2["AlwaysOn"] = "always_on";
          TracesSamplerValues2["ParentBasedAlwaysOff"] = "parentbased_always_off";
          TracesSamplerValues2["ParentBasedAlwaysOn"] = "parentbased_always_on";
          TracesSamplerValues2["ParentBasedTraceIdRatio"] = "parentbased_traceidratio";
          TracesSamplerValues2["TraceIdRatio"] = "traceidratio";
        })(TracesSamplerValues || (TracesSamplerValues = {}));
      },
      923: (__unused_webpack_module, __webpack_exports__2, __webpack_require__2) => {
        __webpack_require__2.d(__webpack_exports__2, {
          "q": () => VERSION
        });
        var VERSION = "1.7.0";
      },
      545: (__unused_webpack_module, __webpack_exports__2, __webpack_require__2) => {
        __webpack_require__2.r(__webpack_exports__2);
        __webpack_require__2.d(__webpack_exports__2, {
          "OTLPTraceExporter": () => OTLPTraceExporter
        });
        var utils = __webpack_require__2(315);
        var environment = __webpack_require__2(580);
        var esm = __webpack_require__2(620);
        var callback = __webpack_require__2(399);
        var ExportResult = __webpack_require__2(420);
        ;
        var __read = function (o, n) {
          var m = typeof Symbol === "function" && o[Symbol.iterator];
          if (!m) return o;
          var i = m.call(o),
            r,
            ar = [],
            e;
          try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
          } catch (error) {
            e = {
              error
            };
          } finally {
            try {
              if (r && !r.done && (m = i["return"])) m.call(i);
            } finally {
              if (e) throw e.error;
            }
          }
          return ar;
        };
        var DEFAULT_TRACE_TIMEOUT = 1e4;
        function parseHeaders(partialHeaders) {
          if (partialHeaders === void 0) {
            partialHeaders = {};
          }
          var headers = {};
          Object.entries(partialHeaders).forEach(function (_a) {
            var _b = __read(_a, 2),
              key = _b[0],
              value = _b[1];
            if (typeof value !== "undefined") {
              headers[key] = String(value);
            } else {
              esm.diag.warn('Header "' + key + '" has wrong value and will be ignored');
            }
          });
          return headers;
        }
        function appendResourcePathToUrl(url, path) {
          if (!url.endsWith("/")) {
            url = url + "/";
          }
          return url + path;
        }
        function appendRootPathToUrlIfNeeded(url, path) {
          if (!url.includes(path) && !url.endsWith("/")) {
            url = url + "/";
          }
          return url;
        }
        function configureExporterTimeout(timeoutMillis) {
          if (typeof timeoutMillis === "number") {
            if (timeoutMillis <= 0) {
              return invalidTimeout(timeoutMillis, DEFAULT_TRACE_TIMEOUT);
            }
            return timeoutMillis;
          } else {
            return getExporterTimeoutFromEnv();
          }
        }
        function getExporterTimeoutFromEnv() {
          var _a;
          var definedTimeout = Number((_a = (0, environment.d)().OTEL_EXPORTER_OTLP_TRACES_TIMEOUT) !== null && _a !== void 0 ? _a : (0, environment.d)().OTEL_EXPORTER_OTLP_TIMEOUT);
          if (definedTimeout <= 0) {
            return invalidTimeout(definedTimeout, DEFAULT_TRACE_TIMEOUT);
          } else {
            return definedTimeout;
          }
        }
        function invalidTimeout(timeout, defaultTimeout) {
          esm.diag.warn("Timeout must be greater than 0", timeout);
          return defaultTimeout;
        }
        ;
        var OTLPExporterBase = function () {
          function OTLPExporterBase2(config) {
            if (config === void 0) {
              config = {};
            }
            this._sendingPromises = [];
            this.url = this.getDefaultUrl(config);
            if (typeof config.hostname === "string") {
              this.hostname = config.hostname;
            }
            this.shutdown = this.shutdown.bind(this);
            this._shutdownOnce = new callback.q(this._shutdown, this);
            this._concurrencyLimit = typeof config.concurrencyLimit === "number" ? config.concurrencyLimit : Infinity;
            this.timeoutMillis = configureExporterTimeout(config.timeoutMillis);
            this.onInit(config);
          }
          OTLPExporterBase2.prototype.export = function (items, resultCallback) {
            if (this._shutdownOnce.isCalled) {
              resultCallback({
                code: ExportResult.I.FAILED,
                error: new Error("Exporter has been shutdown")
              });
              return;
            }
            if (this._sendingPromises.length >= this._concurrencyLimit) {
              resultCallback({
                code: ExportResult.I.FAILED,
                error: new Error("Concurrent export limit reached")
              });
              return;
            }
            this._export(items).then(function () {
              resultCallback({
                code: ExportResult.I.SUCCESS
              });
            }).catch(function (error) {
              resultCallback({
                code: ExportResult.I.FAILED,
                error
              });
            });
          };
          OTLPExporterBase2.prototype._export = function (items) {
            var _this = this;
            return new Promise(function (resolve, reject) {
              try {
                esm.diag.debug("items to be sent", items);
                _this.send(items, resolve, reject);
              } catch (e) {
                reject(e);
              }
            });
          };
          OTLPExporterBase2.prototype.shutdown = function () {
            return this._shutdownOnce.call();
          };
          OTLPExporterBase2.prototype._shutdown = function () {
            esm.diag.debug("shutdown started");
            this.onShutdown();
            return Promise.all(this._sendingPromises).then(function () {});
          };
          return OTLPExporterBase2;
        }();
        ;
        var __extends = function () {
          var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (d2, b2) {
              d2.__proto__ = b2;
            } || function (d2, b2) {
              for (var p in b2) if (Object.prototype.hasOwnProperty.call(b2, p)) d2[p] = b2[p];
            };
            return extendStatics(d, b);
          };
          return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
              this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
          };
        }();
        var OTLPExporterError = function (_super) {
          __extends(OTLPExporterError2, _super);
          function OTLPExporterError2(message, code, data) {
            var _this = _super.call(this, message) || this;
            _this.name = "OTLPExporterError";
            _this.data = data;
            _this.code = code;
            return _this;
          }
          return OTLPExporterError2;
        }(Error);
        ;
        var __assign = function () {
          __assign = Object.assign || function (t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
              s = arguments[i];
              for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
          };
          return __assign.apply(this, arguments);
        };
        var util_read = function (o, n) {
          var m = typeof Symbol === "function" && o[Symbol.iterator];
          if (!m) return o;
          var i = m.call(o),
            r,
            ar = [],
            e;
          try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
          } catch (error) {
            e = {
              error
            };
          } finally {
            try {
              if (r && !r.done && (m = i["return"])) m.call(i);
            } finally {
              if (e) throw e.error;
            }
          }
          return ar;
        };
        function sendWithBeacon(body, url, blobPropertyBag, onSuccess, onError) {
          if (navigator.sendBeacon(url, new Blob([body], blobPropertyBag))) {
            esm.diag.debug("sendBeacon - can send", body);
            onSuccess();
          } else {
            var error = new OTLPExporterError("sendBeacon - cannot send " + body);
            onError(error);
          }
        }
        function sendWithXhr(body, url, headers, exporterTimeout, onSuccess, onError) {
          var reqIsDestroyed;
          var exporterTimer = setTimeout(function () {
            reqIsDestroyed = true;
            xhr.abort();
          }, exporterTimeout);
          var xhr = new XMLHttpRequest();
          xhr.open("POST", url);
          var defaultHeaders = {
            "Accept": "application/json",
            "Content-Type": "application/json"
          };
          Object.entries(__assign(__assign({}, defaultHeaders), headers)).forEach(function (_a) {
            var _b = util_read(_a, 2),
              k = _b[0],
              v = _b[1];
            xhr.setRequestHeader(k, v);
          });
          xhr.send(body);
          xhr.onreadystatechange = function () {
            if (xhr.readyState === XMLHttpRequest.DONE) {
              if (xhr.status >= 200 && xhr.status <= 299) {
                clearTimeout(exporterTimer);
                esm.diag.debug("xhr success", body);
                onSuccess();
              } else if (reqIsDestroyed) {
                var error = new OTLPExporterError("Request Timeout", xhr.status);
                onError(error);
              } else {
                var error = new OTLPExporterError("Failed to export with XHR (status: " + xhr.status + ")", xhr.status);
                clearTimeout(exporterTimer);
                onError(error);
              }
            }
          };
        }
        ;
        var OTLPExporterBrowserBase_extends = function () {
          var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (d2, b2) {
              d2.__proto__ = b2;
            } || function (d2, b2) {
              for (var p in b2) if (Object.prototype.hasOwnProperty.call(b2, p)) d2[p] = b2[p];
            };
            return extendStatics(d, b);
          };
          return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
              this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
          };
        }();
        var OTLPExporterBrowserBase = function (_super) {
          OTLPExporterBrowserBase_extends(OTLPExporterBrowserBase2, _super);
          function OTLPExporterBrowserBase2(config) {
            if (config === void 0) {
              config = {};
            }
            var _this = _super.call(this, config) || this;
            _this._useXHR = false;
            _this._useXHR = !!config.headers || typeof navigator.sendBeacon !== "function";
            if (_this._useXHR) {
              _this._headers = Object.assign({}, parseHeaders(config.headers), utils.parseKeyPairsIntoRecord((0, environment.d)().OTEL_EXPORTER_OTLP_HEADERS));
            } else {
              _this._headers = {};
            }
            return _this;
          }
          OTLPExporterBrowserBase2.prototype.onInit = function () {
            window.addEventListener("unload", this.shutdown);
          };
          OTLPExporterBrowserBase2.prototype.onShutdown = function () {
            window.removeEventListener("unload", this.shutdown);
          };
          OTLPExporterBrowserBase2.prototype.send = function (items, onSuccess, onError) {
            var _this = this;
            if (this._shutdownOnce.isCalled) {
              esm.diag.debug("Shutdown already started. Cannot send objects");
              return;
            }
            var serviceRequest = this.convert(items);
            var body = JSON.stringify(serviceRequest);
            var promise = new Promise(function (resolve, reject) {
              if (_this._useXHR) {
                sendWithXhr(body, _this.url, _this._headers, _this.timeoutMillis, resolve, reject);
              } else {
                sendWithBeacon(body, _this.url, {
                  type: "application/json"
                }, resolve, reject);
              }
            }).then(onSuccess, onError);
            this._sendingPromises.push(promise);
            var popPromise = function () {
              var index = _this._sendingPromises.indexOf(promise);
              _this._sendingPromises.splice(index, 1);
            };
            promise.then(popPromise, popPromise);
          };
          return OTLPExporterBrowserBase2;
        }(OTLPExporterBase);
        ;
        ;
        ;
        var internal_read = function (o, n) {
          var m = typeof Symbol === "function" && o[Symbol.iterator];
          if (!m) return o;
          var i = m.call(o),
            r,
            ar = [],
            e;
          try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
          } catch (error) {
            e = {
              error
            };
          } finally {
            try {
              if (r && !r.done && (m = i["return"])) m.call(i);
            } finally {
              if (e) throw e.error;
            }
          }
          return ar;
        };
        function toAttributes(attributes) {
          return Object.keys(attributes).map(function (key) {
            return toKeyValue(key, attributes[key]);
          });
        }
        function toKeyValue(key, value) {
          return {
            key,
            value: toAnyValue(value)
          };
        }
        function toAnyValue(value) {
          var t = typeof value;
          if (t === "string") return {
            stringValue: value
          };
          if (t === "number") {
            if (!Number.isInteger(value)) return {
              doubleValue: value
            };
            return {
              intValue: value
            };
          }
          if (t === "boolean") return {
            boolValue: value
          };
          if (value instanceof Uint8Array) return {
            bytesValue: value
          };
          if (Array.isArray(value)) return {
            arrayValue: {
              values: value.map(toAnyValue)
            }
          };
          if (t === "object" && value != null) return {
            kvlistValue: {
              values: Object.entries(value).map(function (_a) {
                var _b = internal_read(_a, 2),
                  k = _b[0],
                  v = _b[1];
                return toKeyValue(k, v);
              })
            }
          };
          return {};
        }
        function hexToBuf(hex) {
          var _a;
          var ints = (_a = hex.match(/[\da-f]{2}/gi)) === null || _a === void 0 ? void 0 : _a.map(function (h) {
            return parseInt(h, 16);
          });
          return ints && new Uint8Array(ints);
        }
        function i2hex(i) {
          return ("0" + i.toString(16)).slice(-2);
        }
        function bufToHex(buf) {
          if (buf == null || buf.length === 0) return void 0;
          return Array.from(buf).map(i2hex).join("");
        }
        var time = __webpack_require__2(664);
        var hex_to_base64 = __webpack_require__2(16);
        ;
        function sdkSpanToOtlpSpan(span, useHex) {
          var ctx = span.spanContext();
          var status = span.status;
          var parentSpanId = useHex ? span.parentSpanId : span.parentSpanId != null ? hex_to_base64.W(span.parentSpanId) : void 0;
          return {
            traceId: useHex ? ctx.traceId : hex_to_base64.W(ctx.traceId),
            spanId: useHex ? ctx.spanId : hex_to_base64.W(ctx.spanId),
            parentSpanId,
            name: span.name,
            kind: span.kind == null ? 0 : span.kind + 1,
            startTimeUnixNano: (0, time.PW)(span.startTime),
            endTimeUnixNano: (0, time.PW)(span.endTime),
            attributes: toAttributes(span.attributes),
            droppedAttributesCount: 0,
            events: span.events.map(toOtlpSpanEvent),
            droppedEventsCount: 0,
            status: {
              code: status.code,
              message: status.message
            },
            links: span.links.map(function (link) {
              return toOtlpLink(link, useHex);
            }),
            droppedLinksCount: 0
          };
        }
        function toOtlpLink(link, useHex) {
          return {
            attributes: link.attributes ? toAttributes(link.attributes) : [],
            spanId: useHex ? link.context.spanId : hex_to_base64.W(link.context.spanId),
            traceId: useHex ? link.context.traceId : hex_to_base64.W(link.context.traceId),
            droppedAttributesCount: 0
          };
        }
        function toOtlpSpanEvent(timedEvent) {
          return {
            attributes: timedEvent.attributes ? toAttributes(timedEvent.attributes) : [],
            name: timedEvent.name,
            timeUnixNano: (0, time.PW)(timedEvent.time),
            droppedAttributesCount: 0
          };
        }
        ;
        var __values = function (o) {
          var s = typeof Symbol === "function" && Symbol.iterator,
            m = s && o[s],
            i = 0;
          if (m) return m.call(o);
          if (o && typeof o.length === "number") return {
            next: function () {
              if (o && i >= o.length) o = void 0;
              return {
                value: o && o[i++],
                done: !o
              };
            }
          };
          throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
        };
        var trace_read = function (o, n) {
          var m = typeof Symbol === "function" && o[Symbol.iterator];
          if (!m) return o;
          var i = m.call(o),
            r,
            ar = [],
            e;
          try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
          } catch (error) {
            e = {
              error
            };
          } finally {
            try {
              if (r && !r.done && (m = i["return"])) m.call(i);
            } finally {
              if (e) throw e.error;
            }
          }
          return ar;
        };
        function createExportTraceServiceRequest(spans, useHex) {
          return {
            resourceSpans: spanRecordsToResourceSpans(spans, useHex)
          };
        }
        function createResourceMap(readableSpans) {
          var e_1, _a;
          var resourceMap = new Map();
          try {
            for (var readableSpans_1 = __values(readableSpans), readableSpans_1_1 = readableSpans_1.next(); !readableSpans_1_1.done; readableSpans_1_1 = readableSpans_1.next()) {
              var record = readableSpans_1_1.value;
              var ilmMap = resourceMap.get(record.resource);
              if (!ilmMap) {
                ilmMap = new Map();
                resourceMap.set(record.resource, ilmMap);
              }
              var instrumentationLibraryKey = record.instrumentationLibrary.name + "@" + (record.instrumentationLibrary.version || "") + ":" + (record.instrumentationLibrary.schemaUrl || "");
              var records = ilmMap.get(instrumentationLibraryKey);
              if (!records) {
                records = [];
                ilmMap.set(instrumentationLibraryKey, records);
              }
              records.push(record);
            }
          } catch (e_1_1) {
            e_1 = {
              error: e_1_1
            };
          } finally {
            try {
              if (readableSpans_1_1 && !readableSpans_1_1.done && (_a = readableSpans_1.return)) _a.call(readableSpans_1);
            } finally {
              if (e_1) throw e_1.error;
            }
          }
          return resourceMap;
        }
        function spanRecordsToResourceSpans(readableSpans, useHex) {
          var resourceMap = createResourceMap(readableSpans);
          var out = [];
          var entryIterator = resourceMap.entries();
          var entry = entryIterator.next();
          while (!entry.done) {
            var _a = trace_read(entry.value, 2),
              resource = _a[0],
              ilmMap = _a[1];
            var scopeResourceSpans = [];
            var ilmIterator = ilmMap.values();
            var ilmEntry = ilmIterator.next();
            while (!ilmEntry.done) {
              var scopeSpans = ilmEntry.value;
              if (scopeSpans.length > 0) {
                var _b = scopeSpans[0].instrumentationLibrary,
                  name_1 = _b.name,
                  version = _b.version,
                  schemaUrl = _b.schemaUrl;
                var spans = scopeSpans.map(function (readableSpan) {
                  return sdkSpanToOtlpSpan(readableSpan, useHex);
                });
                scopeResourceSpans.push({
                  scope: {
                    name: name_1,
                    version
                  },
                  spans,
                  schemaUrl
                });
              }
              ilmEntry = ilmIterator.next();
            }
            var transformedSpans = {
              resource: {
                attributes: toAttributes(resource.attributes),
                droppedAttributesCount: 0
              },
              scopeSpans: scopeResourceSpans,
              schemaUrl: void 0
            };
            out.push(transformedSpans);
            entry = entryIterator.next();
          }
          return out;
        }
        ;
        var OTLPTraceExporter_extends = function () {
          var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (d2, b2) {
              d2.__proto__ = b2;
            } || function (d2, b2) {
              for (var p in b2) if (Object.prototype.hasOwnProperty.call(b2, p)) d2[p] = b2[p];
            };
            return extendStatics(d, b);
          };
          return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
              this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
          };
        }();
        var DEFAULT_COLLECTOR_RESOURCE_PATH = "v1/traces";
        var DEFAULT_COLLECTOR_URL = "http://localhost:4318/" + DEFAULT_COLLECTOR_RESOURCE_PATH;
        var OTLPTraceExporter = function (_super) {
          OTLPTraceExporter_extends(OTLPTraceExporter2, _super);
          function OTLPTraceExporter2(config) {
            if (config === void 0) {
              config = {};
            }
            var _this = _super.call(this, config) || this;
            _this._headers = Object.assign(_this._headers, utils.parseKeyPairsIntoRecord((0, environment.d)().OTEL_EXPORTER_OTLP_TRACES_HEADERS));
            return _this;
          }
          OTLPTraceExporter2.prototype.convert = function (spans) {
            return createExportTraceServiceRequest(spans, true);
          };
          OTLPTraceExporter2.prototype.getDefaultUrl = function (config) {
            return typeof config.url === "string" ? config.url : (0, environment.d)().OTEL_EXPORTER_OTLP_TRACES_ENDPOINT.length > 0 ? appendRootPathToUrlIfNeeded((0, environment.d)().OTEL_EXPORTER_OTLP_TRACES_ENDPOINT, DEFAULT_COLLECTOR_RESOURCE_PATH) : (0, environment.d)().OTEL_EXPORTER_OTLP_ENDPOINT.length > 0 ? appendResourcePathToUrl((0, environment.d)().OTEL_EXPORTER_OTLP_ENDPOINT, DEFAULT_COLLECTOR_RESOURCE_PATH) : DEFAULT_COLLECTOR_URL;
          };
          return OTLPTraceExporter2;
        }(OTLPExporterBrowserBase);
        ;
        ;
      },
      879: (__unused_webpack_module, __webpack_exports__2, __webpack_require__2) => {
        __webpack_require__2.d(__webpack_exports__2, {
          "_": () => Resource
        });
        var _opentelemetry_semantic_conventions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__2(364);
        var _opentelemetry_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__2(511);
        var _platform__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__2(186);
        var Resource = function () {
          function Resource2(attributes) {
            this.attributes = attributes;
          }
          Resource2.empty = function () {
            return Resource2.EMPTY;
          };
          Resource2.default = function () {
            var _a;
            return new Resource2((_a = {}, _a[_opentelemetry_semantic_conventions__WEBPACK_IMPORTED_MODULE_0__.R9.SERVICE_NAME] = (0, _platform__WEBPACK_IMPORTED_MODULE_1__.u)(), _a[_opentelemetry_semantic_conventions__WEBPACK_IMPORTED_MODULE_0__.R9.TELEMETRY_SDK_LANGUAGE] = _opentelemetry_core__WEBPACK_IMPORTED_MODULE_2__.m[_opentelemetry_semantic_conventions__WEBPACK_IMPORTED_MODULE_0__.R9.TELEMETRY_SDK_LANGUAGE], _a[_opentelemetry_semantic_conventions__WEBPACK_IMPORTED_MODULE_0__.R9.TELEMETRY_SDK_NAME] = _opentelemetry_core__WEBPACK_IMPORTED_MODULE_2__.m[_opentelemetry_semantic_conventions__WEBPACK_IMPORTED_MODULE_0__.R9.TELEMETRY_SDK_NAME], _a[_opentelemetry_semantic_conventions__WEBPACK_IMPORTED_MODULE_0__.R9.TELEMETRY_SDK_VERSION] = _opentelemetry_core__WEBPACK_IMPORTED_MODULE_2__.m[_opentelemetry_semantic_conventions__WEBPACK_IMPORTED_MODULE_0__.R9.TELEMETRY_SDK_VERSION], _a));
          };
          Resource2.prototype.merge = function (other) {
            if (!other || !Object.keys(other.attributes).length) return this;
            var mergedAttributes = Object.assign({}, this.attributes, other.attributes);
            return new Resource2(mergedAttributes);
          };
          Resource2.EMPTY = new Resource2({});
          return Resource2;
        }();
      },
      183: (__unused_webpack_module, __webpack_exports__2, __webpack_require__2) => {
        __webpack_require__2.r(__webpack_exports__2);
        __webpack_require__2.d(__webpack_exports__2, {
          "Resource": () => Resource._,
          "browserDetector": () => browserDetector,
          "defaultServiceName": () => default_service_name.u,
          "detectResources": () => detectResources,
          "envDetector": () => envDetector,
          "hostDetector": () => hostDetector,
          "osDetector": () => osDetector,
          "processDetector": () => processDetector
        });
        var Resource = __webpack_require__2(879);
        var default_service_name = __webpack_require__2(186);
        var esm = __webpack_require__2(620);
        ;
        var __awaiter = function (thisArg, _arguments, P, generator) {
          function adopt(value) {
            return value instanceof P ? value : new P(function (resolve) {
              resolve(value);
            });
          }
          return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) {
              try {
                step(generator.next(value));
              } catch (e) {
                reject(e);
              }
            }
            function rejected(value) {
              try {
                step(generator["throw"](value));
              } catch (e) {
                reject(e);
              }
            }
            function step(result) {
              result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
          });
        };
        var __generator = function (thisArg, body) {
          var _ = {
              label: 0,
              sent: function () {
                if (t[0] & 1) throw t[1];
                return t[1];
              },
              trys: [],
              ops: []
            },
            f,
            y,
            t,
            g;
          return g = {
            next: verb(0),
            "throw": verb(1),
            "return": verb(2)
          }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
            return this;
          }), g;
          function verb(n) {
            return function (v) {
              return step([n, v]);
            };
          }
          function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_) try {
              if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
              if (y = 0, t) op = [op[0] & 2, t.value];
              switch (op[0]) {
                case 0:
                case 1:
                  t = op;
                  break;
                case 4:
                  _.label++;
                  return {
                    value: op[1],
                    done: false
                  };
                case 5:
                  _.label++;
                  y = op[1];
                  op = [0];
                  continue;
                case 7:
                  op = _.ops.pop();
                  _.trys.pop();
                  continue;
                default:
                  if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                    _ = 0;
                    continue;
                  }
                  if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                    _.label = op[1];
                    break;
                  }
                  if (op[0] === 6 && _.label < t[1]) {
                    _.label = t[1];
                    t = op;
                    break;
                  }
                  if (t && _.label < t[2]) {
                    _.label = t[2];
                    _.ops.push(op);
                    break;
                  }
                  if (t[2]) _.ops.pop();
                  _.trys.pop();
                  continue;
              }
              op = body.call(thisArg, _);
            } catch (e) {
              op = [6, e];
              y = 0;
            } finally {
              f = t = 0;
            }
            if (op[0] & 5) throw op[1];
            return {
              value: op[0] ? op[1] : void 0,
              done: true
            };
          }
        };
        var detectResources = function (config) {
          if (config === void 0) {
            config = {};
          }
          return __awaiter(void 0, void 0, void 0, function () {
            var internalConfig, resources;
            return __generator(this, function (_a) {
              switch (_a.label) {
                case 0:
                  internalConfig = Object.assign(config);
                  return [4, Promise.all((internalConfig.detectors || []).map(function (d) {
                    return __awaiter(void 0, void 0, void 0, function () {
                      var resource, e_1;
                      return __generator(this, function (_a2) {
                        switch (_a2.label) {
                          case 0:
                            _a2.trys.push([0, 2,, 3]);
                            return [4, d.detect(internalConfig)];
                          case 1:
                            resource = _a2.sent();
                            esm.diag.debug(d.constructor.name + " found resource.", resource);
                            return [2, resource];
                          case 2:
                            e_1 = _a2.sent();
                            esm.diag.debug(d.constructor.name + " failed: " + e_1.message);
                            return [2, Resource._.empty()];
                          case 3:
                            return [2];
                        }
                      });
                    });
                  }))];
                case 1:
                  resources = _a.sent();
                  return [2, resources.reduce(function (acc, resource) {
                    return acc.merge(resource);
                  }, Resource._.empty())];
              }
            });
          });
        };
        ;
        var NoopDetector_awaiter = function (thisArg, _arguments, P, generator) {
          function adopt(value) {
            return value instanceof P ? value : new P(function (resolve) {
              resolve(value);
            });
          }
          return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) {
              try {
                step(generator.next(value));
              } catch (e) {
                reject(e);
              }
            }
            function rejected(value) {
              try {
                step(generator["throw"](value));
              } catch (e) {
                reject(e);
              }
            }
            function step(result) {
              result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
          });
        };
        var NoopDetector_generator = function (thisArg, body) {
          var _ = {
              label: 0,
              sent: function () {
                if (t[0] & 1) throw t[1];
                return t[1];
              },
              trys: [],
              ops: []
            },
            f,
            y,
            t,
            g;
          return g = {
            next: verb(0),
            "throw": verb(1),
            "return": verb(2)
          }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
            return this;
          }), g;
          function verb(n) {
            return function (v) {
              return step([n, v]);
            };
          }
          function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_) try {
              if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
              if (y = 0, t) op = [op[0] & 2, t.value];
              switch (op[0]) {
                case 0:
                case 1:
                  t = op;
                  break;
                case 4:
                  _.label++;
                  return {
                    value: op[1],
                    done: false
                  };
                case 5:
                  _.label++;
                  y = op[1];
                  op = [0];
                  continue;
                case 7:
                  op = _.ops.pop();
                  _.trys.pop();
                  continue;
                default:
                  if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                    _ = 0;
                    continue;
                  }
                  if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                    _.label = op[1];
                    break;
                  }
                  if (op[0] === 6 && _.label < t[1]) {
                    _.label = t[1];
                    t = op;
                    break;
                  }
                  if (t && _.label < t[2]) {
                    _.label = t[2];
                    _.ops.push(op);
                    break;
                  }
                  if (t[2]) _.ops.pop();
                  _.trys.pop();
                  continue;
              }
              op = body.call(thisArg, _);
            } catch (e) {
              op = [6, e];
              y = 0;
            } finally {
              f = t = 0;
            }
            if (op[0] & 5) throw op[1];
            return {
              value: op[0] ? op[1] : void 0,
              done: true
            };
          }
        };
        var NoopDetector = function () {
          function NoopDetector2() {}
          NoopDetector2.prototype.detect = function () {
            return NoopDetector_awaiter(this, void 0, void 0, function () {
              return NoopDetector_generator(this, function (_a) {
                return [2, new Resource._({})];
              });
            });
          };
          return NoopDetector2;
        }();
        var noopDetector = new NoopDetector();
        ;
        var hostDetector = noopDetector;
        ;
        var osDetector = noopDetector;
        ;
        var SemanticResourceAttributes = __webpack_require__2(364);
        ;
        var __assign = function () {
          __assign = Object.assign || function (t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
              s = arguments[i];
              for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
          };
          return __assign.apply(this, arguments);
        };
        var BrowserDetector_awaiter = function (thisArg, _arguments, P, generator) {
          function adopt(value) {
            return value instanceof P ? value : new P(function (resolve) {
              resolve(value);
            });
          }
          return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) {
              try {
                step(generator.next(value));
              } catch (e) {
                reject(e);
              }
            }
            function rejected(value) {
              try {
                step(generator["throw"](value));
              } catch (e) {
                reject(e);
              }
            }
            function step(result) {
              result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
          });
        };
        var BrowserDetector_generator = function (thisArg, body) {
          var _ = {
              label: 0,
              sent: function () {
                if (t[0] & 1) throw t[1];
                return t[1];
              },
              trys: [],
              ops: []
            },
            f,
            y,
            t,
            g;
          return g = {
            next: verb(0),
            "throw": verb(1),
            "return": verb(2)
          }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
            return this;
          }), g;
          function verb(n) {
            return function (v) {
              return step([n, v]);
            };
          }
          function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_) try {
              if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
              if (y = 0, t) op = [op[0] & 2, t.value];
              switch (op[0]) {
                case 0:
                case 1:
                  t = op;
                  break;
                case 4:
                  _.label++;
                  return {
                    value: op[1],
                    done: false
                  };
                case 5:
                  _.label++;
                  y = op[1];
                  op = [0];
                  continue;
                case 7:
                  op = _.ops.pop();
                  _.trys.pop();
                  continue;
                default:
                  if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                    _ = 0;
                    continue;
                  }
                  if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                    _.label = op[1];
                    break;
                  }
                  if (op[0] === 6 && _.label < t[1]) {
                    _.label = t[1];
                    t = op;
                    break;
                  }
                  if (t && _.label < t[2]) {
                    _.label = t[2];
                    _.ops.push(op);
                    break;
                  }
                  if (t[2]) _.ops.pop();
                  _.trys.pop();
                  continue;
              }
              op = body.call(thisArg, _);
            } catch (e) {
              op = [6, e];
              y = 0;
            } finally {
              f = t = 0;
            }
            if (op[0] & 5) throw op[1];
            return {
              value: op[0] ? op[1] : void 0,
              done: true
            };
          }
        };
        var BrowserDetector = function () {
          function BrowserDetector2() {}
          BrowserDetector2.prototype.detect = function (config) {
            return BrowserDetector_awaiter(this, void 0, void 0, function () {
              var isBrowser, browserResource;
              var _a;
              return BrowserDetector_generator(this, function (_b) {
                isBrowser = typeof navigator !== "undefined";
                if (!isBrowser) {
                  return [2, Resource._.empty()];
                }
                browserResource = (_a = {}, _a[SemanticResourceAttributes.R9.PROCESS_RUNTIME_NAME] = "browser", _a[SemanticResourceAttributes.R9.PROCESS_RUNTIME_DESCRIPTION] = "Web Browser", _a[SemanticResourceAttributes.R9.PROCESS_RUNTIME_VERSION] = navigator.userAgent, _a);
                return [2, this._getResourceAttributes(browserResource, config)];
              });
            });
          };
          BrowserDetector2.prototype._getResourceAttributes = function (browserResource, _config) {
            if (browserResource[SemanticResourceAttributes.R9.PROCESS_RUNTIME_VERSION] === "") {
              esm.diag.debug("BrowserDetector failed: Unable to find required browser resources. ");
              return Resource._.empty();
            } else {
              return new Resource._(__assign({}, browserResource));
            }
          };
          return BrowserDetector2;
        }();
        var browserDetector = new BrowserDetector();
        var environment = __webpack_require__2(580);
        ;
        var EnvDetector_awaiter = function (thisArg, _arguments, P, generator) {
          function adopt(value) {
            return value instanceof P ? value : new P(function (resolve) {
              resolve(value);
            });
          }
          return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) {
              try {
                step(generator.next(value));
              } catch (e) {
                reject(e);
              }
            }
            function rejected(value) {
              try {
                step(generator["throw"](value));
              } catch (e) {
                reject(e);
              }
            }
            function step(result) {
              result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
          });
        };
        var EnvDetector_generator = function (thisArg, body) {
          var _ = {
              label: 0,
              sent: function () {
                if (t[0] & 1) throw t[1];
                return t[1];
              },
              trys: [],
              ops: []
            },
            f,
            y,
            t,
            g;
          return g = {
            next: verb(0),
            "throw": verb(1),
            "return": verb(2)
          }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
            return this;
          }), g;
          function verb(n) {
            return function (v) {
              return step([n, v]);
            };
          }
          function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_) try {
              if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
              if (y = 0, t) op = [op[0] & 2, t.value];
              switch (op[0]) {
                case 0:
                case 1:
                  t = op;
                  break;
                case 4:
                  _.label++;
                  return {
                    value: op[1],
                    done: false
                  };
                case 5:
                  _.label++;
                  y = op[1];
                  op = [0];
                  continue;
                case 7:
                  op = _.ops.pop();
                  _.trys.pop();
                  continue;
                default:
                  if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                    _ = 0;
                    continue;
                  }
                  if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                    _.label = op[1];
                    break;
                  }
                  if (op[0] === 6 && _.label < t[1]) {
                    _.label = t[1];
                    t = op;
                    break;
                  }
                  if (t && _.label < t[2]) {
                    _.label = t[2];
                    _.ops.push(op);
                    break;
                  }
                  if (t[2]) _.ops.pop();
                  _.trys.pop();
                  continue;
              }
              op = body.call(thisArg, _);
            } catch (e) {
              op = [6, e];
              y = 0;
            } finally {
              f = t = 0;
            }
            if (op[0] & 5) throw op[1];
            return {
              value: op[0] ? op[1] : void 0,
              done: true
            };
          }
        };
        var __values = function (o) {
          var s = typeof Symbol === "function" && Symbol.iterator,
            m = s && o[s],
            i = 0;
          if (m) return m.call(o);
          if (o && typeof o.length === "number") return {
            next: function () {
              if (o && i >= o.length) o = void 0;
              return {
                value: o && o[i++],
                done: !o
              };
            }
          };
          throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
        };
        var __read = function (o, n) {
          var m = typeof Symbol === "function" && o[Symbol.iterator];
          if (!m) return o;
          var i = m.call(o),
            r,
            ar = [],
            e;
          try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
          } catch (error) {
            e = {
              error
            };
          } finally {
            try {
              if (r && !r.done && (m = i["return"])) m.call(i);
            } finally {
              if (e) throw e.error;
            }
          }
          return ar;
        };
        var EnvDetector = function () {
          function EnvDetector2() {
            this._MAX_LENGTH = 255;
            this._COMMA_SEPARATOR = ",";
            this._LABEL_KEY_VALUE_SPLITTER = "=";
            this._ERROR_MESSAGE_INVALID_CHARS = "should be a ASCII string with a length greater than 0 and not exceed " + this._MAX_LENGTH + " characters.";
            this._ERROR_MESSAGE_INVALID_VALUE = "should be a ASCII string with a length not exceed " + this._MAX_LENGTH + " characters.";
          }
          EnvDetector2.prototype.detect = function (_config) {
            return EnvDetector_awaiter(this, void 0, void 0, function () {
              var attributes, env, rawAttributes, serviceName, parsedAttributes;
              return EnvDetector_generator(this, function (_a) {
                attributes = {};
                env = (0, environment.d)();
                rawAttributes = env.OTEL_RESOURCE_ATTRIBUTES;
                serviceName = env.OTEL_SERVICE_NAME;
                if (rawAttributes) {
                  try {
                    parsedAttributes = this._parseResourceAttributes(rawAttributes);
                    Object.assign(attributes, parsedAttributes);
                  } catch (e) {
                    esm.diag.debug("EnvDetector failed: " + e.message);
                  }
                }
                if (serviceName) {
                  attributes[SemanticResourceAttributes.R9.SERVICE_NAME] = serviceName;
                }
                return [2, new Resource._(attributes)];
              });
            });
          };
          EnvDetector2.prototype._parseResourceAttributes = function (rawEnvAttributes) {
            var e_1, _a;
            if (!rawEnvAttributes) return {};
            var attributes = {};
            var rawAttributes = rawEnvAttributes.split(this._COMMA_SEPARATOR, -1);
            try {
              for (var rawAttributes_1 = __values(rawAttributes), rawAttributes_1_1 = rawAttributes_1.next(); !rawAttributes_1_1.done; rawAttributes_1_1 = rawAttributes_1.next()) {
                var rawAttribute = rawAttributes_1_1.value;
                var keyValuePair = rawAttribute.split(this._LABEL_KEY_VALUE_SPLITTER, -1);
                if (keyValuePair.length !== 2) {
                  continue;
                }
                var _b = __read(keyValuePair, 2),
                  key = _b[0],
                  value = _b[1];
                key = key.trim();
                value = value.trim().split('^"|"$').join("");
                if (!this._isValidAndNotEmpty(key)) {
                  throw new Error("Attribute key " + this._ERROR_MESSAGE_INVALID_CHARS);
                }
                if (!this._isValid(value)) {
                  throw new Error("Attribute value " + this._ERROR_MESSAGE_INVALID_VALUE);
                }
                attributes[key] = value;
              }
            } catch (e_1_1) {
              e_1 = {
                error: e_1_1
              };
            } finally {
              try {
                if (rawAttributes_1_1 && !rawAttributes_1_1.done && (_a = rawAttributes_1.return)) _a.call(rawAttributes_1);
              } finally {
                if (e_1) throw e_1.error;
              }
            }
            return attributes;
          };
          EnvDetector2.prototype._isValid = function (name) {
            return name.length <= this._MAX_LENGTH && this._isPrintableString(name);
          };
          EnvDetector2.prototype._isPrintableString = function (str) {
            for (var i = 0; i < str.length; i++) {
              var ch = str.charAt(i);
              if (ch <= " " || ch >= "~") {
                return false;
              }
            }
            return true;
          };
          EnvDetector2.prototype._isValidAndNotEmpty = function (str) {
            return str.length > 0 && this._isValid(str);
          };
          return EnvDetector2;
        }();
        var envDetector = new EnvDetector();
        ;
        var ProcessDetector_assign = function () {
          ProcessDetector_assign = Object.assign || function (t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
              s = arguments[i];
              for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
          };
          return ProcessDetector_assign.apply(this, arguments);
        };
        var ProcessDetector_awaiter = function (thisArg, _arguments, P, generator) {
          function adopt(value) {
            return value instanceof P ? value : new P(function (resolve) {
              resolve(value);
            });
          }
          return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) {
              try {
                step(generator.next(value));
              } catch (e) {
                reject(e);
              }
            }
            function rejected(value) {
              try {
                step(generator["throw"](value));
              } catch (e) {
                reject(e);
              }
            }
            function step(result) {
              result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
          });
        };
        var ProcessDetector_generator = function (thisArg, body) {
          var _ = {
              label: 0,
              sent: function () {
                if (t[0] & 1) throw t[1];
                return t[1];
              },
              trys: [],
              ops: []
            },
            f,
            y,
            t,
            g;
          return g = {
            next: verb(0),
            "throw": verb(1),
            "return": verb(2)
          }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
            return this;
          }), g;
          function verb(n) {
            return function (v) {
              return step([n, v]);
            };
          }
          function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_) try {
              if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
              if (y = 0, t) op = [op[0] & 2, t.value];
              switch (op[0]) {
                case 0:
                case 1:
                  t = op;
                  break;
                case 4:
                  _.label++;
                  return {
                    value: op[1],
                    done: false
                  };
                case 5:
                  _.label++;
                  y = op[1];
                  op = [0];
                  continue;
                case 7:
                  op = _.ops.pop();
                  _.trys.pop();
                  continue;
                default:
                  if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                    _ = 0;
                    continue;
                  }
                  if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                    _.label = op[1];
                    break;
                  }
                  if (op[0] === 6 && _.label < t[1]) {
                    _.label = t[1];
                    t = op;
                    break;
                  }
                  if (t && _.label < t[2]) {
                    _.label = t[2];
                    _.ops.push(op);
                    break;
                  }
                  if (t[2]) _.ops.pop();
                  _.trys.pop();
                  continue;
              }
              op = body.call(thisArg, _);
            } catch (e) {
              op = [6, e];
              y = 0;
            } finally {
              f = t = 0;
            }
            if (op[0] & 5) throw op[1];
            return {
              value: op[0] ? op[1] : void 0,
              done: true
            };
          }
        };
        var ProcessDetector = function () {
          function ProcessDetector2() {}
          ProcessDetector2.prototype.detect = function (config) {
            return ProcessDetector_awaiter(this, void 0, void 0, function () {
              var processResource;
              var _a;
              return ProcessDetector_generator(this, function (_b) {
                if (typeof process !== "object") {
                  return [2, Resource._.empty()];
                }
                processResource = (_a = {}, _a[SemanticResourceAttributes.R9.PROCESS_PID] = process.pid, _a[SemanticResourceAttributes.R9.PROCESS_EXECUTABLE_NAME] = process.title || "", _a[SemanticResourceAttributes.R9.PROCESS_COMMAND] = process.argv[1] || "", _a[SemanticResourceAttributes.R9.PROCESS_COMMAND_LINE] = process.argv.join(" ") || "", _a[SemanticResourceAttributes.R9.PROCESS_RUNTIME_VERSION] = process.versions.node, _a[SemanticResourceAttributes.R9.PROCESS_RUNTIME_NAME] = "nodejs", _a[SemanticResourceAttributes.R9.PROCESS_RUNTIME_DESCRIPTION] = "Node.js", _a);
                return [2, this._getResourceAttributes(processResource, config)];
              });
            });
          };
          ProcessDetector2.prototype._getResourceAttributes = function (processResource, _config) {
            if (processResource[SemanticResourceAttributes.R9.PROCESS_EXECUTABLE_NAME] === "" || processResource[SemanticResourceAttributes.R9.PROCESS_EXECUTABLE_PATH] === "" || processResource[SemanticResourceAttributes.R9.PROCESS_COMMAND] === "" || processResource[SemanticResourceAttributes.R9.PROCESS_COMMAND_LINE] === "" || processResource[SemanticResourceAttributes.R9.PROCESS_RUNTIME_VERSION] === "") {
              esm.diag.debug("ProcessDetector failed: Unable to find required process resources. ");
              return Resource._.empty();
            } else {
              return new Resource._(ProcessDetector_assign({}, processResource));
            }
          };
          return ProcessDetector2;
        }();
        var processDetector = new ProcessDetector();
        ;
        ;
      },
      186: (__unused_webpack_module, __webpack_exports__2, __webpack_require__2) => {
        __webpack_require__2.d(__webpack_exports__2, {
          "u": () => defaultServiceName
        });
        function defaultServiceName() {
          return "unknown_service";
        }
      },
      354: (__unused_webpack_module, __webpack_exports__2, __webpack_require__2) => {
        __webpack_require__2.r(__webpack_exports__2);
        __webpack_require__2.d(__webpack_exports__2, {
          "AlwaysOffSampler": () => AlwaysOffSampler,
          "AlwaysOnSampler": () => AlwaysOnSampler,
          "BasicTracerProvider": () => BasicTracerProvider,
          "BatchSpanProcessor": () => BatchSpanProcessor,
          "ConsoleSpanExporter": () => ConsoleSpanExporter,
          "ForceFlushState": () => ForceFlushState,
          "InMemorySpanExporter": () => InMemorySpanExporter,
          "NoopSpanProcessor": () => NoopSpanProcessor,
          "ParentBasedSampler": () => ParentBasedSampler,
          "RandomIdGenerator": () => RandomIdGenerator,
          "SamplingDecision": () => SamplingDecision,
          "SimpleSpanProcessor": () => SimpleSpanProcessor,
          "Span": () => Span,
          "TraceIdRatioBasedSampler": () => TraceIdRatioBasedSampler,
          "Tracer": () => Tracer
        });
        var esm = __webpack_require__2(620);
        var invalid_span_constants = __webpack_require__2(7);
        var span_kind = __webpack_require__2(87);
        var SamplingResult = __webpack_require__2(227);
        var trace_flags = __webpack_require__2(726);
        var anchored_clock = __webpack_require__2(706);
        var performance2 = __webpack_require__2(383);
        var suppress_tracing = __webpack_require__2(397);
        var common_attributes = __webpack_require__2(551);
        var trace_status = __webpack_require__2(820);
        var time = __webpack_require__2(664);
        ;
        var SemanticAttributes = {
          AWS_LAMBDA_INVOKED_ARN: "aws.lambda.invoked_arn",
          DB_SYSTEM: "db.system",
          DB_CONNECTION_STRING: "db.connection_string",
          DB_USER: "db.user",
          DB_JDBC_DRIVER_CLASSNAME: "db.jdbc.driver_classname",
          DB_NAME: "db.name",
          DB_STATEMENT: "db.statement",
          DB_OPERATION: "db.operation",
          DB_MSSQL_INSTANCE_NAME: "db.mssql.instance_name",
          DB_CASSANDRA_KEYSPACE: "db.cassandra.keyspace",
          DB_CASSANDRA_PAGE_SIZE: "db.cassandra.page_size",
          DB_CASSANDRA_CONSISTENCY_LEVEL: "db.cassandra.consistency_level",
          DB_CASSANDRA_TABLE: "db.cassandra.table",
          DB_CASSANDRA_IDEMPOTENCE: "db.cassandra.idempotence",
          DB_CASSANDRA_SPECULATIVE_EXECUTION_COUNT: "db.cassandra.speculative_execution_count",
          DB_CASSANDRA_COORDINATOR_ID: "db.cassandra.coordinator.id",
          DB_CASSANDRA_COORDINATOR_DC: "db.cassandra.coordinator.dc",
          DB_HBASE_NAMESPACE: "db.hbase.namespace",
          DB_REDIS_DATABASE_INDEX: "db.redis.database_index",
          DB_MONGODB_COLLECTION: "db.mongodb.collection",
          DB_SQL_TABLE: "db.sql.table",
          EXCEPTION_TYPE: "exception.type",
          EXCEPTION_MESSAGE: "exception.message",
          EXCEPTION_STACKTRACE: "exception.stacktrace",
          EXCEPTION_ESCAPED: "exception.escaped",
          FAAS_TRIGGER: "faas.trigger",
          FAAS_EXECUTION: "faas.execution",
          FAAS_DOCUMENT_COLLECTION: "faas.document.collection",
          FAAS_DOCUMENT_OPERATION: "faas.document.operation",
          FAAS_DOCUMENT_TIME: "faas.document.time",
          FAAS_DOCUMENT_NAME: "faas.document.name",
          FAAS_TIME: "faas.time",
          FAAS_CRON: "faas.cron",
          FAAS_COLDSTART: "faas.coldstart",
          FAAS_INVOKED_NAME: "faas.invoked_name",
          FAAS_INVOKED_PROVIDER: "faas.invoked_provider",
          FAAS_INVOKED_REGION: "faas.invoked_region",
          NET_TRANSPORT: "net.transport",
          NET_PEER_IP: "net.peer.ip",
          NET_PEER_PORT: "net.peer.port",
          NET_PEER_NAME: "net.peer.name",
          NET_HOST_IP: "net.host.ip",
          NET_HOST_PORT: "net.host.port",
          NET_HOST_NAME: "net.host.name",
          NET_HOST_CONNECTION_TYPE: "net.host.connection.type",
          NET_HOST_CONNECTION_SUBTYPE: "net.host.connection.subtype",
          NET_HOST_CARRIER_NAME: "net.host.carrier.name",
          NET_HOST_CARRIER_MCC: "net.host.carrier.mcc",
          NET_HOST_CARRIER_MNC: "net.host.carrier.mnc",
          NET_HOST_CARRIER_ICC: "net.host.carrier.icc",
          PEER_SERVICE: "peer.service",
          ENDUSER_ID: "enduser.id",
          ENDUSER_ROLE: "enduser.role",
          ENDUSER_SCOPE: "enduser.scope",
          THREAD_ID: "thread.id",
          THREAD_NAME: "thread.name",
          CODE_FUNCTION: "code.function",
          CODE_NAMESPACE: "code.namespace",
          CODE_FILEPATH: "code.filepath",
          CODE_LINENO: "code.lineno",
          HTTP_METHOD: "http.method",
          HTTP_URL: "http.url",
          HTTP_TARGET: "http.target",
          HTTP_HOST: "http.host",
          HTTP_SCHEME: "http.scheme",
          HTTP_STATUS_CODE: "http.status_code",
          HTTP_FLAVOR: "http.flavor",
          HTTP_USER_AGENT: "http.user_agent",
          HTTP_REQUEST_CONTENT_LENGTH: "http.request_content_length",
          HTTP_REQUEST_CONTENT_LENGTH_UNCOMPRESSED: "http.request_content_length_uncompressed",
          HTTP_RESPONSE_CONTENT_LENGTH: "http.response_content_length",
          HTTP_RESPONSE_CONTENT_LENGTH_UNCOMPRESSED: "http.response_content_length_uncompressed",
          HTTP_SERVER_NAME: "http.server_name",
          HTTP_ROUTE: "http.route",
          HTTP_CLIENT_IP: "http.client_ip",
          AWS_DYNAMODB_TABLE_NAMES: "aws.dynamodb.table_names",
          AWS_DYNAMODB_CONSUMED_CAPACITY: "aws.dynamodb.consumed_capacity",
          AWS_DYNAMODB_ITEM_COLLECTION_METRICS: "aws.dynamodb.item_collection_metrics",
          AWS_DYNAMODB_PROVISIONED_READ_CAPACITY: "aws.dynamodb.provisioned_read_capacity",
          AWS_DYNAMODB_PROVISIONED_WRITE_CAPACITY: "aws.dynamodb.provisioned_write_capacity",
          AWS_DYNAMODB_CONSISTENT_READ: "aws.dynamodb.consistent_read",
          AWS_DYNAMODB_PROJECTION: "aws.dynamodb.projection",
          AWS_DYNAMODB_LIMIT: "aws.dynamodb.limit",
          AWS_DYNAMODB_ATTRIBUTES_TO_GET: "aws.dynamodb.attributes_to_get",
          AWS_DYNAMODB_INDEX_NAME: "aws.dynamodb.index_name",
          AWS_DYNAMODB_SELECT: "aws.dynamodb.select",
          AWS_DYNAMODB_GLOBAL_SECONDARY_INDEXES: "aws.dynamodb.global_secondary_indexes",
          AWS_DYNAMODB_LOCAL_SECONDARY_INDEXES: "aws.dynamodb.local_secondary_indexes",
          AWS_DYNAMODB_EXCLUSIVE_START_TABLE: "aws.dynamodb.exclusive_start_table",
          AWS_DYNAMODB_TABLE_COUNT: "aws.dynamodb.table_count",
          AWS_DYNAMODB_SCAN_FORWARD: "aws.dynamodb.scan_forward",
          AWS_DYNAMODB_SEGMENT: "aws.dynamodb.segment",
          AWS_DYNAMODB_TOTAL_SEGMENTS: "aws.dynamodb.total_segments",
          AWS_DYNAMODB_COUNT: "aws.dynamodb.count",
          AWS_DYNAMODB_SCANNED_COUNT: "aws.dynamodb.scanned_count",
          AWS_DYNAMODB_ATTRIBUTE_DEFINITIONS: "aws.dynamodb.attribute_definitions",
          AWS_DYNAMODB_GLOBAL_SECONDARY_INDEX_UPDATES: "aws.dynamodb.global_secondary_index_updates",
          MESSAGING_SYSTEM: "messaging.system",
          MESSAGING_DESTINATION: "messaging.destination",
          MESSAGING_DESTINATION_KIND: "messaging.destination_kind",
          MESSAGING_TEMP_DESTINATION: "messaging.temp_destination",
          MESSAGING_PROTOCOL: "messaging.protocol",
          MESSAGING_PROTOCOL_VERSION: "messaging.protocol_version",
          MESSAGING_URL: "messaging.url",
          MESSAGING_MESSAGE_ID: "messaging.message_id",
          MESSAGING_CONVERSATION_ID: "messaging.conversation_id",
          MESSAGING_MESSAGE_PAYLOAD_SIZE_BYTES: "messaging.message_payload_size_bytes",
          MESSAGING_MESSAGE_PAYLOAD_COMPRESSED_SIZE_BYTES: "messaging.message_payload_compressed_size_bytes",
          MESSAGING_OPERATION: "messaging.operation",
          MESSAGING_CONSUMER_ID: "messaging.consumer_id",
          MESSAGING_RABBITMQ_ROUTING_KEY: "messaging.rabbitmq.routing_key",
          MESSAGING_KAFKA_MESSAGE_KEY: "messaging.kafka.message_key",
          MESSAGING_KAFKA_CONSUMER_GROUP: "messaging.kafka.consumer_group",
          MESSAGING_KAFKA_CLIENT_ID: "messaging.kafka.client_id",
          MESSAGING_KAFKA_PARTITION: "messaging.kafka.partition",
          MESSAGING_KAFKA_TOMBSTONE: "messaging.kafka.tombstone",
          RPC_SYSTEM: "rpc.system",
          RPC_SERVICE: "rpc.service",
          RPC_METHOD: "rpc.method",
          RPC_GRPC_STATUS_CODE: "rpc.grpc.status_code",
          RPC_JSONRPC_VERSION: "rpc.jsonrpc.version",
          RPC_JSONRPC_REQUEST_ID: "rpc.jsonrpc.request_id",
          RPC_JSONRPC_ERROR_CODE: "rpc.jsonrpc.error_code",
          RPC_JSONRPC_ERROR_MESSAGE: "rpc.jsonrpc.error_message",
          MESSAGE_TYPE: "message.type",
          MESSAGE_ID: "message.id",
          MESSAGE_COMPRESSED_SIZE: "message.compressed_size",
          MESSAGE_UNCOMPRESSED_SIZE: "message.uncompressed_size"
        };
        var DbSystemValues = {
          OTHER_SQL: "other_sql",
          MSSQL: "mssql",
          MYSQL: "mysql",
          ORACLE: "oracle",
          DB2: "db2",
          POSTGRESQL: "postgresql",
          REDSHIFT: "redshift",
          HIVE: "hive",
          CLOUDSCAPE: "cloudscape",
          HSQLDB: "hsqldb",
          PROGRESS: "progress",
          MAXDB: "maxdb",
          HANADB: "hanadb",
          INGRES: "ingres",
          FIRSTSQL: "firstsql",
          EDB: "edb",
          CACHE: "cache",
          ADABAS: "adabas",
          FIREBIRD: "firebird",
          DERBY: "derby",
          FILEMAKER: "filemaker",
          INFORMIX: "informix",
          INSTANTDB: "instantdb",
          INTERBASE: "interbase",
          MARIADB: "mariadb",
          NETEZZA: "netezza",
          PERVASIVE: "pervasive",
          POINTBASE: "pointbase",
          SQLITE: "sqlite",
          SYBASE: "sybase",
          TERADATA: "teradata",
          VERTICA: "vertica",
          H2: "h2",
          COLDFUSION: "coldfusion",
          CASSANDRA: "cassandra",
          HBASE: "hbase",
          MONGODB: "mongodb",
          REDIS: "redis",
          COUCHBASE: "couchbase",
          COUCHDB: "couchdb",
          COSMOSDB: "cosmosdb",
          DYNAMODB: "dynamodb",
          NEO4J: "neo4j",
          GEODE: "geode",
          ELASTICSEARCH: "elasticsearch",
          MEMCACHED: "memcached",
          COCKROACHDB: "cockroachdb"
        };
        var DbCassandraConsistencyLevelValues = {
          ALL: "all",
          EACH_QUORUM: "each_quorum",
          QUORUM: "quorum",
          LOCAL_QUORUM: "local_quorum",
          ONE: "one",
          TWO: "two",
          THREE: "three",
          LOCAL_ONE: "local_one",
          ANY: "any",
          SERIAL: "serial",
          LOCAL_SERIAL: "local_serial"
        };
        var FaasTriggerValues = {
          DATASOURCE: "datasource",
          HTTP: "http",
          PUBSUB: "pubsub",
          TIMER: "timer",
          OTHER: "other"
        };
        var FaasDocumentOperationValues = {
          INSERT: "insert",
          EDIT: "edit",
          DELETE: "delete"
        };
        var FaasInvokedProviderValues = {
          ALIBABA_CLOUD: "alibaba_cloud",
          AWS: "aws",
          AZURE: "azure",
          GCP: "gcp"
        };
        var NetTransportValues = {
          IP_TCP: "ip_tcp",
          IP_UDP: "ip_udp",
          IP: "ip",
          UNIX: "unix",
          PIPE: "pipe",
          INPROC: "inproc",
          OTHER: "other"
        };
        var NetHostConnectionTypeValues = {
          WIFI: "wifi",
          WIRED: "wired",
          CELL: "cell",
          UNAVAILABLE: "unavailable",
          UNKNOWN: "unknown"
        };
        var NetHostConnectionSubtypeValues = {
          GPRS: "gprs",
          EDGE: "edge",
          UMTS: "umts",
          CDMA: "cdma",
          EVDO_0: "evdo_0",
          EVDO_A: "evdo_a",
          CDMA2000_1XRTT: "cdma2000_1xrtt",
          HSDPA: "hsdpa",
          HSUPA: "hsupa",
          HSPA: "hspa",
          IDEN: "iden",
          EVDO_B: "evdo_b",
          LTE: "lte",
          EHRPD: "ehrpd",
          HSPAP: "hspap",
          GSM: "gsm",
          TD_SCDMA: "td_scdma",
          IWLAN: "iwlan",
          NR: "nr",
          NRNSA: "nrnsa",
          LTE_CA: "lte_ca"
        };
        var HttpFlavorValues = {
          HTTP_1_0: "1.0",
          HTTP_1_1: "1.1",
          HTTP_2_0: "2.0",
          SPDY: "SPDY",
          QUIC: "QUIC"
        };
        var MessagingDestinationKindValues = {
          QUEUE: "queue",
          TOPIC: "topic"
        };
        var MessagingOperationValues = {
          RECEIVE: "receive",
          PROCESS: "process"
        };
        var RpcGrpcStatusCodeValues = {
          OK: 0,
          CANCELLED: 1,
          UNKNOWN: 2,
          INVALID_ARGUMENT: 3,
          DEADLINE_EXCEEDED: 4,
          NOT_FOUND: 5,
          ALREADY_EXISTS: 6,
          PERMISSION_DENIED: 7,
          RESOURCE_EXHAUSTED: 8,
          FAILED_PRECONDITION: 9,
          ABORTED: 10,
          OUT_OF_RANGE: 11,
          UNIMPLEMENTED: 12,
          INTERNAL: 13,
          UNAVAILABLE: 14,
          DATA_LOSS: 15,
          UNAUTHENTICATED: 16
        };
        var MessageTypeValues = {
          SENT: "SENT",
          RECEIVED: "RECEIVED"
        };
        ;
        var ExceptionEventName = "exception";
        ;
        var __values = function (o) {
          var s = typeof Symbol === "function" && Symbol.iterator,
            m = s && o[s],
            i = 0;
          if (m) return m.call(o);
          if (o && typeof o.length === "number") return {
            next: function () {
              if (o && i >= o.length) o = void 0;
              return {
                value: o && o[i++],
                done: !o
              };
            }
          };
          throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
        };
        var __read = function (o, n) {
          var m = typeof Symbol === "function" && o[Symbol.iterator];
          if (!m) return o;
          var i = m.call(o),
            r,
            ar = [],
            e;
          try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
          } catch (error) {
            e = {
              error
            };
          } finally {
            try {
              if (r && !r.done && (m = i["return"])) m.call(i);
            } finally {
              if (e) throw e.error;
            }
          }
          return ar;
        };
        var Span = function () {
          function Span2(parentTracer, context, spanName, spanContext, kind, parentSpanId, links, startTime, clock) {
            if (links === void 0) {
              links = [];
            }
            if (clock === void 0) {
              clock = performance2.t;
            }
            this.attributes = {};
            this.links = [];
            this.events = [];
            this.status = {
              code: trace_status.Q.UNSET
            };
            this.endTime = [0, 0];
            this._ended = false;
            this._duration = [-1, -1];
            this._clock = clock;
            this.name = spanName;
            this._spanContext = spanContext;
            this.parentSpanId = parentSpanId;
            this.kind = kind;
            this.links = links;
            this.startTime = (0, time.aE)(startTime !== null && startTime !== void 0 ? startTime : clock.now());
            this.resource = parentTracer.resource;
            this.instrumentationLibrary = parentTracer.instrumentationLibrary;
            this._spanLimits = parentTracer.getSpanLimits();
            this._spanProcessor = parentTracer.getActiveSpanProcessor();
            this._spanProcessor.onStart(this, context);
            this._attributeValueLengthLimit = this._spanLimits.attributeValueLengthLimit || 0;
          }
          Span2.prototype.spanContext = function () {
            return this._spanContext;
          };
          Span2.prototype.setAttribute = function (key, value) {
            if (value == null || this._isSpanEnded()) return this;
            if (key.length === 0) {
              esm.diag.warn("Invalid attribute key: " + key);
              return this;
            }
            if (!(0, common_attributes.Do)(value)) {
              esm.diag.warn("Invalid attribute value set for key: " + key);
              return this;
            }
            if (Object.keys(this.attributes).length >= this._spanLimits.attributeCountLimit && !Object.prototype.hasOwnProperty.call(this.attributes, key)) {
              return this;
            }
            this.attributes[key] = this._truncateToSize(value);
            return this;
          };
          Span2.prototype.setAttributes = function (attributes) {
            var e_1, _a;
            try {
              for (var _b = __values(Object.entries(attributes)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2),
                  k = _d[0],
                  v = _d[1];
                this.setAttribute(k, v);
              }
            } catch (e_1_1) {
              e_1 = {
                error: e_1_1
              };
            } finally {
              try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
              } finally {
                if (e_1) throw e_1.error;
              }
            }
            return this;
          };
          Span2.prototype.addEvent = function (name, attributesOrStartTime, startTime) {
            if (this._isSpanEnded()) return this;
            if (this._spanLimits.eventCountLimit === 0) {
              esm.diag.warn("No events allowed.");
              return this;
            }
            if (this.events.length >= this._spanLimits.eventCountLimit) {
              esm.diag.warn("Dropping extra events.");
              this.events.shift();
            }
            if ((0, time.X_)(attributesOrStartTime)) {
              if (typeof startTime === "undefined") {
                startTime = attributesOrStartTime;
              }
              attributesOrStartTime = void 0;
            }
            if (typeof startTime === "undefined") {
              startTime = this._clock.now();
            }
            var attributes = (0, common_attributes.FT)(attributesOrStartTime);
            this.events.push({
              name,
              attributes,
              time: (0, time.aE)(startTime)
            });
            return this;
          };
          Span2.prototype.setStatus = function (status) {
            if (this._isSpanEnded()) return this;
            this.status = status;
            return this;
          };
          Span2.prototype.updateName = function (name) {
            if (this._isSpanEnded()) return this;
            this.name = name;
            return this;
          };
          Span2.prototype.end = function (endTime) {
            if (this._isSpanEnded()) {
              esm.diag.error("You can only call end() on a span once.");
              return;
            }
            this._ended = true;
            this.endTime = (0, time.aE)(endTime !== null && endTime !== void 0 ? endTime : this._clock.now());
            this._duration = (0, time.J3)(this.startTime, this.endTime);
            if (this._duration[0] < 0) {
              esm.diag.warn("Inconsistent start and end time, startTime > endTime", this.startTime, this.endTime);
            }
            this._spanProcessor.onEnd(this);
          };
          Span2.prototype.isRecording = function () {
            return this._ended === false;
          };
          Span2.prototype.recordException = function (exception, time2) {
            if (time2 === void 0) {
              time2 = this._clock.now();
            }
            var attributes = {};
            if (typeof exception === "string") {
              attributes[SemanticAttributes.EXCEPTION_MESSAGE] = exception;
            } else if (exception) {
              if (exception.code) {
                attributes[SemanticAttributes.EXCEPTION_TYPE] = exception.code.toString();
              } else if (exception.name) {
                attributes[SemanticAttributes.EXCEPTION_TYPE] = exception.name;
              }
              if (exception.message) {
                attributes[SemanticAttributes.EXCEPTION_MESSAGE] = exception.message;
              }
              if (exception.stack) {
                attributes[SemanticAttributes.EXCEPTION_STACKTRACE] = exception.stack;
              }
            }
            if (attributes[SemanticAttributes.EXCEPTION_TYPE] || attributes[SemanticAttributes.EXCEPTION_MESSAGE]) {
              this.addEvent(ExceptionEventName, attributes, time2);
            } else {
              esm.diag.warn("Failed to record an exception " + exception);
            }
          };
          Object.defineProperty(Span2.prototype, "duration", {
            get: function () {
              return this._duration;
            },
            enumerable: false,
            configurable: true
          });
          Object.defineProperty(Span2.prototype, "ended", {
            get: function () {
              return this._ended;
            },
            enumerable: false,
            configurable: true
          });
          Span2.prototype._isSpanEnded = function () {
            if (this._ended) {
              esm.diag.warn("Can not execute the operation on ended Span {traceId: " + this._spanContext.traceId + ", spanId: " + this._spanContext.spanId + "}");
            }
            return this._ended;
          };
          Span2.prototype._truncateToLimitUtil = function (value, limit) {
            if (value.length <= limit) {
              return value;
            }
            return value.substr(0, limit);
          };
          Span2.prototype._truncateToSize = function (value) {
            var _this = this;
            var limit = this._attributeValueLengthLimit;
            if (limit <= 0) {
              esm.diag.warn("Attribute value limit must be positive, got " + limit);
              return value;
            }
            if (typeof value === "string") {
              return this._truncateToLimitUtil(value, limit);
            }
            if (Array.isArray(value)) {
              return value.map(function (val) {
                return typeof val === "string" ? _this._truncateToLimitUtil(val, limit) : val;
              });
            }
            return value;
          };
          return Span2;
        }();
        var browser_environment = __webpack_require__2(580);
        var sampling = __webpack_require__2(290);
        ;
        var SamplingDecision;
        (function (SamplingDecision2) {
          SamplingDecision2[SamplingDecision2["NOT_RECORD"] = 0] = "NOT_RECORD";
          SamplingDecision2[SamplingDecision2["RECORD"] = 1] = "RECORD";
          SamplingDecision2[SamplingDecision2["RECORD_AND_SAMPLED"] = 2] = "RECORD_AND_SAMPLED";
        })(SamplingDecision || (SamplingDecision = {}));
        ;
        var AlwaysOffSampler = function () {
          function AlwaysOffSampler2() {}
          AlwaysOffSampler2.prototype.shouldSample = function () {
            return {
              decision: SamplingDecision.NOT_RECORD
            };
          };
          AlwaysOffSampler2.prototype.toString = function () {
            return "AlwaysOffSampler";
          };
          return AlwaysOffSampler2;
        }();
        ;
        var AlwaysOnSampler = function () {
          function AlwaysOnSampler2() {}
          AlwaysOnSampler2.prototype.shouldSample = function () {
            return {
              decision: SamplingDecision.RECORD_AND_SAMPLED
            };
          };
          AlwaysOnSampler2.prototype.toString = function () {
            return "AlwaysOnSampler";
          };
          return AlwaysOnSampler2;
        }();
        var spancontext_utils = __webpack_require__2(228);
        var global_error_handler = __webpack_require__2(220);
        ;
        var ParentBasedSampler = function () {
          function ParentBasedSampler2(config) {
            var _a, _b, _c, _d;
            this._root = config.root;
            if (!this._root) {
              (0, global_error_handler.L)(new Error("ParentBasedSampler must have a root sampler configured"));
              this._root = new AlwaysOnSampler();
            }
            this._remoteParentSampled = (_a = config.remoteParentSampled) !== null && _a !== void 0 ? _a : new AlwaysOnSampler();
            this._remoteParentNotSampled = (_b = config.remoteParentNotSampled) !== null && _b !== void 0 ? _b : new AlwaysOffSampler();
            this._localParentSampled = (_c = config.localParentSampled) !== null && _c !== void 0 ? _c : new AlwaysOnSampler();
            this._localParentNotSampled = (_d = config.localParentNotSampled) !== null && _d !== void 0 ? _d : new AlwaysOffSampler();
          }
          ParentBasedSampler2.prototype.shouldSample = function (context, traceId, spanName, spanKind, attributes, links) {
            var parentContext = esm.trace.getSpanContext(context);
            if (!parentContext || !(0, spancontext_utils.BM)(parentContext)) {
              return this._root.shouldSample(context, traceId, spanName, spanKind, attributes, links);
            }
            if (parentContext.isRemote) {
              if (parentContext.traceFlags & trace_flags.r.SAMPLED) {
                return this._remoteParentSampled.shouldSample(context, traceId, spanName, spanKind, attributes, links);
              }
              return this._remoteParentNotSampled.shouldSample(context, traceId, spanName, spanKind, attributes, links);
            }
            if (parentContext.traceFlags & trace_flags.r.SAMPLED) {
              return this._localParentSampled.shouldSample(context, traceId, spanName, spanKind, attributes, links);
            }
            return this._localParentNotSampled.shouldSample(context, traceId, spanName, spanKind, attributes, links);
          };
          ParentBasedSampler2.prototype.toString = function () {
            return "ParentBased{root=" + this._root.toString() + ", remoteParentSampled=" + this._remoteParentSampled.toString() + ", remoteParentNotSampled=" + this._remoteParentNotSampled.toString() + ", localParentSampled=" + this._localParentSampled.toString() + ", localParentNotSampled=" + this._localParentNotSampled.toString() + "}";
          };
          return ParentBasedSampler2;
        }();
        ;
        var TraceIdRatioBasedSampler = function () {
          function TraceIdRatioBasedSampler2(_ratio) {
            if (_ratio === void 0) {
              _ratio = 0;
            }
            this._ratio = _ratio;
            this._ratio = this._normalize(_ratio);
            this._upperBound = Math.floor(this._ratio * 4294967295);
          }
          TraceIdRatioBasedSampler2.prototype.shouldSample = function (context, traceId) {
            return {
              decision: (0, spancontext_utils.jN)(traceId) && this._accumulate(traceId) < this._upperBound ? SamplingDecision.RECORD_AND_SAMPLED : SamplingDecision.NOT_RECORD
            };
          };
          TraceIdRatioBasedSampler2.prototype.toString = function () {
            return "TraceIdRatioBased{" + this._ratio + "}";
          };
          TraceIdRatioBasedSampler2.prototype._normalize = function (ratio) {
            if (typeof ratio !== "number" || isNaN(ratio)) return 0;
            return ratio >= 1 ? 1 : ratio <= 0 ? 0 : ratio;
          };
          TraceIdRatioBasedSampler2.prototype._accumulate = function (traceId) {
            var accumulation = 0;
            for (var i = 0; i < traceId.length / 8; i++) {
              var pos = i * 8;
              var part = parseInt(traceId.slice(pos, pos + 8), 16);
              accumulation = (accumulation ^ part) >>> 0;
            }
            return accumulation;
          };
          return TraceIdRatioBasedSampler2;
        }();
        ;
        var env = (0, browser_environment.d)();
        var FALLBACK_OTEL_TRACES_SAMPLER = sampling.J.AlwaysOn;
        var DEFAULT_RATIO = 1;
        function loadDefaultConfig() {
          return {
            sampler: buildSamplerFromEnv(env),
            forceFlushTimeoutMillis: 3e4,
            generalLimits: {
              attributeValueLengthLimit: (0, browser_environment.d)().OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT,
              attributeCountLimit: (0, browser_environment.d)().OTEL_ATTRIBUTE_COUNT_LIMIT
            },
            spanLimits: {
              attributeValueLengthLimit: (0, browser_environment.d)().OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT,
              attributeCountLimit: (0, browser_environment.d)().OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT,
              linkCountLimit: (0, browser_environment.d)().OTEL_SPAN_LINK_COUNT_LIMIT,
              eventCountLimit: (0, browser_environment.d)().OTEL_SPAN_EVENT_COUNT_LIMIT
            }
          };
        }
        function buildSamplerFromEnv(environment2) {
          if (environment2 === void 0) {
            environment2 = (0, browser_environment.d)();
          }
          switch (environment2.OTEL_TRACES_SAMPLER) {
            case sampling.J.AlwaysOn:
              return new AlwaysOnSampler();
            case sampling.J.AlwaysOff:
              return new AlwaysOffSampler();
            case sampling.J.ParentBasedAlwaysOn:
              return new ParentBasedSampler({
                root: new AlwaysOnSampler()
              });
            case sampling.J.ParentBasedAlwaysOff:
              return new ParentBasedSampler({
                root: new AlwaysOffSampler()
              });
            case sampling.J.TraceIdRatio:
              return new TraceIdRatioBasedSampler(getSamplerProbabilityFromEnv(environment2));
            case sampling.J.ParentBasedTraceIdRatio:
              return new ParentBasedSampler({
                root: new TraceIdRatioBasedSampler(getSamplerProbabilityFromEnv(environment2))
              });
            default:
              esm.diag.error('OTEL_TRACES_SAMPLER value "' + environment2.OTEL_TRACES_SAMPLER + " invalid, defaulting to " + FALLBACK_OTEL_TRACES_SAMPLER + '".');
              return new AlwaysOnSampler();
          }
        }
        function getSamplerProbabilityFromEnv(environment2) {
          if (environment2.OTEL_TRACES_SAMPLER_ARG === void 0 || environment2.OTEL_TRACES_SAMPLER_ARG === "") {
            esm.diag.error("OTEL_TRACES_SAMPLER_ARG is blank, defaulting to " + DEFAULT_RATIO + ".");
            return DEFAULT_RATIO;
          }
          var probability = Number(environment2.OTEL_TRACES_SAMPLER_ARG);
          if (isNaN(probability)) {
            esm.diag.error("OTEL_TRACES_SAMPLER_ARG=" + environment2.OTEL_TRACES_SAMPLER_ARG + " was given, but it is invalid, defaulting to " + DEFAULT_RATIO + ".");
            return DEFAULT_RATIO;
          }
          if (probability < 0 || probability > 1) {
            esm.diag.error("OTEL_TRACES_SAMPLER_ARG=" + environment2.OTEL_TRACES_SAMPLER_ARG + " was given, but it is out of range ([0..1]), defaulting to " + DEFAULT_RATIO + ".");
            return DEFAULT_RATIO;
          }
          return probability;
        }
        var environment = __webpack_require__2(851);
        ;
        function mergeConfig(userConfig) {
          var perInstanceDefaults = {
            sampler: buildSamplerFromEnv()
          };
          var DEFAULT_CONFIG = loadDefaultConfig();
          var target = Object.assign({}, DEFAULT_CONFIG, perInstanceDefaults, userConfig);
          target.generalLimits = Object.assign({}, DEFAULT_CONFIG.generalLimits, userConfig.generalLimits || {});
          target.spanLimits = Object.assign({}, DEFAULT_CONFIG.spanLimits, userConfig.spanLimits || {});
          return target;
        }
        function reconfigureLimits(userConfig) {
          var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
          var spanLimits = Object.assign({}, userConfig.spanLimits);
          var parsedEnvConfig = (0, environment.vU)();
          spanLimits.attributeCountLimit = (_f = (_e = (_d = (_b = (_a = userConfig.spanLimits) === null || _a === void 0 ? void 0 : _a.attributeCountLimit) !== null && _b !== void 0 ? _b : (_c = userConfig.generalLimits) === null || _c === void 0 ? void 0 : _c.attributeCountLimit) !== null && _d !== void 0 ? _d : parsedEnvConfig.OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT) !== null && _e !== void 0 ? _e : parsedEnvConfig.OTEL_ATTRIBUTE_COUNT_LIMIT) !== null && _f !== void 0 ? _f : environment.qG;
          spanLimits.attributeValueLengthLimit = (_m = (_l = (_k = (_h = (_g = userConfig.spanLimits) === null || _g === void 0 ? void 0 : _g.attributeValueLengthLimit) !== null && _h !== void 0 ? _h : (_j = userConfig.generalLimits) === null || _j === void 0 ? void 0 : _j.attributeValueLengthLimit) !== null && _k !== void 0 ? _k : parsedEnvConfig.OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT) !== null && _l !== void 0 ? _l : parsedEnvConfig.OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT) !== null && _m !== void 0 ? _m : environment.KR;
          return Object.assign({}, userConfig, {
            spanLimits
          });
        }
        ;
        var SPAN_ID_BYTES = 8;
        var TRACE_ID_BYTES = 16;
        var RandomIdGenerator = function () {
          function RandomIdGenerator2() {
            this.generateTraceId = getIdGenerator(TRACE_ID_BYTES);
            this.generateSpanId = getIdGenerator(SPAN_ID_BYTES);
          }
          return RandomIdGenerator2;
        }();
        var SHARED_CHAR_CODES_ARRAY = Array(32);
        function getIdGenerator(bytes) {
          return function generateId() {
            for (var i = 0; i < bytes * 2; i++) {
              SHARED_CHAR_CODES_ARRAY[i] = Math.floor(Math.random() * 16) + 48;
              if (SHARED_CHAR_CODES_ARRAY[i] >= 58) {
                SHARED_CHAR_CODES_ARRAY[i] += 39;
              }
            }
            return String.fromCharCode.apply(null, SHARED_CHAR_CODES_ARRAY.slice(0, bytes * 2));
          };
        }
        ;
        var Tracer = function () {
          function Tracer2(instrumentationLibrary, config, _tracerProvider) {
            this._tracerProvider = _tracerProvider;
            var localConfig = mergeConfig(config);
            this._sampler = localConfig.sampler;
            this._generalLimits = localConfig.generalLimits;
            this._spanLimits = localConfig.spanLimits;
            this._idGenerator = config.idGenerator || new RandomIdGenerator();
            this.resource = _tracerProvider.resource;
            this.instrumentationLibrary = instrumentationLibrary;
          }
          Tracer2.prototype.startSpan = function (name, options, context) {
            var _a, _b;
            if (options === void 0) {
              options = {};
            }
            if (context === void 0) {
              context = esm.context.active();
            }
            if (options.root) {
              context = esm.trace.deleteSpan(context);
            }
            var parentSpan = esm.trace.getSpan(context);
            var clock;
            if (parentSpan) {
              clock = parentSpan["_clock"];
            }
            if (!clock) {
              clock = new anchored_clock.v(Date, performance2.t);
              if (parentSpan) {
                parentSpan["_clock"] = clock;
              }
            }
            if ((0, suppress_tracing.Ll)(context)) {
              esm.diag.debug("Instrumentation suppressed, returning Noop Span");
              var nonRecordingSpan = esm.trace.wrapSpanContext(invalid_span_constants.Rr);
              nonRecordingSpan["_clock"] = clock;
              return nonRecordingSpan;
            }
            var parentSpanContext = parentSpan === null || parentSpan === void 0 ? void 0 : parentSpan.spanContext();
            var spanId = this._idGenerator.generateSpanId();
            var traceId;
            var traceState;
            var parentSpanId;
            if (!parentSpanContext || !esm.trace.isSpanContextValid(parentSpanContext)) {
              traceId = this._idGenerator.generateTraceId();
            } else {
              traceId = parentSpanContext.traceId;
              traceState = parentSpanContext.traceState;
              parentSpanId = parentSpanContext.spanId;
            }
            var spanKind = (_a = options.kind) !== null && _a !== void 0 ? _a : span_kind.M.INTERNAL;
            var links = ((_b = options.links) !== null && _b !== void 0 ? _b : []).map(function (link) {
              return {
                context: link.context,
                attributes: (0, common_attributes.FT)(link.attributes)
              };
            });
            var attributes = (0, common_attributes.FT)(options.attributes);
            var samplingResult = this._sampler.shouldSample(context, traceId, name, spanKind, attributes, links);
            var traceFlags = samplingResult.decision === SamplingResult.U.RECORD_AND_SAMPLED ? trace_flags.r.SAMPLED : trace_flags.r.NONE;
            var spanContext = {
              traceId,
              spanId,
              traceFlags,
              traceState
            };
            if (samplingResult.decision === SamplingResult.U.NOT_RECORD) {
              esm.diag.debug("Recording is off, propagating context in a non-recording span");
              var nonRecordingSpan = esm.trace.wrapSpanContext(spanContext);
              nonRecordingSpan["_clock"] = clock;
              return nonRecordingSpan;
            }
            var span = new Span(this, context, name, spanContext, spanKind, parentSpanId, links, options.startTime, clock);
            var initAttributes = (0, common_attributes.FT)(Object.assign(attributes, samplingResult.attributes));
            span.setAttributes(initAttributes);
            return span;
          };
          Tracer2.prototype.startActiveSpan = function (name, arg2, arg3, arg4) {
            var opts;
            var ctx;
            var fn;
            if (arguments.length < 2) {
              return;
            } else if (arguments.length === 2) {
              fn = arg2;
            } else if (arguments.length === 3) {
              opts = arg2;
              fn = arg3;
            } else {
              opts = arg2;
              ctx = arg3;
              fn = arg4;
            }
            var parentContext = ctx !== null && ctx !== void 0 ? ctx : esm.context.active();
            var span = this.startSpan(name, opts, parentContext);
            var contextWithSpanSet = esm.trace.setSpan(parentContext, span);
            return esm.context["with"](contextWithSpanSet, fn, void 0, span);
          };
          Tracer2.prototype.getGeneralLimits = function () {
            return this._generalLimits;
          };
          Tracer2.prototype.getSpanLimits = function () {
            return this._spanLimits;
          };
          Tracer2.prototype.getActiveSpanProcessor = function () {
            return this._tracerProvider.getActiveSpanProcessor();
          };
          return Tracer2;
        }();
        var merge = __webpack_require__2(9);
        var composite = __webpack_require__2(135);
        var W3CTraceContextPropagator = __webpack_require__2(588);
        var W3CBaggagePropagator = __webpack_require__2(926);
        var Resource = __webpack_require__2(879);
        ;
        var MultiSpanProcessor_values = function (o) {
          var s = typeof Symbol === "function" && Symbol.iterator,
            m = s && o[s],
            i = 0;
          if (m) return m.call(o);
          if (o && typeof o.length === "number") return {
            next: function () {
              if (o && i >= o.length) o = void 0;
              return {
                value: o && o[i++],
                done: !o
              };
            }
          };
          throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
        };
        var MultiSpanProcessor = function () {
          function MultiSpanProcessor2(_spanProcessors) {
            this._spanProcessors = _spanProcessors;
          }
          MultiSpanProcessor2.prototype.forceFlush = function () {
            var e_1, _a;
            var promises = [];
            try {
              for (var _b = MultiSpanProcessor_values(this._spanProcessors), _c = _b.next(); !_c.done; _c = _b.next()) {
                var spanProcessor = _c.value;
                promises.push(spanProcessor.forceFlush());
              }
            } catch (e_1_1) {
              e_1 = {
                error: e_1_1
              };
            } finally {
              try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
              } finally {
                if (e_1) throw e_1.error;
              }
            }
            return new Promise(function (resolve) {
              Promise.all(promises).then(function () {
                resolve();
              }).catch(function (error) {
                (0, global_error_handler.L)(error || new Error("MultiSpanProcessor: forceFlush failed"));
                resolve();
              });
            });
          };
          MultiSpanProcessor2.prototype.onStart = function (span, context) {
            var e_2, _a;
            try {
              for (var _b = MultiSpanProcessor_values(this._spanProcessors), _c = _b.next(); !_c.done; _c = _b.next()) {
                var spanProcessor = _c.value;
                spanProcessor.onStart(span, context);
              }
            } catch (e_2_1) {
              e_2 = {
                error: e_2_1
              };
            } finally {
              try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
              } finally {
                if (e_2) throw e_2.error;
              }
            }
          };
          MultiSpanProcessor2.prototype.onEnd = function (span) {
            var e_3, _a;
            try {
              for (var _b = MultiSpanProcessor_values(this._spanProcessors), _c = _b.next(); !_c.done; _c = _b.next()) {
                var spanProcessor = _c.value;
                spanProcessor.onEnd(span);
              }
            } catch (e_3_1) {
              e_3 = {
                error: e_3_1
              };
            } finally {
              try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
              } finally {
                if (e_3) throw e_3.error;
              }
            }
          };
          MultiSpanProcessor2.prototype.shutdown = function () {
            var e_4, _a;
            var promises = [];
            try {
              for (var _b = MultiSpanProcessor_values(this._spanProcessors), _c = _b.next(); !_c.done; _c = _b.next()) {
                var spanProcessor = _c.value;
                promises.push(spanProcessor.shutdown());
              }
            } catch (e_4_1) {
              e_4 = {
                error: e_4_1
              };
            } finally {
              try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
              } finally {
                if (e_4) throw e_4.error;
              }
            }
            return new Promise(function (resolve, reject) {
              Promise.all(promises).then(function () {
                resolve();
              }, reject);
            });
          };
          return MultiSpanProcessor2;
        }();
        ;
        var NoopSpanProcessor = function () {
          function NoopSpanProcessor2() {}
          NoopSpanProcessor2.prototype.onStart = function (_span, _context) {};
          NoopSpanProcessor2.prototype.onEnd = function (_span) {};
          NoopSpanProcessor2.prototype.shutdown = function () {
            return Promise.resolve();
          };
          NoopSpanProcessor2.prototype.forceFlush = function () {
            return Promise.resolve();
          };
          return NoopSpanProcessor2;
        }();
        var callback = __webpack_require__2(399);
        var ExportResult = __webpack_require__2(420);
        var timer_util = __webpack_require__2(869);
        ;
        var BatchSpanProcessorBase = function () {
          function BatchSpanProcessorBase2(_exporter, config) {
            this._exporter = _exporter;
            this._finishedSpans = [];
            var env2 = (0, browser_environment.d)();
            this._maxExportBatchSize = typeof (config === null || config === void 0 ? void 0 : config.maxExportBatchSize) === "number" ? config.maxExportBatchSize : env2.OTEL_BSP_MAX_EXPORT_BATCH_SIZE;
            this._maxQueueSize = typeof (config === null || config === void 0 ? void 0 : config.maxQueueSize) === "number" ? config.maxQueueSize : env2.OTEL_BSP_MAX_QUEUE_SIZE;
            this._scheduledDelayMillis = typeof (config === null || config === void 0 ? void 0 : config.scheduledDelayMillis) === "number" ? config.scheduledDelayMillis : env2.OTEL_BSP_SCHEDULE_DELAY;
            this._exportTimeoutMillis = typeof (config === null || config === void 0 ? void 0 : config.exportTimeoutMillis) === "number" ? config.exportTimeoutMillis : env2.OTEL_BSP_EXPORT_TIMEOUT;
            this._shutdownOnce = new callback.q(this._shutdown, this);
          }
          BatchSpanProcessorBase2.prototype.forceFlush = function () {
            if (this._shutdownOnce.isCalled) {
              return this._shutdownOnce.promise;
            }
            return this._flushAll();
          };
          BatchSpanProcessorBase2.prototype.onStart = function (_span, _parentContext) {};
          BatchSpanProcessorBase2.prototype.onEnd = function (span) {
            if (this._shutdownOnce.isCalled) {
              return;
            }
            if ((span.spanContext().traceFlags & trace_flags.r.SAMPLED) === 0) {
              return;
            }
            this._addToBuffer(span);
          };
          BatchSpanProcessorBase2.prototype.shutdown = function () {
            return this._shutdownOnce.call();
          };
          BatchSpanProcessorBase2.prototype._shutdown = function () {
            var _this = this;
            return Promise.resolve().then(function () {
              return _this.onShutdown();
            }).then(function () {
              return _this._flushAll();
            }).then(function () {
              return _this._exporter.shutdown();
            });
          };
          BatchSpanProcessorBase2.prototype._addToBuffer = function (span) {
            if (this._finishedSpans.length >= this._maxQueueSize) {
              return;
            }
            this._finishedSpans.push(span);
            this._maybeStartTimer();
          };
          BatchSpanProcessorBase2.prototype._flushAll = function () {
            var _this = this;
            return new Promise(function (resolve, reject) {
              var promises = [];
              var count = Math.ceil(_this._finishedSpans.length / _this._maxExportBatchSize);
              for (var i = 0, j = count; i < j; i++) {
                promises.push(_this._flushOneBatch());
              }
              Promise.all(promises).then(function () {
                resolve();
              }).catch(reject);
            });
          };
          BatchSpanProcessorBase2.prototype._flushOneBatch = function () {
            var _this = this;
            this._clearTimer();
            if (this._finishedSpans.length === 0) {
              return Promise.resolve();
            }
            return new Promise(function (resolve, reject) {
              var timer = setTimeout(function () {
                reject(new Error("Timeout"));
              }, _this._exportTimeoutMillis);
              esm.context["with"]((0, suppress_tracing.hE)(esm.context.active()), function () {
                _this._exporter.export(_this._finishedSpans.splice(0, _this._maxExportBatchSize), function (result) {
                  var _a;
                  clearTimeout(timer);
                  if (result.code === ExportResult.I.SUCCESS) {
                    resolve();
                  } else {
                    reject((_a = result.error) !== null && _a !== void 0 ? _a : new Error("BatchSpanProcessor: span export failed"));
                  }
                });
              });
            });
          };
          BatchSpanProcessorBase2.prototype._maybeStartTimer = function () {
            var _this = this;
            if (this._timer !== void 0) return;
            this._timer = setTimeout(function () {
              _this._flushOneBatch().then(function () {
                if (_this._finishedSpans.length > 0) {
                  _this._clearTimer();
                  _this._maybeStartTimer();
                }
              }).catch(function (e) {
                (0, global_error_handler.L)(e);
              });
            }, this._scheduledDelayMillis);
            (0, timer_util.g)(this._timer);
          };
          BatchSpanProcessorBase2.prototype._clearTimer = function () {
            if (this._timer !== void 0) {
              clearTimeout(this._timer);
              this._timer = void 0;
            }
          };
          return BatchSpanProcessorBase2;
        }();
        ;
        var __extends = function () {
          var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (d2, b2) {
              d2.__proto__ = b2;
            } || function (d2, b2) {
              for (var p in b2) if (Object.prototype.hasOwnProperty.call(b2, p)) d2[p] = b2[p];
            };
            return extendStatics(d, b);
          };
          return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
              this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
          };
        }();
        var BatchSpanProcessor = function (_super) {
          __extends(BatchSpanProcessor2, _super);
          function BatchSpanProcessor2(_exporter, config) {
            var _this = _super.call(this, _exporter, config) || this;
            _this.onInit(config);
            return _this;
          }
          BatchSpanProcessor2.prototype.onInit = function (config) {
            var _this = this;
            if ((config === null || config === void 0 ? void 0 : config.disableAutoFlushOnDocumentHide) !== true && typeof document !== "undefined") {
              this._visibilityChangeListener = function () {
                if (document.visibilityState === "hidden") {
                  void _this.forceFlush();
                }
              };
              this._pageHideListener = function () {
                void _this.forceFlush();
              };
              document.addEventListener("visibilitychange", this._visibilityChangeListener);
              document.addEventListener("pagehide", this._pageHideListener);
            }
          };
          BatchSpanProcessor2.prototype.onShutdown = function () {
            if (typeof document !== "undefined") {
              if (this._visibilityChangeListener) {
                document.removeEventListener("visibilitychange", this._visibilityChangeListener);
              }
              if (this._pageHideListener) {
                document.removeEventListener("pagehide", this._pageHideListener);
              }
            }
          };
          return BatchSpanProcessor2;
        }(BatchSpanProcessorBase);
        ;
        var ForceFlushState;
        (function (ForceFlushState2) {
          ForceFlushState2[ForceFlushState2["resolved"] = 0] = "resolved";
          ForceFlushState2[ForceFlushState2["timeout"] = 1] = "timeout";
          ForceFlushState2[ForceFlushState2["error"] = 2] = "error";
          ForceFlushState2[ForceFlushState2["unresolved"] = 3] = "unresolved";
        })(ForceFlushState || (ForceFlushState = {}));
        var BasicTracerProvider = function () {
          function BasicTracerProvider2(config) {
            if (config === void 0) {
              config = {};
            }
            var _a;
            this._registeredSpanProcessors = [];
            this._tracers = new Map();
            var mergedConfig = (0, merge.T)({}, loadDefaultConfig(), reconfigureLimits(config));
            this.resource = (_a = mergedConfig.resource) !== null && _a !== void 0 ? _a : Resource._.empty();
            this.resource = Resource._["default"]().merge(this.resource);
            this._config = Object.assign({}, mergedConfig, {
              resource: this.resource
            });
            var defaultExporter = this._buildExporterFromEnv();
            if (defaultExporter !== void 0) {
              var batchProcessor = new BatchSpanProcessor(defaultExporter);
              this.activeSpanProcessor = batchProcessor;
            } else {
              this.activeSpanProcessor = new NoopSpanProcessor();
            }
          }
          BasicTracerProvider2.prototype.getTracer = function (name, version, options) {
            var key = name + "@" + (version || "") + ":" + ((options === null || options === void 0 ? void 0 : options.schemaUrl) || "");
            if (!this._tracers.has(key)) {
              this._tracers.set(key, new Tracer({
                name,
                version,
                schemaUrl: options === null || options === void 0 ? void 0 : options.schemaUrl
              }, this._config, this));
            }
            return this._tracers.get(key);
          };
          BasicTracerProvider2.prototype.addSpanProcessor = function (spanProcessor) {
            if (this._registeredSpanProcessors.length === 0) {
              this.activeSpanProcessor.shutdown().catch(function (err) {
                return esm.diag.error("Error while trying to shutdown current span processor", err);
              });
            }
            this._registeredSpanProcessors.push(spanProcessor);
            this.activeSpanProcessor = new MultiSpanProcessor(this._registeredSpanProcessors);
          };
          BasicTracerProvider2.prototype.getActiveSpanProcessor = function () {
            return this.activeSpanProcessor;
          };
          BasicTracerProvider2.prototype.register = function (config) {
            if (config === void 0) {
              config = {};
            }
            esm.trace.setGlobalTracerProvider(this);
            if (config.propagator === void 0) {
              config.propagator = this._buildPropagatorFromEnv();
            }
            if (config.contextManager) {
              esm.context.setGlobalContextManager(config.contextManager);
            }
            if (config.propagator) {
              esm.propagation.setGlobalPropagator(config.propagator);
            }
          };
          BasicTracerProvider2.prototype.forceFlush = function () {
            var timeout = this._config.forceFlushTimeoutMillis;
            var promises = this._registeredSpanProcessors.map(function (spanProcessor) {
              return new Promise(function (resolve) {
                var state;
                var timeoutInterval = setTimeout(function () {
                  resolve(new Error("Span processor did not completed within timeout period of " + timeout + " ms"));
                  state = ForceFlushState.timeout;
                }, timeout);
                spanProcessor.forceFlush().then(function () {
                  clearTimeout(timeoutInterval);
                  if (state !== ForceFlushState.timeout) {
                    state = ForceFlushState.resolved;
                    resolve(state);
                  }
                }).catch(function (error) {
                  clearTimeout(timeoutInterval);
                  state = ForceFlushState.error;
                  resolve(error);
                });
              });
            });
            return new Promise(function (resolve, reject) {
              Promise.all(promises).then(function (results) {
                var errors = results.filter(function (result) {
                  return result !== ForceFlushState.resolved;
                });
                if (errors.length > 0) {
                  reject(errors);
                } else {
                  resolve();
                }
              }).catch(function (error) {
                return reject([error]);
              });
            });
          };
          BasicTracerProvider2.prototype.shutdown = function () {
            return this.activeSpanProcessor.shutdown();
          };
          BasicTracerProvider2.prototype._getPropagator = function (name) {
            var _a;
            return (_a = this.constructor._registeredPropagators.get(name)) === null || _a === void 0 ? void 0 : _a();
          };
          BasicTracerProvider2.prototype._getSpanExporter = function (name) {
            var _a;
            return (_a = this.constructor._registeredExporters.get(name)) === null || _a === void 0 ? void 0 : _a();
          };
          BasicTracerProvider2.prototype._buildPropagatorFromEnv = function () {
            var _this = this;
            var uniquePropagatorNames = Array.from(new Set((0, browser_environment.d)().OTEL_PROPAGATORS));
            var propagators = uniquePropagatorNames.map(function (name) {
              var propagator = _this._getPropagator(name);
              if (!propagator) {
                esm.diag.warn('Propagator "' + name + '" requested through environment variable is unavailable.');
              }
              return propagator;
            });
            var validPropagators = propagators.reduce(function (list, item) {
              if (item) {
                list.push(item);
              }
              return list;
            }, []);
            if (validPropagators.length === 0) {
              return;
            } else if (uniquePropagatorNames.length === 1) {
              return validPropagators[0];
            } else {
              return new composite.Y({
                propagators: validPropagators
              });
            }
          };
          BasicTracerProvider2.prototype._buildExporterFromEnv = function () {
            var exporterName = (0, browser_environment.d)().OTEL_TRACES_EXPORTER;
            if (exporterName === "none") return;
            var exporter = this._getSpanExporter(exporterName);
            if (!exporter) {
              esm.diag.error('Exporter "' + exporterName + '" requested through environment variable is unavailable.');
            }
            return exporter;
          };
          BasicTracerProvider2._registeredPropagators = new Map([["tracecontext", function () {
            return new W3CTraceContextPropagator.jf();
          }], ["baggage", function () {
            return new W3CBaggagePropagator.a();
          }]]);
          BasicTracerProvider2._registeredExporters = new Map();
          return BasicTracerProvider2;
        }();
        ;
        ;
        var ConsoleSpanExporter_values = function (o) {
          var s = typeof Symbol === "function" && Symbol.iterator,
            m = s && o[s],
            i = 0;
          if (m) return m.call(o);
          if (o && typeof o.length === "number") return {
            next: function () {
              if (o && i >= o.length) o = void 0;
              return {
                value: o && o[i++],
                done: !o
              };
            }
          };
          throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
        };
        var ConsoleSpanExporter = function () {
          function ConsoleSpanExporter2() {}
          ConsoleSpanExporter2.prototype.export = function (spans, resultCallback) {
            return this._sendSpans(spans, resultCallback);
          };
          ConsoleSpanExporter2.prototype.shutdown = function () {
            this._sendSpans([]);
            return Promise.resolve();
          };
          ConsoleSpanExporter2.prototype._exportInfo = function (span) {
            return {
              traceId: span.spanContext().traceId,
              parentId: span.parentSpanId,
              name: span.name,
              id: span.spanContext().spanId,
              kind: span.kind,
              timestamp: (0, time.ji)(span.startTime),
              duration: (0, time.ji)(span.duration),
              attributes: span.attributes,
              status: span.status,
              events: span.events,
              links: span.links
            };
          };
          ConsoleSpanExporter2.prototype._sendSpans = function (spans, done) {
            var e_1, _a;
            try {
              for (var spans_1 = ConsoleSpanExporter_values(spans), spans_1_1 = spans_1.next(); !spans_1_1.done; spans_1_1 = spans_1.next()) {
                var span = spans_1_1.value;
                console.dir(this._exportInfo(span), {
                  depth: 3
                });
              }
            } catch (e_1_1) {
              e_1 = {
                error: e_1_1
              };
            } finally {
              try {
                if (spans_1_1 && !spans_1_1.done && (_a = spans_1.return)) _a.call(spans_1);
              } finally {
                if (e_1) throw e_1.error;
              }
            }
            if (done) {
              return done({
                code: ExportResult.I.SUCCESS
              });
            }
          };
          return ConsoleSpanExporter2;
        }();
        ;
        var InMemorySpanExporter_read = function (o, n) {
          var m = typeof Symbol === "function" && o[Symbol.iterator];
          if (!m) return o;
          var i = m.call(o),
            r,
            ar = [],
            e;
          try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
          } catch (error) {
            e = {
              error
            };
          } finally {
            try {
              if (r && !r.done && (m = i["return"])) m.call(i);
            } finally {
              if (e) throw e.error;
            }
          }
          return ar;
        };
        var __spreadArray = function (to, from, pack) {
          if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
            if (ar || !(i in from)) {
              if (!ar) ar = Array.prototype.slice.call(from, 0, i);
              ar[i] = from[i];
            }
          }
          return to.concat(ar || Array.prototype.slice.call(from));
        };
        var InMemorySpanExporter = function () {
          function InMemorySpanExporter2() {
            this._finishedSpans = [];
            this._stopped = false;
          }
          InMemorySpanExporter2.prototype.export = function (spans, resultCallback) {
            var _a;
            if (this._stopped) return resultCallback({
              code: ExportResult.I.FAILED,
              error: new Error("Exporter has been stopped")
            });
            (_a = this._finishedSpans).push.apply(_a, __spreadArray([], InMemorySpanExporter_read(spans), false));
            setTimeout(function () {
              return resultCallback({
                code: ExportResult.I.SUCCESS
              });
            }, 0);
          };
          InMemorySpanExporter2.prototype.shutdown = function () {
            this._stopped = true;
            this._finishedSpans = [];
            return Promise.resolve();
          };
          InMemorySpanExporter2.prototype.reset = function () {
            this._finishedSpans = [];
          };
          InMemorySpanExporter2.prototype.getFinishedSpans = function () {
            return this._finishedSpans;
          };
          return InMemorySpanExporter2;
        }();
        ;
        var SimpleSpanProcessor = function () {
          function SimpleSpanProcessor2(_exporter) {
            this._exporter = _exporter;
            this._shutdownOnce = new callback.q(this._shutdown, this);
          }
          SimpleSpanProcessor2.prototype.forceFlush = function () {
            return Promise.resolve();
          };
          SimpleSpanProcessor2.prototype.onStart = function (_span, _parentContext) {};
          SimpleSpanProcessor2.prototype.onEnd = function (span) {
            var _this = this;
            if (this._shutdownOnce.isCalled) {
              return;
            }
            if ((span.spanContext().traceFlags & trace_flags.r.SAMPLED) === 0) {
              return;
            }
            esm.context["with"]((0, suppress_tracing.hE)(esm.context.active()), function () {
              _this._exporter.export([span], function (result) {
                var _a;
                if (result.code !== ExportResult.I.SUCCESS) {
                  (0, global_error_handler.L)((_a = result.error) !== null && _a !== void 0 ? _a : new Error("SimpleSpanProcessor: span export failed (status " + result + ")"));
                }
              });
            });
          };
          SimpleSpanProcessor2.prototype.shutdown = function () {
            return this._shutdownOnce.call();
          };
          SimpleSpanProcessor2.prototype._shutdown = function () {
            return this._exporter.shutdown();
          };
          return SimpleSpanProcessor2;
        }();
        ;
      },
      364: (__unused_webpack_module, __webpack_exports__2, __webpack_require__2) => {
        __webpack_require__2.d(__webpack_exports__2, {
          "R9": () => SemanticResourceAttributes,
          "Te": () => TelemetrySdkLanguageValues
        });
        var SemanticResourceAttributes = {
          CLOUD_PROVIDER: "cloud.provider",
          CLOUD_ACCOUNT_ID: "cloud.account.id",
          CLOUD_REGION: "cloud.region",
          CLOUD_AVAILABILITY_ZONE: "cloud.availability_zone",
          CLOUD_PLATFORM: "cloud.platform",
          AWS_ECS_CONTAINER_ARN: "aws.ecs.container.arn",
          AWS_ECS_CLUSTER_ARN: "aws.ecs.cluster.arn",
          AWS_ECS_LAUNCHTYPE: "aws.ecs.launchtype",
          AWS_ECS_TASK_ARN: "aws.ecs.task.arn",
          AWS_ECS_TASK_FAMILY: "aws.ecs.task.family",
          AWS_ECS_TASK_REVISION: "aws.ecs.task.revision",
          AWS_EKS_CLUSTER_ARN: "aws.eks.cluster.arn",
          AWS_LOG_GROUP_NAMES: "aws.log.group.names",
          AWS_LOG_GROUP_ARNS: "aws.log.group.arns",
          AWS_LOG_STREAM_NAMES: "aws.log.stream.names",
          AWS_LOG_STREAM_ARNS: "aws.log.stream.arns",
          CONTAINER_NAME: "container.name",
          CONTAINER_ID: "container.id",
          CONTAINER_RUNTIME: "container.runtime",
          CONTAINER_IMAGE_NAME: "container.image.name",
          CONTAINER_IMAGE_TAG: "container.image.tag",
          DEPLOYMENT_ENVIRONMENT: "deployment.environment",
          DEVICE_ID: "device.id",
          DEVICE_MODEL_IDENTIFIER: "device.model.identifier",
          DEVICE_MODEL_NAME: "device.model.name",
          FAAS_NAME: "faas.name",
          FAAS_ID: "faas.id",
          FAAS_VERSION: "faas.version",
          FAAS_INSTANCE: "faas.instance",
          FAAS_MAX_MEMORY: "faas.max_memory",
          HOST_ID: "host.id",
          HOST_NAME: "host.name",
          HOST_TYPE: "host.type",
          HOST_ARCH: "host.arch",
          HOST_IMAGE_NAME: "host.image.name",
          HOST_IMAGE_ID: "host.image.id",
          HOST_IMAGE_VERSION: "host.image.version",
          K8S_CLUSTER_NAME: "k8s.cluster.name",
          K8S_NODE_NAME: "k8s.node.name",
          K8S_NODE_UID: "k8s.node.uid",
          K8S_NAMESPACE_NAME: "k8s.namespace.name",
          K8S_POD_UID: "k8s.pod.uid",
          K8S_POD_NAME: "k8s.pod.name",
          K8S_CONTAINER_NAME: "k8s.container.name",
          K8S_REPLICASET_UID: "k8s.replicaset.uid",
          K8S_REPLICASET_NAME: "k8s.replicaset.name",
          K8S_DEPLOYMENT_UID: "k8s.deployment.uid",
          K8S_DEPLOYMENT_NAME: "k8s.deployment.name",
          K8S_STATEFULSET_UID: "k8s.statefulset.uid",
          K8S_STATEFULSET_NAME: "k8s.statefulset.name",
          K8S_DAEMONSET_UID: "k8s.daemonset.uid",
          K8S_DAEMONSET_NAME: "k8s.daemonset.name",
          K8S_JOB_UID: "k8s.job.uid",
          K8S_JOB_NAME: "k8s.job.name",
          K8S_CRONJOB_UID: "k8s.cronjob.uid",
          K8S_CRONJOB_NAME: "k8s.cronjob.name",
          OS_TYPE: "os.type",
          OS_DESCRIPTION: "os.description",
          OS_NAME: "os.name",
          OS_VERSION: "os.version",
          PROCESS_PID: "process.pid",
          PROCESS_EXECUTABLE_NAME: "process.executable.name",
          PROCESS_EXECUTABLE_PATH: "process.executable.path",
          PROCESS_COMMAND: "process.command",
          PROCESS_COMMAND_LINE: "process.command_line",
          PROCESS_COMMAND_ARGS: "process.command_args",
          PROCESS_OWNER: "process.owner",
          PROCESS_RUNTIME_NAME: "process.runtime.name",
          PROCESS_RUNTIME_VERSION: "process.runtime.version",
          PROCESS_RUNTIME_DESCRIPTION: "process.runtime.description",
          SERVICE_NAME: "service.name",
          SERVICE_NAMESPACE: "service.namespace",
          SERVICE_INSTANCE_ID: "service.instance.id",
          SERVICE_VERSION: "service.version",
          TELEMETRY_SDK_NAME: "telemetry.sdk.name",
          TELEMETRY_SDK_LANGUAGE: "telemetry.sdk.language",
          TELEMETRY_SDK_VERSION: "telemetry.sdk.version",
          TELEMETRY_AUTO_VERSION: "telemetry.auto.version",
          WEBENGINE_NAME: "webengine.name",
          WEBENGINE_VERSION: "webengine.version",
          WEBENGINE_DESCRIPTION: "webengine.description"
        };
        var CloudProviderValues = {
          ALIBABA_CLOUD: "alibaba_cloud",
          AWS: "aws",
          AZURE: "azure",
          GCP: "gcp"
        };
        var CloudPlatformValues = {
          ALIBABA_CLOUD_ECS: "alibaba_cloud_ecs",
          ALIBABA_CLOUD_FC: "alibaba_cloud_fc",
          AWS_EC2: "aws_ec2",
          AWS_ECS: "aws_ecs",
          AWS_EKS: "aws_eks",
          AWS_LAMBDA: "aws_lambda",
          AWS_ELASTIC_BEANSTALK: "aws_elastic_beanstalk",
          AZURE_VM: "azure_vm",
          AZURE_CONTAINER_INSTANCES: "azure_container_instances",
          AZURE_AKS: "azure_aks",
          AZURE_FUNCTIONS: "azure_functions",
          AZURE_APP_SERVICE: "azure_app_service",
          GCP_COMPUTE_ENGINE: "gcp_compute_engine",
          GCP_CLOUD_RUN: "gcp_cloud_run",
          GCP_KUBERNETES_ENGINE: "gcp_kubernetes_engine",
          GCP_CLOUD_FUNCTIONS: "gcp_cloud_functions",
          GCP_APP_ENGINE: "gcp_app_engine"
        };
        var AwsEcsLaunchtypeValues = {
          EC2: "ec2",
          FARGATE: "fargate"
        };
        var HostArchValues = {
          AMD64: "amd64",
          ARM32: "arm32",
          ARM64: "arm64",
          IA64: "ia64",
          PPC32: "ppc32",
          PPC64: "ppc64",
          X86: "x86"
        };
        var OsTypeValues = {
          WINDOWS: "windows",
          LINUX: "linux",
          DARWIN: "darwin",
          FREEBSD: "freebsd",
          NETBSD: "netbsd",
          OPENBSD: "openbsd",
          DRAGONFLYBSD: "dragonflybsd",
          HPUX: "hpux",
          AIX: "aix",
          SOLARIS: "solaris",
          Z_OS: "z_os"
        };
        var TelemetrySdkLanguageValues = {
          CPP: "cpp",
          DOTNET: "dotnet",
          ERLANG: "erlang",
          GO: "go",
          JAVA: "java",
          NODEJS: "nodejs",
          PHP: "php",
          PYTHON: "python",
          RUBY: "ruby",
          WEBJS: "webjs"
        };
      },
      445: (__unused_webpack_module, exports2, __webpack_require__2) => {
        Object.defineProperty(exports2, "__esModule", {
          value: true
        });
        exports2.contextFromSpan = exports2.currentContext = exports2.getTracer = exports2.inject = exports2.extract = void 0;
        const api_1 = __webpack_require__2(620);
        const core_1 = __webpack_require__2(455);
        const libraryName = "svs-telemetry";
        const libraryVersion = "0.0.0";
        const propagator = new core_1.W3CTraceContextPropagator();
        exports2.extract = carrier => {
          const context_ = propagator.extract(api_1.context.active(), carrier, api_1.defaultTextMapGetter);
          return context_;
        };
        exports2.inject = (carrier, span) => {
          const context_ = api_1.trace.setSpan(api_1.context.active(), span);
          propagator.inject(context_, carrier, api_1.defaultTextMapSetter);
          return carrier;
        };
        exports2.getTracer = () => api_1.trace.getTracerProvider().getTracer(libraryName, libraryVersion);
        exports2.currentContext = () => api_1.context.active();
        exports2.contextFromSpan = span => api_1.trace.setSpanContext(api_1.ROOT_CONTEXT, span.spanContext());
      }
    };
    var __webpack_module_cache__ = {};
    function __webpack_require__(moduleId) {
      var cachedModule = __webpack_module_cache__[moduleId];
      if (cachedModule !== void 0) {
        return cachedModule.exports;
      }
      var module2 = __webpack_module_cache__[moduleId] = {
        exports: {}
      };
      __webpack_modules__[moduleId](module2, module2.exports, __webpack_require__);
      return module2.exports;
    }
    (() => {
      __webpack_require__.d = (exports2, definition) => {
        for (var key in definition) {
          if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports2, key)) {
            Object.defineProperty(exports2, key, {
              enumerable: true,
              get: definition[key]
            });
          }
        }
      };
    })();
    (() => {
      __webpack_require__.g = function () {
        if (typeof globalThis === "object") return globalThis;
        try {
          return this || new Function("return this")();
        } catch (e) {
          if (typeof window === "object") return window;
        }
      }();
    })();
    (() => {
      __webpack_require__.o = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop);
    })();
    (() => {
      __webpack_require__.r = exports2 => {
        if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
          Object.defineProperty(exports2, Symbol.toStringTag, {
            value: "Module"
          });
        }
        Object.defineProperty(exports2, "__esModule", {
          value: true
        });
      };
    })();
    var __webpack_exports__ = {};
    (() => {
      var exports2 = __webpack_exports__;
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.api = exports2.WebTelemetry = void 0;
      const sdk_trace_base_1 = __webpack_require__(354);
      const api_1 = __webpack_require__(620);
      const exporter_trace_otlp_http_1 = __webpack_require__(545);
      const core_1 = __webpack_require__(455);
      const resources_1 = __webpack_require__(183);
      const utils_1 = __webpack_require__(445);
      class WebTelemetry {
        constructor() {
          this.init = function () {
            let serviceName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "unknown";
            let serviceVersion = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "0.0.0";
            let environment = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "dev";
            let endpoint = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "http://localhost:4318";
            let bufferConfig = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
              maxExportBatchSize: 512,
              scheduledDelayMillis: 5e3,
              exportTimeoutMillis: 3e4,
              maxQueueSize: 2048
            };
            let noop = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
            if (!noop) {
              const resources = new resources_1.Resource({
                "deplyment.environment": environment,
                "service.name": serviceName,
                "service.version": serviceVersion
              });
              const propagator = new core_1.W3CTraceContextPropagator();
              const provider = new sdk_trace_base_1.BasicTracerProvider({
                sampler: new sdk_trace_base_1.AlwaysOnSampler(),
                resource: resources
              });
              const ep = endpoint.endsWith("v1/traces") ? endpoint : "".concat(endpoint, "/v1/traces");
              const exporter = new exporter_trace_otlp_http_1.OTLPTraceExporter({
                url: ep,
                httpAgentOptions: {
                  keepAlive: true,
                  timeout: 1e3
                }
              });
              const processor = new sdk_trace_base_1.BatchSpanProcessor(exporter, bufferConfig);
              provider.addSpanProcessor(processor);
              provider.register({
                propagator
              });
            }
          };
        }
        static getInstance() {
          if (!this._instance) {
            this._instance = new WebTelemetry();
          }
          return this._instance;
        }
      }
      exports2.WebTelemetry = WebTelemetry;
      exports2.api = {
        inject: utils_1.inject,
        extract: utils_1.extract,
        getTracer: utils_1.getTracer,
        SpanKind: api_1.SpanKind,
        currentContext: utils_1.currentContext,
        contextFromSpan: utils_1.contextFromSpan
      };
    })();
    return __webpack_exports__;
  })();
});
 })(window);